import React, { useEffect, useState, useRef, useImperativeHandle, useMemo, forwardRef, useCallback } from 'react';

import hash from 'hash-sum';
import stringify from '../utils/stableStringify';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { unpack, pack } from 'msgpackr';
import format from 'string-format';
import AntTime from '../utils/AntTime';
import { useGridSettingsScope } from './AntGridScope';
import { resolveColumnFilterSpec, buildColumnFilterConditions } from '../utils/AntGridColumnFilter';
import { prepareColumnFilterEditor } from '../utils/AntGridColumnFilterEditor';
import { attachHeaderBoundaryDblClick } from '../utils/AntGridHeaderDblClick';
import {
    buildGridSettingsKey,
    registerGridSettingsKey,
    readGridSettings,
    updateGridSettings,
    mergeColumnSettings,
    getSavedColumnWidths,
    getSavedColumnVisibility,
    applyColumnOrder,
    gridStateToSettings,
    settingsToGridState,
    migrateLegacyGridSettings
} from '../utils/AntGridSettings';
import calculator from '../utils/calculator';
// import $ from 'jquery';
import DataGrid, { Column, Paging } from 'devextreme-react/data-grid';
import Scheduler from 'devextreme-react/scheduler';

import { TextBox, CheckBox, SelectBox, TextArea, NumberBox } from 'devextreme-react';
import { Button } from 'devextreme-react/button';
import { Tooltip } from 'devextreme-react/tooltip';

import { Template } from 'devextreme-react/core/template';
import AntLocalization from '../utils/AntLocalization';
import AntLocalStorage from '../utils/AntLocalStorage';
import AntGridRowActions from './AntGridRowActions';
import AntGridBar from './AntGridBar';
import AntGridLink from './AntGridLink';
import AntGridCategories from './AntGridCategories';
import AntGridCellEditor from './AntGridCellEditor';
import notify from 'devextreme/ui/notify';
import {
    INLINE_DRAFT_ID,
    isInlineDraftRow,
    mapInlineFormItems,
    synthesizeInlineFormItems,
    getConfiguredEditable,
    isMultilineFormItem,
    getMissingRequiredFields,
    applyInlineFormulas,
    buildInlineCreatePayload,
    buildInlineDraftBase,
    buildInlineCellIssues,
    inlineMessageText,
    getResultErrorField,
    INLINE_TEXTS
} from '../utils/AntGridInlineEdit';
import AntGridCategoryLayout from '../utils/AntGridCategoryLayout';
import { isValidDateFilter } from '../utils/AntGridDateFilterValue';
import AntQueryStore from './AntQueryStore';
import AntSimpleDataSource from './AntSimpleDataSource';
import AntConfig from '../utils/AntConfig';
import AntCondition from '../utils/AntCondition';
import AntAuth from '../utils/AntAuth';
import AntString from '../utils/AntString';
import AntArray from '../utils/AntArray';
import AntCategory from '../utils/AntCategory';
import AntBatchActionPopup from './AntBatchActionPopup';
import AntDeletePopup from './AntDeletePopup';
import AntObjectEditPopup from './AntObjectEditPopup';
import AntObjectCreationPopup from './AntObjectCreationPopup';
import AntImport from './AntImport';
import AntSearchForm from './AntSearchForm';
import AntScheduler from './AntScheduler';
import AntCardViewTile from './AntCardViewTile';
import AntPOSCardViewList from '../pos/AntPOSCardViewList';
import AntCardViewList from './AntCardViewList';
import AntGridSummary from './AntGridSummary';

import { AntGlobal, AntSession } from '../utils/AntContext';
import AntJSON from '../utils/AntJSON';
import { buildSmartGridLayout, detectFinancialGrid, getLookupBestFitWidth, localizeLookupValues } from '../utils/AntGridLayout';
import {
    canDiscoverBatchActions,
    getBatchActionIcon,
    getContextualBatchActions,
    getSelectionActionPermissions,
    isBatchSafeRowAction,
    resolveGridSelection,
    isBatchOnlyRowActions
} from '../utils/AntGridBatchActions';
import { getSelectedRowsPage } from '../utils/AntGridSelectedRows';
import { resetGridHeaderHeights, observeAdaptiveHiddenHeaders } from '../utils/AntGridHeaderLayout';
import { keepSortedColumnsShown } from '../utils/AntGridLayout';
import { createGridWidthCache, createGridTextMeasurer, calculateGridBestFit, calculateGridFlexibleWidths, getGridViewportWidth, applyGridBestFit, getCommittedGridWidths, invalidateGridBestFit, scheduleGridBestFit, fitSortedHeaderWidths, setGridBestFitFrozen, toResizeMinWidth, refitGridBestFit, holdGridLayoutUntilReveal, hasAdaptiveHiddenColumns, GRID_RESIZE_FLOOR } from '../utils/AntGridBestFit';

const ROW_ACTION_MENU_WIDTH = 40;

const getRowActionsDisplay = (value) => (['menu', 'smart', 'batch'].includes(value) ? value : 'inline');

const DEFAULT_ROW_ACTION_LABELS = {
    actionDelete: { vi: 'Xóa', en: 'Delete', fr: 'Supprimer', es: 'Eliminar', id: 'Hapus', ja: '削除', zh: '删除', ko: '삭제', hi: 'हटाएं', ar: 'حذف' },
    actionCancel: { vi: 'Hủy', en: 'Cancel', fr: 'Annuler', es: 'Cancelar', id: 'Batalkan', ja: 'キャンセル', zh: '取消', ko: '취소', hi: 'रद्द करें', ar: 'إلغاء' },
    actionReject: { vi: 'Từ chối', en: 'Reject', fr: 'Rejeter', es: 'Rechazar', id: 'Tolak', ja: '却下', zh: '拒绝', ko: '거부', hi: 'अस्वीकार करें', ar: 'رفض' },
    actionPost: { vi: 'Hạch toán', en: 'Post', fr: 'Comptabiliser', es: 'Contabilizar', id: 'Posting', ja: '計上', zh: '过账', ko: '전기', hi: 'पोस्ट करें', ar: 'ترحيل' },
    actionApprove: { vi: 'Phê duyệt', en: 'Approve', fr: 'Approuver', es: 'Aprobar', id: 'Setujui', ja: '承認', zh: '批准', ko: '승인', hi: 'स्वीकृत करें', ar: 'موافقة' },
    actionClose: { vi: 'Đóng', en: 'Close', fr: 'Clôturer', es: 'Cerrar', id: 'Tutup', ja: '終了', zh: '关闭', ko: '닫기', hi: 'बंद करें', ar: 'إغلاق' },
    actionRelease: { vi: 'Phát hành', en: 'Release', fr: 'Valider', es: 'Liberar', id: 'Rilis', ja: 'リリース', zh: '发布', ko: '발행', hi: 'जारी करें', ar: 'إصدار' },
    actionSaleActivate: { vi: 'Bán hàng', en: 'Activate sale', fr: 'Activer vente', es: 'Activar venta', id: 'Aktifkan jual', ja: '販売を有効化', zh: '启用销售', ko: '판매 활성화', hi: 'बिक्री चालू', ar: 'تفعيل البيع' },
    actionSaleDeactivate: { vi: 'Dừng bán', en: 'Deactivate sale', fr: 'Arrêter la vente', es: 'Detener venta', id: 'Hentikan jual', ja: '販売を停止', zh: '停用销售', ko: '판매 중지', hi: 'बिक्री बंद', ar: 'إيقاف البيع' },
    actionUpdateActive: { vi: 'Kích hoạt', en: 'Activate', fr: 'Réactiver', es: 'Reactivar', ja: '再有効化', zh: '重新激活', ko: '재활성화', id: 'Aktifkan', hi: 'सक्रिय करें', ar: 'تفعيل' },
    actionUpdateInactive: { vi: 'Vô hiệu', en: 'Deactivate', fr: 'Désactiver', es: 'Desactivar', id: 'Nonaktifkan', ja: '無効化', zh: '停用', ko: '비활성화', hi: 'निष्क्रिय', ar: 'تعطيل' },
    actionUpdateSaleActive: { vi: 'Bán hàng', en: 'Activate sale', fr: 'Activer vente', es: 'Activar venta', id: 'Aktifkan jual', ja: '販売を有効化', zh: '启用销售', ko: '판매 활성화', hi: 'बिक्री चालू', ar: 'تفعيل البيع' },
    actionUpdateSaleInactive: { vi: 'Ngừng bán', en: 'Deactivate sale', fr: 'Arrêter la vente', es: 'Detener venta', id: 'Hentikan jual', ja: '販売を停止', zh: '停用销售', ko: '판매 중지', hi: 'बिक्री बंद', ar: 'إيقاف البيع' },
    actionUpdateCookingActive: { vi: 'Chế biến', en: 'Require cooking', fr: 'Avec préparation', es: 'Con preparación', id: 'Perlu dimasak', ja: '調理あり', zh: '需要制作', ko: '조리 필요', hi: 'पकाना ज़रूरी', ar: 'يتطلب تحضيرًا' },
    actionUpdateCookingInactive: { vi: 'Không chế biến', en: 'No cooking required', fr: 'Sans préparation', es: 'Sin preparación', id: 'Tanpa dimasak', ja: '調理なし', zh: '无需制作', ko: '조리 불필요', hi: 'पकाना ज़रूरी नहीं', ar: 'بدون تحضير' },
    actionUpdateCookingTicketActive: { vi: 'Bật in phiếu bếp', en: 'Enable kitchen ticket', fr: 'Activer ticket cuisine', es: 'Activar ticket de cocina', id: 'Aktifkan tiket dapur', ja: '厨房伝票印刷オン', zh: '开启厨房单打印', ko: '주방 전표 인쇄 켜기', hi: 'किचन टिकट चालू करें', ar: 'تفعيل تذكرة المطبخ' },
    actionUpdateCookingTicketInactive: { vi: 'Tắt in phiếu bếp', en: 'Disable kitchen ticket', fr: 'Désactiver ticket cuisine', es: 'Desactivar ticket cocina', id: 'Nonaktifkan tiket dapur', ja: '厨房伝票印刷オフ', zh: '关闭厨房单打印', ko: '주방 전표 인쇄 끄기', hi: 'किचन टिकट बंद करें', ar: 'تعطيل تذكرة المطبخ' },
    actionUpdateServiceTicketActive: { vi: 'Bật in phiếu dịch vụ', en: 'Enable service ticket', fr: 'Activer ticket service', es: 'Activar ticket servicio', id: 'Aktifkan tiket layanan', ja: 'サービス伝票印刷オン', zh: '开启服务单打印', ko: '서비스 전표 인쇄 켜기', hi: 'सेवा टिकट चालू करें', ar: 'تفعيل تذكرة الخدمة' },
    actionUpdateServiceTicketInactive: { vi: 'Tắt in phiếu dịch vụ', en: 'Disable service ticket', fr: 'Désactiver ticket service', es: 'Desactivar ticket servicio', id: 'Nonaktifkan tiket layanan', ja: 'サービス伝票印刷オフ', zh: '关闭服务单打印', ko: '서비스 전표 인쇄 끄기', hi: 'सेवा टिकट बंद करें', ar: 'تعطيل تذكرة الخدمة' }
};

const getRowActionFallbackLabel = (code) =>
    DEFAULT_ROW_ACTION_LABELS[code] || code?.replace(/^action/, '').replace(/([a-z])([A-Z])/g, '$1 $2') || 'Action';

// Cột hệ thống vẫn cho kéo đổi độ rộng (và lưu): cột số thứ tự — số lớn bị cắt nếu cột hẹp.
const isResizableSystemColumn = (col) => Boolean(col) && col.dataField === 'rowIndex';

// Field văn bản dài hiển thị xuống dòng mặc định: *_name, *_desc, description, note (kể cả *_description, *_note).
const WRAP_FIELD_PATTERN = /(^|_)(desc|description|note)$|_name$/;

// Trước khi độ rộng người dùng kéo thay chỗ: giữ chế độ tự đo / co giãn / độ rộng cấu hình (một lần).
const backupAutoWidth = (col) => {
    if (!col || col._antAutoBackup) return;
    col._antAutoBackup = { bestFit: col._antBestFit, flexible: Boolean(col._antFlexibleWidth), width: col.width };
};

// Cột chữ hoặc cột auto (co giãn lấp chỗ trống).
const isTextOrAutoColumn = (col) =>
    Boolean(col) && (Boolean(col._antFlexibleWidth) || col.width === 'auto' || !col.dataType || col.dataType === 'string');

// Cột người dùng được kéo thả đổi thứ tự: cột dữ liệu (không phải STT, chọn, thao tác...).
const isUserMovableColumn = (col) => Boolean(col) && Boolean(col.dataField) && !col.isSystemCol;

export default forwardRef(function (props, ref) {
    const appGlobal = AntGlobal();
    // const session = AntSession();
    const location = useLocation();
    const navigate = useNavigate();

    if (props.API && !props.API.entityDisplay) {
        if (appGlobal && appGlobal.appConfig && appGlobal.appConfig.Services) {
            let found = appGlobal.appConfig.Services.find((s) => s.name === props.API.entityName);
            if (found) props.API.init({ entityDisplay: found.display });
        }
    }

    const tableName = useMemo(() => (props.table ? props.table : props.API ? props.API.entityName : ''), []);

    const config = useMemo(() => {
        let found = appGlobal.tableConfigs?.find((t) => t.tableName === tableName);
        if (found) return found.config;

        let cnf = new AntConfig(appGlobal, tableName);
        cnf.configFields(props.fields);

        if (appGlobal.tableConfigs instanceof Array === false) appGlobal.tableConfigs = [];

        appGlobal.tableConfigs.push({
            tableName: tableName,
            config: cnf
        });
        return cnf;
    }, []);

    const compName = useMemo(
        () =>
            props.storageKey
                ? props.storageKey
                : props.name
                ? props.name
                : props.API && props.API.entityName
                ? props.API.entityName
                : props.entityName
                ? props.entityName
                : props.url
                ? props.url
                : undefined,
        []
    );

    const [shouldRender, setShouldRender] = useState(1);

    const forceRender = useCallback(() => {
        setShouldRender((v) => v + 1);
    }, []);

    const isRender = useMemo(() => shouldRender + (props.shouldRender ? props.shouldRender : 1), [props.shouldRender, shouldRender]);

    const locationPath = useMemo(() => location.pathname + '-' + compName, [location]);

    // ---- Cấu hình người dùng của lưới: 1 object JSON chung (AntGridSettings) ----
    // Route pattern (vd /exp/EXPOrders) chỉ dùng khi không có khung chứa khai báo phạm vi (xem AntGridScope).
    // Khoá = phạm vi (khung chứa gần nhất khai báo qua AntGridScope; không có thì màn theo route pattern)
    //       + tab (AntVoucherTabs) + lưới (settingsKey, không có thì tên bảng).
    // Hai lưới cùng bảng trong cùng phạm vi phải truyền settingsKey (bản dev cảnh báo khi trùng).
    const { scope: gridSettingsScope, route: routePattern } = useGridSettingsScope();
    const gridSettingsName = useMemo(
        () => String(props.settingsKey || tableName || compName || '').replace(/[#/]/g, '.'),
        [props.settingsKey, tableName, compName]
    );
    const gridSettingsKey = useMemo(
        () =>
            buildGridSettingsKey(
                gridSettingsScope,
                props.tabName ? 'tab:' + String(props.tabName).replace(/[#/]/g, '.') : null,
                gridSettingsName ? 'grid:' + gridSettingsName : null
            ),
        [gridSettingsScope, props.tabName, gridSettingsName]
    );
    const gridSettingsMeta = useMemo(
        () => ({ scope: gridSettingsScope, route: routePattern, grid: gridSettingsName, table: tableName || undefined }),
        [gridSettingsScope, routePattern, gridSettingsName, tableName]
    );
    useEffect(() => registerGridSettingsKey(gridSettingsKey), [gridSettingsKey]);
    // Lưới con theo 1 phiếu (FKField): không nhớ ô tìm/bộ lọc sang phiếu khác; chỉ nhớ cột, sắp xếp, kiểu xem.
    const persistGridFilters = !props.FKField;
    // Chuyển dữ liệu từ các khoá cũ (lưu rời, khoá băm) — một lần cho mỗi lưới.
    useMemo(() => {
        if (props.byPassCachingStates) return;
        const legacyRouteBase = String((location && location.pathname) || '')
            .split('/')
            .filter(Boolean)
            .slice(0, 2)
            .join('/');
        migrateLegacyGridSettings(gridSettingsKey, gridSettingsMeta, {
            statesHash: hash(String(locationPath)),
            widthsHash: hash([legacyRouteBase, props.parentTable || '', tableName || '', props.tabName || props.storageKey || ''].join('|')),
            persistFilters: persistGridFilters
        });
    }, [gridSettingsKey]);
    // Lựa chọn ẩn hiện cột của người dùng: { field: false } tắt cột; { field: true } bật cột ẩn mặc định
    // (defaultVisible: false). Kiểm tra thông minh (tự ẩn cột trống, màn hẹp) và điều kiện nghiệp vụ vẫn áp dụng.
    const userColumnVisibility = useRef(null);
    if (userColumnVisibility.current === null) {
        // Chỉ lựa chọn ẩn (false) có hiệu lực; tick hiện = trả về tự động (bản lưu cũ có true thì bỏ qua).
        // false = người dùng tắt; true = người dùng bật cột ẩn mặc định (defaultVisible: false) — với cột thường
        // true không có tác dụng (vẫn qua tự ẩn cột trống / điều kiện nghiệp vụ).
        userColumnVisibility.current = { ...getSavedColumnVisibility(readGridSettings(gridSettingsKey)) };
    }
    // Thứ tự cột người dùng kéo thả trong bảng ẩn hiện cột: [field...] (null = theo cấu hình).
    const userColumnOrder = useRef(undefined);
    if (userColumnOrder.current === undefined) {
        const savedOrder = readGridSettings(gridSettingsKey).columnOrder;
        userColumnOrder.current = savedOrder instanceof Array && savedOrder.length ? savedOrder : null;
    }
    const widthCacheSession = AntAuth.getSessionInfo() || {};
    const widthCacheScope = hash(stringify([
        compName, tableName, props.parentTable, tableName ? null : locationPath,
        widthCacheSession.business_code, widthCacheSession.user_code,
        widthCacheSession.store_code, AntLocalStorage.getBusinessSetting('Sys_BaseLanguage')
    ]));
    const gridWidthCache = useMemo(() => createGridWidthCache(widthCacheScope), [widthCacheScope]);

    const CategoryData = useMemo(() => new AntCategory(appGlobal.appAssets.data.categoryData), []);

    const [formSearchConditions, setFormSearchConditions] = useState({ ...props.searchConditions });

    const loading = useRef(false);
    const loaded = useRef(false);

    const markSelectedField = useRef();
    const grid = useRef();
    const gridContainer = useRef();
    const gridResizeTimer = useRef();
    const gridHeaderTimer = useRef();
    const lastGridContainerWidth = useRef();
    // Lưới ở tab đang đóng: ghi nợ lượt nạp lại, mở tab mới nạp.
    const pendingParentReload = useRef(false);
    const actionBar = useRef();
    const selectedRowsRef = useRef([]);
    const scheduler = useRef();
    const cardview = useRef();
    const afterActionRefreshTimeout = useRef();
    const autoRefreshTimer = useRef();
    const deletePopup = useRef();
    const batchActionPopup = useRef();
    const editPopup = useRef();
    const addPopup = useRef();
    const importPopup = useRef();

    const isAllowNew = useMemo(() => (props.allowNew !== undefined ? props.allowNew : false), []);

    const isRemotePaging = useMemo(() => (props.remotePaging !== undefined ? props.remotePaging : isAllowNew ? false : true), [isAllowNew]);

    const defaultPageSize = useMemo(
        () => (props.defaultPageSize ? props.defaultPageSize : props.allowedPageSizes ? props.allowedPageSizes[0] : 7),
        []
    );

    const dataSource = useRef(new AntQueryStore({}));
    const schedulerDataSource = useRef(new AntQueryStore({}));
    const cardViewDataSource = useRef(new AntSimpleDataSource({ paginate: true, pageSize: defaultPageSize }));

    const getCachingStates = useCallback(() => {
        var defaultObj = { searchText: '', sortByColumn: null, sortType: null, filterBySelected: false, filteredGroup: null };

        if (gridSettingsKey && !props.byPassCachingStates) {
            const saved = settingsToGridState(readGridSettings(gridSettingsKey));
            defaultObj = { ...defaultObj, ...saved };
        }

        return defaultObj;
    }, [gridSettingsKey, props.byPassCachingStates]);

    const defaultStates = useMemo(() => getCachingStates(), []);

    const [itemsCats1, setItemsCats1] = useState([]);
    const [itemsCats2, setItemsCats2] = useState([]);
    const [itemsCats3, setItemsCats3] = useState([]);
    const [itemsCats4, setItemsCats4] = useState([]);
    const [itemsCats5, setItemsCats5] = useState([]);
    const [itemsCats6, setItemsCats6] = useState([]);
    const [itemsCats7, setItemsCats7] = useState([]);
    const [itemsCats8, setItemsCats8] = useState([]);
    const [itemsCats9, setItemsCats9] = useState([]);
    const [itemsCats10, setItemsCats10] = useState([]);

    // const itemsCats1 = useRef([]);
    // const itemsCats2 = useRef([]);
    // const itemsCats3 = useRef([]);
    // const itemsCats4 = useRef([]);
    // const itemsCats5 = useRef([]);
    // const itemsCats6 = useRef([]);
    // const itemsCats7 = useRef([]);
    // const itemsCats8 = useRef([]);
    // const itemsCats9 = useRef([]);
    // const itemsCats10 = useRef([]);

    const [itemsCats1Loaded, setItemsCats1Loaded] = useState(false);
    const [itemsCats2Loaded, setItemsCats2Loaded] = useState(false);
    const [itemsCats3Loaded, setItemsCats3Loaded] = useState(false);
    const [itemsCats4Loaded, setItemsCats4Loaded] = useState(false);
    const [itemsCats5Loaded, setItemsCats5Loaded] = useState(false);
    const [itemsCats6Loaded, setItemsCats6Loaded] = useState(false);
    const [itemsCats7Loaded, setItemsCats7Loaded] = useState(false);
    const [itemsCats8Loaded, setItemsCats8Loaded] = useState(false);
    const [itemsCats9Loaded, setItemsCats9Loaded] = useState(false);
    const [itemsCats10Loaded, setItemsCats10Loaded] = useState(false);

    // const itemsCats1Loaded = useRef(false);
    // const itemsCats2Loaded = useRef(false);
    // const itemsCats3Loaded = useRef(false);
    // const itemsCats4Loaded = useRef(false);
    // const itemsCats5Loaded = useRef(false);
    // const itemsCats6Loaded = useRef(false);
    // const itemsCats7Loaded = useRef(false);
    // const itemsCats8Loaded = useRef(false);
    // const itemsCats9Loaded = useRef(false);
    // const itemsCats10Loaded = useRef(false);

    const [selectedCats1, setSelectedCats1] = useState(defaultStates && defaultStates.selectedCats1 !== undefined ? defaultStates.selectedCats1 : []);
    const [selectedCats2, setSelectedCats2] = useState(defaultStates && defaultStates.selectedCats2 !== undefined ? defaultStates.selectedCats2 : []);
    const [selectedCats3, setSelectedCats3] = useState(defaultStates && defaultStates.selectedCats3 !== undefined ? defaultStates.selectedCats3 : []);
    const [selectedCats4, setSelectedCats4] = useState(defaultStates && defaultStates.selectedCats4 !== undefined ? defaultStates.selectedCats4 : []);
    const [selectedCats5, setSelectedCats5] = useState(defaultStates && defaultStates.selectedCats5 !== undefined ? defaultStates.selectedCats5 : []);
    const [selectedCats6, setSelectedCats6] = useState(defaultStates && defaultStates.selectedCats6 !== undefined ? defaultStates.selectedCats6 : []);
    const [selectedCats7, setSelectedCats7] = useState(defaultStates && defaultStates.selectedCats7 !== undefined ? defaultStates.selectedCats7 : []);
    const [selectedCats8, setSelectedCats8] = useState(defaultStates && defaultStates.selectedCats8 !== undefined ? defaultStates.selectedCats8 : []);
    const [selectedCats9, setSelectedCats9] = useState(defaultStates && defaultStates.selectedCats9 !== undefined ? defaultStates.selectedCats9 : []);
    const [selectedCats10, setSelectedCats10] = useState(
        defaultStates && defaultStates.selectedCats10 !== undefined ? defaultStates.selectedCats10 : []
    );

    const [filteredGroup, setFilteredGroup] = useState(defaultStates.filteredGroup ? JSON.parse(defaultStates.filteredGroup) : null);

    // const selectedCats1 = useRef(defaultStates && defaultStates.selectedCats1 !== undefined ? defaultStates.selectedCats1 : []);
    // const selectedCats2 = useRef(defaultStates && defaultStates.selectedCats2 !== undefined ? defaultStates.selectedCats2 : []);
    // const selectedCats3 = useRef(defaultStates && defaultStates.selectedCats3 !== undefined ? defaultStates.selectedCats3 : []);
    // const selectedCats4 = useRef(defaultStates && defaultStates.selectedCats4 !== undefined ? defaultStates.selectedCats4 : []);
    // const selectedCats5 = useRef(defaultStates && defaultStates.selectedCats5 !== undefined ? defaultStates.selectedCats5 : []);
    // const selectedCats6 = useRef(defaultStates && defaultStates.selectedCats6 !== undefined ? defaultStates.selectedCats6 : []);
    // const selectedCats7 = useRef(defaultStates && defaultStates.selectedCats7 !== undefined ? defaultStates.selectedCats7 : []);
    // const selectedCats8 = useRef(defaultStates && defaultStates.selectedCats8 !== undefined ? defaultStates.selectedCats8 : []);
    // const selectedCats9 = useRef(defaultStates && defaultStates.selectedCats9 !== undefined ? defaultStates.selectedCats9 : []);
    // const selectedCats10 = useRef(defaultStates && defaultStates.selectedCats10 !== undefined ? defaultStates.selectedCats10 : []);

    // Lựa chọn searchCategories mới nhất, cập nhật đồng bộ khi người dùng bấm (state cập nhật trễ 1 nhịp render).
    const latestCatSelections = useRef({});

    // Phân bổ số giá trị hiện của các nhóm searchCategories theo độ rộng khung (không qua state AntGrid).
    const categoryLayout = useRef(null);
    if (!categoryLayout.current) categoryLayout.current = new AntGridCategoryLayout();
    useEffect(() => {
        categoryLayout.current.resume();
        return () => categoryLayout.current.suspend();
    }, []);
    const attachCategoryLayout = useCallback((element) => {
        if (categoryLayout.current) categoryLayout.current.attach(element);
    }, []);

    // Bộ lọc theo ngày trên thanh công cụ: { startDate, endDate } Unix, gửi dạng
    // <field>_startDate / <field>_endDate như AntSearchForm (BE sqlSearchAdvance đọc).
    const dateFilterRef = useRef(isValidDateFilter(defaultStates.dateFilter) ? defaultStates.dateFilter : null);

    // Bộ lọc ngay trên cột (dòng lọc dưới tiêu đề — filterRow của DevExtreme, editor + điều kiện do AntGrid dựng,
    // xem AntGridColumnFilter). Bật cho lưới lấy dữ liệu qua API chuẩn; showColumnFilter để bật/tắt hẳn.
    const columnFilterEnabled =
        props.showColumnFilter !== undefined
            ? Boolean(props.showColumnFilter)
            : Boolean(props.API) && !props.loadFunc && props.showActionBar !== false && props.showColumnHeaders !== false;
    // { dataField: giá trị editor } và trạng thái hiện dòng lọc — ref (không state) để AntGrid không render lại.
    const columnFilterValues = useRef(
        defaultStates.columnFilters && typeof defaultStates.columnFilters === 'object' ? { ...defaultStates.columnFilters } : {}
    );
    const filterRowVisible = useRef(columnFilterEnabled && Boolean(defaultStates.showFilterRow));
    const columnFilterTimer = useRef(null);
    const appliedColumnFilterKey = useRef(null);
    // Đang hiện dòng lọc: chốt bố cục cột (ẩn hiện cột trống + độ rộng theo dữ liệu) như lúc bật — kết quả lọc về
    // không làm cột nhảy, ô đang gõ không bị xê dịch.
    const columnLayoutFrozen = useRef(false);
    // Ô lọc đang gõ: nếu DevExtreme vẽ lại dòng lọc (ô cũ bị huỷ) thì ô mới của cùng cột lấy lại focus.
    const activeFilterEditor = useRef({ field: null, blurAt: 0 });
    const freezeLayoutPending = useRef(false);
    // Tự áp dụng cho created_at khi lưới dùng API list chuẩn (url/loadFunc riêng có thể không
    // đọc điều kiện này), không phải lưới con theo phiếu cha và không phải lưới nhập liệu.
    // dateFilterField chỉ định cột khác; showDateFilter={false} để tắt. Cột không có trong cấu
    // hình bảng hoặc không phải kiểu ngày thì ẩn tính năng.
    const dateFilterField = useMemo(() => {
        if (props.showDateFilter === false || !props.API || props.showActionBar === false) return null;
        const field = props.dateFilterField
            ? props.dateFilterField
            : !props.url && !props.loadFunc && !props.FKField && !isAllowNew
            ? 'created_at'
            : null;
        if (!field) return null;
        const cnfField = config && config.cnfFields instanceof Array ? config.cnfFields.find((f) => f.dataField === field) : null;
        if (!cnfField) return null;
        const isDateType = ['date', 'datetime', 'timestamp'].includes(cnfField.dataType);
        // Cột chỉ định rõ: cấu hình FE đôi khi thiếu dataType (BE vẫn là date) → chấp nhận nếu
        // không khai báo kiểu; khai báo kiểu khác ngày thì ẩn. Tự động (created_at) bắt buộc kiểu ngày.
        if (props.dateFilterField) return isDateType || !cnfField.dataType ? field : null;
        return isDateType ? field : null;
    }, [props.showDateFilter, props.API, props.showActionBar, props.dateFilterField, props.url, props.loadFunc, props.FKField, isAllowNew, config]);

    const saveCachingStates = useCallback(() => {
        if (props.byPassCachingStates) return;

        if (gridSettingsKey) {
            let obj = {
                filterBySelected: Boolean(filterBySelected.current),
                sortByColumn: sortByColumn.current ? String(sortByColumn.current) : null,
                sortType: sortType.current ? String(sortType.current) : null,
                searchText: searchText.current !== null && searchText.current !== undefined ? String(searchText.current) : '',
                filteredGroup: filteredGroup ? stringify(filteredGroup) : null,
                selectedCats1: selectedCats1,
                selectedCats2: selectedCats2,
                selectedCats3: selectedCats3,
                selectedCats4: selectedCats4,
                selectedCats5: selectedCats5,
                selectedCats6: selectedCats6,
                selectedCats7: selectedCats7,
                selectedCats8: selectedCats8,
                selectedCats9: selectedCats9,
                selectedCats10: selectedCats10,
                showSearchForm: showSearchForm.current,
                showScheduler: showScheduler.current,
                showCardView: showCardView.current,
                schedulerCurrentView: schedulerCurrentView.current,
                schedulerCurrentDate: schedulerCurrentDate.current,
                dateFilter: dateFilterRef.current,
                columnFilters: columnFilterValues.current,
                showFilterRow: filterRowVisible.current
            };
            if (!obj.dateFilter) delete obj.dateFilter;
            if (obj.searchText === '' || obj.searchText === 'undefined') delete obj.searchText;
            if (!obj.sortByColumn) delete obj.sortByColumn;
            if (!obj.sortType) delete obj.sortType;
            if (!obj.filteredGroup) delete obj.filteredGroup;

            const sections = gridStateToSettings(obj, { persistFilters: persistGridFilters });
            updateGridSettings(gridSettingsKey, (entry) => ({ ...entry, ...sections }), gridSettingsMeta);
        }
    }, [
        filteredGroup,
        gridSettingsKey,
        gridSettingsMeta,
        persistGridFilters,
        props.byPassCachingStates,
        selectedCats1,
        selectedCats2,
        selectedCats3,
        selectedCats4,
        selectedCats5,
        selectedCats6,
        selectedCats7,
        selectedCats8,
        selectedCats9,
        selectedCats10
    ]);

    const showSearchForm = useRef(defaultStates && defaultStates.showSearchForm !== undefined ? defaultStates.showSearchForm : false);
    const showScheduler = useRef(
        props.scheduler && defaultStates && defaultStates.showScheduler !== undefined && AntCondition.isVisible({}, props.scheduler)
            ? defaultStates.showScheduler
            : Boolean(props.scheduler && props.defaultView === 'Scheduler')
    );
    const showCardView = useRef(
        props.cardview?.allowViewSwitch === false
            ? true
            : props.cardview && defaultStates && defaultStates.showCardView !== undefined && AntCondition.isVisible({}, props.cardview)
            ? defaultStates.showCardView
            : Boolean(props.cardview && props.defaultView === 'CardView')
    );

    const schedulerCurrentView = useRef(
        props.scheduler && defaultStates && defaultStates.schedulerCurrentView !== undefined && AntCondition.isVisible({}, props.scheduler)
            ? defaultStates.schedulerCurrentView
            : props.scheduler
            ? props.scheduler.defaultCurrentView
            : undefined
    );

    const schedulerCurrentDate = useRef(
        props.scheduler && defaultStates && defaultStates.schedulerCurrentDate !== undefined && AntCondition.isVisible({}, props.scheduler)
            ? defaultStates.schedulerCurrentDate
            : props.scheduler
            ? props.scheduler.defaultCurrentDate
            : undefined
    );

    const hasColMarkSelected = props.columns.some((col) => typeof col === 'object' && col.isMarkSelected);

    const showRefresh = Boolean(props.showRefresh) && !isAllowNew;

    const showDelete = props.showActionBar !== false && (props.showDelete !== undefined ? props.showDelete : false);

    const showEdit = props.showActionBar !== false && (props.showEdit !== undefined ? props.showEdit : Boolean(props.edit));
    const showAdd = props.showActionBar !== false && (props.showAdd !== undefined ? props.showAdd : Boolean(props.add));

    // ---- Nhập trực tiếp trên lưới (prop inlineEdit, mặc định tắt) ----
    // addForm của lưới quyết định field nào sửa được, editor gì, bắt buộc gì. Dòng nháp luôn ở cuối
    // bảng; đủ field bắt buộc thì tự tạo. Trạng thái giữ trong ref (không state) để AntGrid không
    // render lại — render lại truyền object `selection` mới làm DevExtreme mất dòng đang chọn.
    const inlineEdit = props.inlineEdit === true;
    const configuredInlineItems = useMemo(
        () => (props.add && props.add.items instanceof Array ? props.add.items : props.edit && props.edit.items instanceof Array ? props.edit.items : []),
        [props.add, props.edit]
    );
    const hasInlineForm = configuredInlineItems.length > 0;
    // Không cấu hình addForm/editForm: metadata field từ BE (create/prepare withInlineFields).
    // null = đang lấy; [] = không lấy được → suy đoán theo config/fields của FE.
    const [inlineMeta, setInlineMeta] = useState(null);
    const inlineFormItems = useMemo(() => {
        if (hasInlineForm) return configuredInlineItems;
        if (!inlineEdit || inlineMeta === null) return [];
        return synthesizeInlineFormItems(props.columns, inlineMeta, config && config.cnfFields);
    }, [hasInlineForm, configuredInlineItems, inlineEdit, inlineMeta, props.columns, config]);
    const inlineFieldMap = useMemo(() => (inlineEdit ? mapInlineFormItems(props.columns, inlineFormItems) : new Map()), [inlineEdit, props.columns, inlineFormItems]);
    // Dòng mới theo quyền thêm của phiếu (inlineAddable), không bắt buộc phải có addForm.
    const canInlineAdd =
        inlineEdit && (props.inlineAddable !== undefined ? Boolean(props.inlineAddable) : showAdd) && inlineFieldMap.size > 0;
    const canInlineEditRows = inlineEdit && props.allowEdit !== false && inlineFieldMap.size > 0;
    const inlineActive = canInlineAdd || canInlineEditRows;
    const inlineFieldMapRef = useRef(inlineFieldMap);
    inlineFieldMapRef.current = inlineFieldMap;
    const inlinePrepared = useRef(null);
    const inlineDraftValues = useRef({});
    const inlineDraftError = useRef(null);
    const inlineRowErrors = useRef(new Map());
    // Hàm gắn lỗi/cảnh báo vào ô (định nghĩa sau, dùng trong onCellPrepared khai báo trước).
    const inlineCellIssueRef = useRef(null);
    const inlineLookups = useRef([]);
    const inlineQueue = useRef(Promise.resolve());
    const inlineCopyFields = useMemo(
        () => [
            ...(props.copyFromHeaderFields ? props.copyFromHeaderFields : []),
            ...(props.copyFromParentFields ? props.copyFromParentFields : []),
            ...(props.add && props.add.copyFromHeaderFields ? props.add.copyFromHeaderFields : []),
            ...(props.add && props.add.copyFromParentFields ? props.add.copyFromParentFields : []),
            ...(props.FKField ? [{ field: props.parentIDField ? props.parentIDField : 'code', alias: props.FKField }] : [])
        ],
        [props.copyFromHeaderFields, props.copyFromParentFields, props.add, props.FKField, props.parentIDField]
    );

    // Kéo đổi độ rộng cột + ghi nhớ (localStorage) cho MỌI AntGrid (tắt bằng allowColumnResizing={false}).
    // Khoá theo ngữ cảnh: module/màn (2 đoạn đầu URL, bỏ mã chứng từ), bảng cha, bảng, tab — mở phiếu khác
    // cùng loại vẫn dùng lại độ rộng người dùng đã chỉnh. Cột "auto" (co giãn lấp chỗ trống) không ghi nhớ.
    const allowColumnResizing = props.allowColumnResizing !== false;
    // Độ rộng người dùng kéo: columns[field].width trong cấu hình lưới (AntGridSettings).
    const readSavedColWidths = useCallback(() => getSavedColumnWidths(readGridSettings(gridSettingsKey)), [gridSettingsKey]);
    const writeSavedColWidths = useCallback(
        (patch) => {
            const columnsPatch = {};
            Object.keys(patch || {}).forEach((field) => {
                columnsPatch[field] = { width: patch[field] };
            });
            updateGridSettings(gridSettingsKey, (entry) => ({ ...entry, columns: mergeColumnSettings(entry.columns, columnsPatch) }), gridSettingsMeta);
        },
        [gridSettingsKey, gridSettingsMeta]
    );
    const canEditAction = props.canEditAction !== undefined ? Boolean(props.canEditAction) : showEdit;
    const canDeleteAction = props.canDeleteAction !== undefined ? Boolean(props.canDeleteAction) : showDelete;
    const legacySelectable =
        props.crudSelectable !== undefined
            ? Boolean(props.crudSelectable)
            : props.selectable !== undefined
            ? Boolean(props.selectable)
            : Boolean(showEdit || showDelete);
    const showImport = useMemo(
        () => props.showActionBar !== false && (props.showImport !== undefined ? AntCondition.isValid(props.parentData, props.showImport) : false),
        []
    );

    const sortByColumn = useRef(defaultStates.sortByColumn);
    const sortType = useRef(defaultStates.sortType);

    // const rawColumns = useMemo(() => (props.columns instanceof Array ? JSON.parse(stringify(props.columns)) : []), []);

    const searchParentConditions = useMemo(() => {
        return props.FKField && props.parentData && typeof props.parentData === 'object'
            ? {
                  [props.FKField]: props.parentData[props.parentIDField ? props.parentIDField : 'code']
              }
            : {};
    }, [props.FKField, props.parentData, props.parentIDField]);

    const searchConditions = useMemo(() => {
        return {};
    }, []);

    // Chỉ AntGridSummary (summaryHeader) cần điều kiện dạng state. So sánh qua ref, KHÔNG để generateSearchConditions
    // phụ thuộc state này: đổi điều kiện (lọc trên cột, ô tìm...) sẽ tạo lại chuỗi hàm forceReload → reload →
    // onRowAction → template renderButtonsCell → DevExtreme vẽ lại toàn bộ lưới (dòng lọc mất focus).
    const [finalSearchConditions, setFinalSearchConditions] = useState({});
    const finalSearchConditionsRef = useRef({});

    const searchText = useRef(defaultStates.searchText);
    const searchBarcode = useRef('');
    const filterBySelected = useRef(defaultStates.filterBySelected);
    // Checkbox "Đã chọn" chỉ hiện khi lưới đang có dòng được chọn. Trạng thái hiện/ẩn nằm trong
    // AntGridBar (resetItems) — KHÔNG dùng state ở đây: AntGrid render lại sẽ truyền object
    // `selection` mới cho DataGrid và DevExtreme xoá luôn các dòng đang chọn.
    const hasSelectedRowsRef = useRef(false);
    const refreshRef = useRef();

    const [focusedRow, setFocusedRow] = useState({ row: null });
    const [selectedAll, setSelectedAll] = useState(false);
    const [searchBarFocused, setSearchBarFocused] = useState(false);
    // const lockUpdatedEvent = useRef(false);

    const selectedCategories = [
        selectedCats1,
        selectedCats2,
        selectedCats3,
        selectedCats4,
        selectedCats5,
        selectedCats6,
        selectedCats7,
        selectedCats8,
        selectedCats9,
        selectedCats10
    ]
        .flat()
        .map((s) => s.value)
        .flat();

    const totalCats =
        itemsCats1.length +
        itemsCats2.length +
        itemsCats3.length +
        itemsCats4.length +
        itemsCats5.length +
        itemsCats6.length +
        itemsCats7.length +
        itemsCats8.length +
        itemsCats9.length +
        itemsCats10.length;

    const initGridRowActions = useCallback(() => {
        var actions = [];

        if (props) {
            if (props.showRowActions) {
                let acts = config.getCnfSearchActions(
                    props.rowActionPack ? props.rowActionPack : props.table ? props.table : props.API ? props.API.entityName : null
                );
                actions.push(...acts);
            }

            if (props.rowActions instanceof Array)
                props.rowActions.forEach((item) => {
                    actions.push(item);
                });

            const excludedActionCodes = props.excludesRowActions instanceof Array ? props.excludesRowActions : [];
            actions = actions.filter((item) => {
                const actionCode = item?.code || item?.name || item?.actionName;
                return AntCondition.isVisible(null, item) && !excludedActionCodes.includes(actionCode);
            });
        }

        return actions;
    }, [props.showRowActions, props.rowActionPack, props.table, props.API, props.rowActions, props.excludesRowActions]);

    const gridRowActions = useMemo(
        () => initGridRowActions(),
        [props.showRowActions, props.rowActions, props.rowActionPack, props.excludesRowActions]
    );
    const rowActionsDisplay = getRowActionsDisplay(props.rowActionsDisplay);
    const rowActionPrimaryActions = useMemo(
        () => (props.rowActionPrimaryActions instanceof Array ? props.rowActionPrimaryActions : []),
        [props.rowActionPrimaryActions]
    );
    const gridBatchActions = useMemo(
        () => {
            const configuredActions = props.batchActions instanceof Array ? props.batchActions : [];
            const configuredCodes = configuredActions
                .map((action) => (typeof action === 'string' ? action : action?.code || action?.actionName))
                .filter(Boolean);
            const canDiscoverActions = canDiscoverBatchActions({
                autoBatchActions: props.autoBatchActions,
                legacySelectable,
                isSearching: props.isSearching
            });
            const sourceActions = configuredActions.length > 0 ? configuredActions : canDiscoverActions ? gridRowActions : [];
            const hasCustomFrontendHandler = Boolean(props.onRowAction || props.rowActionCustomData);

            return sourceActions
                .map((rawAction) => {
                    const action = typeof rawAction === 'string' ? { code: rawAction } : rawAction;
                    if (!action) return null;
                    const code = action.code || action.actionName || (typeof action.name === 'string' ? action.name : undefined);
                    if (!code) return null;

                    const rowAction = gridRowActions.find((item) => item.code === code) || {};
                    const explicitlyConfigured = configuredCodes.includes(code) || action.batchable === true || Boolean(action.batchActionName);
                    if (
                        !isBatchSafeRowAction(
                            { ...rowAction, ...action, code },
                            { explicitlyConfigured, hasCustomFrontendHandler, allowDelete: showDelete !== true }
                        )
                    )
                        return null;

                    const text =
                        action.text ||
                        action.label ||
                        (typeof action.name === 'object' || action.name instanceof Array ? action.name : undefined) ||
                        rowAction.name ||
                        getRowActionFallbackLabel(code);

                    return {
                        ...rowAction,
                        ...action,
                        code,
                        name: code,
                        text,
                        icon: getBatchActionIcon({ ...rowAction, ...action, code }),
                        requireRowAction: true,
                        // Some independent list APIs intentionally omit the
                        // row-actions payload. An explicitly declared batch
                        // action remains available in that case; prepare on
                        // the backend remains the authoritative eligibility check.
                        allowMissingRowActions: explicitlyConfigured,
                        eligibility: 'all',
                        maxSelection:
                            action.maxSelection !== undefined
                                ? action.maxSelection
                                : action.batchMaxRows !== undefined
                                ? action.batchMaxRows
                                : 500
                    };
                })
                .filter((action) => action && AntCondition.isVisible(props.parentData || null, action));
        },
        [
            gridRowActions,
            props.batchActions,
            props.autoBatchActions,
            props.parentData,
            props.onRowAction,
            props.rowActionCustomData,
            props.isSearching,
            legacySelectable
        ]
    );
    const hasBatchActionCandidates = gridBatchActions.length > 0;
    const selectable = resolveGridSelection({
        selectable: props.selectable,
        legacySelectable,
        showEdit,
        showDelete,
        hasBatchActionCandidates
    });
    const focusable = props.allowEdit !== true && !inlineActive && (selectable || (props.focusable !== undefined ? props.focusable : true));

    const beginUpdate = useCallback(() => {
        if (grid.current && grid.current.instance) {
            grid.current.instance.beginUpdate();
        }
    }, []);

    const endUpdate = useCallback(() => {
        if (grid.current && grid.current.instance) {
            grid.current.instance.updateDimensions();
            grid.current.instance.endUpdate();
        }
    }, []);

    const dsGetSearchText = useCallback(() => {
        return searchText.current;
    }, []);

    const dsGetPageIndex = useCallback(() => {
        var pageIndex = grid.current && grid.current.instance ? grid.current.instance.option('paging.pageIndex') : undefined;
        if (pageIndex === undefined || pageIndex === null) pageIndex = 0;
        return pageIndex;
    }, []);

    const dsSetPageIndex = useCallback((index) => {
        if (grid.current && grid.current.instance) return grid.current.instance.option('paging.pageIndex', index);
    }, []);

    const dsGetPageSize = useCallback(() => {
        if (grid.current && grid.current.instance) return grid.current.instance.option('paging.pageSize');
        return null;
    }, []);

    const dsGetCardViewPageSize = useCallback(() => {
        return defaultPageSize;
    }, [defaultPageSize]);

    const dsGetScanBarcode = useCallback(() => {
        return searchBarcode.current;
    }, []);

    const hasFilterGroups = useCallback(() => {
        if (props.actionItems instanceof Array) {
            var found = props.actionItems.find((i) => i.widget === 'ButtonGroup');
            if (found) return true;
        }

        return false;
    }, [props.actionItems]);
   
    // Config field (config/fields) của 1 field trên bảng của lưới, theo cả trỏ cnfTable/cnfField.
    const getFieldAccessConfig = useCallback(
        (field, table) => {
            if (!field || !config || !config.getCnfField) return null;
            let found = config.getCnfField(field, table || tableName);
            if (found && found.cnfTable) found = config.getCnfField(found.cnfField, found.cnfTable) || found;
            return found || null;
        },
        [config, tableName]
    );

    // Cột bị SETTING / PHÂN QUYỀN chặn → ẩn bằng mọi giá: thắng cả visible: true, lựa chọn của người dùng, cột đang
    // sắp xếp, cột sửa được và không có trong danh sách ẩn hiện cột. Xét cấu hình cột lưới + config field; cột ghép
    // (join/first/last) bị chặn khi mọi field con đều bị chặn (từng field con bị chặn thì ẩn trong ô — renderJoin).
    const isColumnAccessDenied = useCallback(
        (col, rawCol) => {
            if (AntCondition.isAccessDenied(rawCol) || AntCondition.isAccessDenied(col.config)) return true;
            const colTable = col.cnfTable || (rawCol && rawCol.cnfTable) || tableName;
            if (!col.config && AntCondition.isAccessDenied(getFieldAccessConfig(col.dataField, colTable))) return true;
            const fields = rawCol && rawCol.fields instanceof Array ? rawCol.fields : null;
            if (fields && fields.length && (['join', 'first', 'last'].includes(rawCol.dataType) || ['join', 'first', 'last'].includes(col.colType))) {
                return fields.every((f) => {
                    const name = f && typeof f === 'object' ? f.dataField : f;
                    return (f && typeof f === 'object' && AntCondition.isAccessDenied(f)) || AntCondition.isAccessDenied(getFieldAccessConfig(name, colTable));
                });
            }
            return false;
        },
        [getFieldAccessConfig, tableName]
    );

    // opts.businessOnly: chỉ điều kiện nghiệp vụ (bỏ lựa chọn người dùng + tự ẩn cột trống) — danh sách ẩn hiện cột.
    const isColumnVisible = useCallback(
        (col, opts) => {
            let rawCol = props.columns.find((c) => c.dataField === col.dataField);
            if (rawCol && rawCol.rawConfig) rawCol = rawCol.rawConfig;
            if (!rawCol) return false;
            if (isColumnAccessDenied(col, rawCol)) return false;

            const businessOnly = Boolean(opts && opts.businessOnly);
            const userVisible = !businessOnly && col.dataField ? userColumnVisibility.current[col.dataField] : undefined;
            if (rawCol.visible === false) return false;
            // if (col.dataField && sortByColumn.current === col.dataField) return true;

            // `visible: true`: không có điều kiện nghiệp vụ — nhưng vẫn qua các kiểm tra thông minh bên dưới
            // (ẩn cột toàn trống...), trừ khi người dùng chọn hiện.
            let visible = true;
            if (rawCol.visible !== true) {
                visible = AntCondition.isVisible(props.parentData, rawCol);
                if (
                    visible &&
                    rawCol.visibleOnMain &&
                    props.parentData &&
                    Object.keys(props.parentData).length > 0 &&
                    (props.parentData.id || props.parentData.code)
                ) {
                    let vObj = rawCol.visibleOnMain;
                    if (rawCol.visibleOnMain instanceof Array) {
                        vObj = rawCol.visibleOnMain.find(
                            (v) =>
                                v.table === props.parentTable ||
                                (v.table instanceof Array && v.table.includes(props.parentTable)) ||
                                (v.tables instanceof Array && v.tables.includes(props.parentTable))
                        );

                        if (vObj) vObj = vObj.value;
                    }
                    if (vObj)
                        visible = AntCondition.isVisible(props.parentData, {
                            visible: vObj
                        });
                }

                if (
                    visible &&
                    col.config &&
                    col.config.visibleOnMain &&
                    props.parentData &&
                    Object.keys(props.parentData).length > 0 &&
                    (props.parentData.id || props.parentData.code)
                ) {
                    let vObj = col.config.visibleOnMain;
                    if (col.config.visibleOnMain instanceof Array) {
                        vObj = col.config.visibleOnMain.find(
                            (v) =>
                                v.table === props.parentTable ||
                                (v.table instanceof Array && v.table.includes(props.parentTable)) ||
                                (v.tables instanceof Array && v.tables.includes(props.parentTable))
                        );

                        if (vObj) vObj = vObj.value;
                    }
                    if (vObj)
                        visible = AntCondition.isVisible(props.parentData, {
                            visible: vObj
                        });
                }

                if (
                    visible &&
                    col.config &&
                    typeof col.config.visible === 'object' &&
                    rawCol.dataType !== 'join' &&
                    rawCol.dataType !== 'first' &&
                    rawCol.dataType !== 'last'
                ) {
                    visible = AntCondition.isVisible(props.parentData, col.config);
                }

                if (hasFilterGroups()) {
                    if (visible && col.config && col.config.visibleFilterGroups instanceof Array) {
                        let selectedGroup = filteredGroup;
                        if (selectedGroup) {
                            selectedGroup = selectedGroup.name;
                            visible = col.config.visibleFilterGroups.includes(selectedGroup);
                        } else {
                            visible = col.config.visibleFilterGroups.includes(null);
                        }
                    }

                    if (visible && rawCol && rawCol.visibleFilterGroups instanceof Array) {
                        let selectedGroup = filteredGroup;
                        if (selectedGroup) {
                            selectedGroup = selectedGroup.name;
                            visible = rawCol.visibleFilterGroups.includes(selectedGroup);
                        } else {
                            visible = rawCol.visibleFilterGroups.includes(null);
                        }
                    }
                }

                if (visible && rawCol && rawCol.visible && typeof rawCol.visible === 'object' && rawCol.visible.type === 'action') {
                    if (rawCol.visible.field) {
                        if (searchConditions.current) {
                            let condKey = Object.keys(searchConditions.current).find((k) => k === rawCol.visible.field);
                            if (condKey && searchConditions.current[condKey] !== undefined)
                                visible = searchConditions.current[condKey] === rawCol.visible.value;
                        }
                    }
                }
            }

            if (businessOnly) return visible;
            // Cột ẩn mặc định (cấu hình defaultVisible: false): chỉ hiện khi người dùng bật trong bảng ẩn hiện cột.
            if (visible && rawCol.defaultVisible === false && userVisible !== true) return false;
            if (visible && userVisible === false && col._antUserHideable !== false) return false;
            if (opts && opts.skipEmpty) return visible;

            // Cột đang sắp xếp không tự ẩn khi trang hiện tại rỗng (sắp tăng dần đẩy giá trị trống lên
            // đầu) — ẩn thì mất luôn icon và người dùng không bấm đổi chiều được nữa.
            const isSortedColumn = Boolean(col.dataField) && sortByColumn.current === col.dataField;
            if (visible && !isSortedColumn && !col.editable && rawCol.hideEmpty !== false && dataSource.current) {
                if (dataSource.current && dataSource.current.getCurrentData().length > 0) {
                    // Cột ghép nhiều field (join / first / last): chỉ trống khi MỌI field đều trống — vd GLEntry
                    // posting_desc = first(description, posting_desc): phiếu nhập tay chỉ có description.
                    if (['join', 'first', 'last'].includes(rawCol.dataType)) {
                        const fields = (rawCol.fields instanceof Array ? rawCol.fields : [])
                            .map((f) => (f && typeof f === 'object' ? f.dataField : f))
                            .filter(Boolean);
                        if (fields.length) {
                            let isEmptyCol = dataSource.current.isEmptyColumns(fields);
                            visible = !isEmptyCol;
                        }
                    } else {
                        let colField = col.dataField;
                        if (props.showPriority && col.name === 'priority') colField = props.priorityField ? props.priorityField : 'priority';

                        let isEmptyCol = dataSource.current.isEmptyColumn(colField);
                        visible = !isEmptyCol;
                    }
                }
            }

            return visible;
        },
        [hasFilterGroups, props.columns, props.parentData, props.parentTable, props.showPriority, filteredGroup, isColumnAccessDenied]
    );
    // Ngoại lệ của tự ẩn cột trống: lưới phải còn ít nhất 1 cột chữ hoặc cột auto (lấp chỗ trống) — nếu tự ẩn làm
    // mất hết thì hiện lại 1 cột (ưu tiên cột auto, rồi theo thứ tự cấu hình). Chỉ hiện lại cột bị ẩn vì trống,
    // không đụng cột bị ẩn do điều kiện nghiệp vụ hay người dùng tắt. Trả về các cột vừa hiện lại.
    const keepTextColumnShown = useCallback(
        (cols) => {
            const data = (cols instanceof Array ? cols : []).filter((c) => c && c.dataField && !c.isSystemCol);
            if (!data.length || data.some((c) => c.visible !== false && isTextOrAutoColumn(c))) return [];
            const candidates = data.filter((c) => c.visible === false && isTextOrAutoColumn(c) && isColumnVisible(c, { skipEmpty: true }));
            const candidate = candidates.find((c) => c._antFlexibleWidth) || candidates[0];
            if (!candidate) return [];
            candidate.visible = true;
            return [candidate];
        },
        [isColumnVisible]
    );

    const initColumns = useCallback(() => {
        var columns = [];
        const lookupFields = new Set();
        const lookupBestFitWidths = new Map();

        var showIndex = props.showIndex !== undefined ? props.showIndex : true;
        showIndex = showIndex && !selectable && !hasColMarkSelected;

        if (props.showDetail && props.showDetailPosition !== 'right') {
            columns.push({
                name: 'detail',
                label: ' ',
                width: 30,
                alignment: 'center',
                isSystemCol: true,
                cellTemplate: 'renderDetailCell',
                showInColumnChooser: false
            });
        }

        if (showIndex) {
            columns.push({
                dataField: 'rowIndex',
                name: 'colrowIndex',
                label: '#',
                width: 30,
                alignment: 'center',
                isSystemCol: true,
                showInColumnChooser: false
            });
        }

        if (props.showNote) {
            columns.push({
                name: 'note',
                label: ' ',
                width: 30,
                alignment: 'center',
                isSystemCol: true,
                cellTemplate: 'renderNoteCell',
                showInColumnChooser: false
            });
        }

        if (props.showAttachments) {
            columns.push({
                name: 'attachment',
                label: ' ',
                width: 30,
                isSystemCol: true,
                alignment: 'center',
                cellTemplate: 'renderAttachmentCell',
                showInColumnChooser: false
            });
        }

        if (props.showPriority) {
            var isValid = true;

            if (typeof props.showPriority === 'object' && props.showPriority.when) {
                isValid = AntCondition.isValid(null, {
                    when: props.showPriority.when,
                    whenType: props.showPriority.whenType
                });
            }
            if (isValid)
                columns.push({
                    name: 'priority',
                    label: ' ',
                    width: 30,
                    isSystemCol: true,
                    alignment: 'center',
                    cellTemplate: 'renderPriorityCell',
                    showInColumnChooser: false
                });
        }

        if (columns.length === 0) {
            if (!selectable) {
                columns.push({
                    name: 'seperatorBefore',
                    label: ' ',
                    alignment: 'center',
                    editable: false,
                    width: 10,
                    isSystemCol: true,
                    showInColumnChooser: false
                });
            }
        }

        if (props.columns instanceof Array) {
            props.columns.forEach((col) => {
                if (typeof col === 'object' && col.isMarkSelected) {
                    if (!col.hideSelectionColumn)
                        columns.push({
                            dataField: col.dataField,
                            name: 'selection',
                            label: '#',
                            alignment: 'center',
                            dataType: 'bool',
                            editable: false,
                            isSystemCol: true,
                            customCellValue: col.customSelectionValue ? col.customSelectionValue : props.customSelectionValue,
                            width: 40
                        });

                    markSelectedField.current = col.dataField;
                }
            });
        }

        if (inlineActive) {
            columns.push({
                name: 'inlineStatus',
                label: ' ',
                width: 30,
                alignment: 'center',
                isSystemCol: true,
                allowSorting: false,
                cellTemplate: 'renderInlineStatusCell',
                showInColumnChooser: false,
                // "Chữ ký" trạng thái: repaintChangesOnly chỉ vẽ lại ô khi giá trị ô đổi — cảnh báo/lỗi/nháp đổi
                // mà các cột khác giữ nguyên thì biểu tượng vẫn phải cập nhật.
                calculateCellValue: (row) => {
                    if (!row) return '';
                    if (isInlineDraftRow(row))
                        return 'draft|' + Object.keys(inlineDraftValues.current).join(',') + '|' + stringify(inlineDraftError.current || '');
                    const rowError = stringify(inlineRowErrors.current.get(row[props.keyExpr ? props.keyExpr : 'id']) || '');
                    const warnings = row.warnings instanceof Array ? stringify(row.warnings) : '';
                    // Quyền sửa từng dòng (checkEdit) quyết định có nút mở form sửa.
                    const editPermission = row.edit === undefined || row.edit === null ? '' : JSON.stringify(row.edit);
                    return rowError + '#' + warnings + '#' + editPermission;
                }
            });
        }

        if (props.columns instanceof Array) {
            props.columns.forEach((col, colIndex) => {
                // Lưới nhập trực tiếp: cột khai báo dạng chuỗi cũng xét nhập trực tiếp như cột object.
                if (typeof col === 'string' && inlineActive) col = { dataField: String(col) };
                if (typeof col === 'string') {
                    var dataField = String(col);
                    columns.push({ dataField: dataField, name: 'col_' + dataField });
                } else if (typeof col === 'object' && col.dataField) {
                    // Cột sửa trực tiếp: có field addForm tương ứng và cấu hình gốc không khoá (editable: false).
                    const inlineItem = inlineActive ? inlineFieldMap.get(col.dataField) : null;
                    const inlineEditable = Boolean(inlineItem) && getConfiguredEditable(col) !== false;
                    columns.push({
                        ...JSON.parse(stringify(col)),
                        name: 'col_' + col.dataField,
                        editable: col.isMarkSelected ? true : inlineEditable ? true : col.editable,
                        ...(inlineEditable ? { _antInlineField: inlineItem.dataField, editCellTemplate: 'renderInlineEditCell' } : {})
                    });
                }
                else if (typeof col === 'object')
                    columns.push({
                        ...JSON.parse(stringify(col)),
                        name: 'col_' + colIndex
                    });
            });
        }

        if (props.showDetail && props.showDetailPosition === 'right') {
            columns.push({
                name: 'detail',
                label: ' ',
                width: 30,
                alignment: 'center',
                isSystemCol: true,
                cellTemplate: 'renderDetailCell',
                showInColumnChooser: false
            });
        }

        if (gridRowActions instanceof Array && gridRowActions.length > 0 && !isBatchOnlyRowActions(rowActionsDisplay)) {
            const initialActionWidth =
                rowActionsDisplay === 'menu'
                    ? ROW_ACTION_MENU_WIDTH
                    : rowActionsDisplay === 'smart'
                    ? ROW_ACTION_MENU_WIDTH + 80
                    : gridRowActions.reduce((total, i) => total + ((i.width ? i.width : 60) + 8), 0);
            columns.push({
                name: 'actions',
                label: ' ',
                width: props.rowActionWidth ? props.rowActionWidth : initialActionWidth,
                alignment: 'right',
                isSystemCol: true,
                cellTemplate: 'renderButtonsCell',
                allowHiding: false,
                showInColumnChooser: false
            });
        }

        columns.push({
            name: 'seperatorAfter',
            label: ' ',
            alignment: 'center',
            editable: false,
            width: gridRowActions instanceof Array && gridRowActions.length > 0 && !isBatchOnlyRowActions(rowActionsDisplay) ? 5 : 6,
            isSystemCol: true,
            showInColumnChooser: false
        });

        columns.forEach((col) => {
            var rawCol = props.columns.find((f) => f.dataField === col.dataField);
            if (rawCol && rawCol.rawConfig) rawCol = rawCol.rawConfig;

            var colType = !col.isSystemCol && rawCol && rawCol.dataType ? rawCol.dataType : col.dataType;
            var colEditor = rawCol && rawCol.editor ? rawCol.editor : col.editor;
            var colLabel = col.caption ? col.caption : col.label;

            if (colLabel instanceof Array) {
                colLabel = AntCondition.getValue(props.parentData, colLabel);
            }

            var colLookupValues =
                rawCol && rawCol.lookup && rawCol.lookup.values instanceof Array
                    ? rawCol.lookup.values
                    : col.lookup && col.lookup.values instanceof Array
                    ? col.lookup.values
                    : null;
            var colHasLookup = Boolean((rawCol && rawCol.lookup) || col.lookup);

            var colWidth = !col.isSystemCol && rawCol && rawCol.width !== undefined ? rawCol.width : col.width;
            var colMinWidth = !col.isSystemCol && rawCol && rawCol.minWidth !== undefined ? rawCol.minWidth : col.minWidth;

            var colAllowHiding = !col.isSystemCol && rawCol && rawCol.allowHiding !== undefined ? rawCol.allowHiding : col.allowHiding;
            var colAlignment = !col.isSystemCol && rawCol && rawCol.alignment !== undefined ? rawCol.alignment : col.alignment;

            var found = null;
            if (config) {
                if (col.dataField || col.cnfField) {
                    var tableName = col.cnfTable ? col.cnfTable : props.table ? props.table : props.API ? props.API.entityName : null;

                    var strField = col.cnfField ? col.cnfField : col.dataField;
                    found = config.getCnfField(strField, tableName);

                    if (found) {
                        if (found.lookup) colHasLookup = true;
                        if (!colType && found.dataType) colType = found.dataType;
                        if (!colLabel && found.gridLabel) colLabel = found.gridLabel;
                        if (!colLabel && found.label) colLabel = found.label;
                        if (!colLookupValues && found.lookup && found.lookup.values instanceof Array) colLookupValues = found.lookup.values;

                        if (!colWidth && found.width) colWidth = found.width;
                        if (!colMinWidth && found.minWidth) colMinWidth = found.minWidth;
                        if (colAllowHiding === undefined && found.allowHiding !== undefined) colAllowHiding = found.allowHiding;

                        if (!colAlignment) {
                            if (found.dataType === 'currency') colAlignment = 'right';
                            else if (found.dataType === 'float' || found.dataType === 'decimal') colAlignment = 'center';
                            else if (found.dataType === 'int') colAlignment = 'center';
                            else colAlignment = found.alignment;
                        }
                    }

                    if (found && found.cnfTable) {
                        var tableName = found.cnfTable;

                        var strField = found.cnfField ? found.cnfField : col.dataField;
                        found = config.getCnfField(strField, tableName);
                    }

                    if (found) {
                        if (found.lookup) colHasLookup = true;
                        if (!colType && found.dataType) colType = found.dataType;
                        if (!colLabel && found.gridLabel) colLabel = found.gridLabel;
                        if (!colLabel && found.label) colLabel = found.label;
                        if (!colLookupValues && found.lookup && found.lookup.values instanceof Array) colLookupValues = found.lookup.values;

                        if (!colWidth && found.width) colWidth = found.width;
                        if (!colMinWidth && found.minWidth) colMinWidth = found.minWidth;
                        if (colAllowHiding === undefined && found.allowHiding !== undefined) colAllowHiding = found.allowHiding;

                        if (!colAlignment) {
                            if (found.dataType === 'currency') colAlignment = 'right';
                            else if (found.dataType === 'float' || found.dataType === 'decimal') colAlignment = 'center';
                            else if (found.dataType === 'int') colAlignment = 'center';
                            else colAlignment = found.alignment;
                        }
                        col.config = found;
                    }
                }
            }

            if (colHasLookup && col.dataField) lookupFields.add(col.dataField);

            col.colType = colType;

            // // if (!colWidth && colType === 'date') colWidth = 76;
            // // if (!colWidth && colType === 'month') colWidth = 70;
            // // if (!colWidth && colType === 'year') colWidth = 70;
            // // if (!colWidth && colType === 'datetime') colWidth = 130;

            // // if (!colWidth && String(col.dataField).endsWith('_status')) colWidth = 100;
            // if (!colWidth && String(col.dataField).endsWith('code')) colWidth = 80;
            // if (!colWidth && String(col.dataField).endsWith('module')) colWidth = 94;
            // if (!colWidth && String(col.dataField).endsWith('type')) colWidth = 94;

            // // if (!colWidth && String(col.dataField).endsWith('item_name')) colWidth = 250;
            // // if (!colWidth && String(col.dataField).endsWith('variant_dimens')) colWidth = 160;
            // // if (!colWidth && String(col.dataField).endsWith('store_name')) colWidth = 130;

            // // if (!colWidth && String(col.dataField).endsWith('entity_name')) colWidth = 200;
            // // if (!colWidth && String(col.dataField).endsWith('warehouse_name')) colWidth = 170;
            // // if (!colWidth && String(col.dataField).endsWith('department')) colWidth = 160;
            // // if (!colWidth && String(col.dataField).endsWith('business_unit')) colWidth = 160;
            // if (!colWidth && String(col.dataField).endsWith('uom')) colWidth = 55;
            // if (!colWidth && String(col.dataField).endsWith('phone')) colWidth = 100;

            // if (String(col.dataField).endsWith('qty')) colWidth = col.isMarkSelected ? 60 : colWidth ? colWidth : 40;

            // if (!colWidth && colType === 'percent') colWidth = 60;

            // // if (!colWidth && String(col.dataField).endsWith('name')) colWidth = 200;

            // if (!colWidth && (colType === 'bool' || colType === 'int') && String(col.dataField).startsWith('is_')) colWidth = 80;

            // // if (colType === 'currency') {
            // //     if (String(col.dataField).endsWith('unit_price')) colWidth = 100;
            // //     else colWidth = 115;
            // // }

            // if (!colWidth || colWidth === 'auto') colWidth = undefined;

            colLabel = AntLocalization.translateText(AntCondition.getValue(props.parentData, colLabel));
            col.caption = String(colLabel).trim();

            var labelWidth = AntString.measureColumnWidth(colLabel);
            if (colLabel) labelWidth += 4;
            if (colType === 'currency') labelWidth += 6;

            if (colLookupValues instanceof Array) {
                var lookupDisplayField = col.displayField
                    ? col.displayField
                    : found && found.lookup && found.lookup.displayField
                    ? found.lookup.displayField
                    : 'name';
                colLookupValues = localizeLookupValues(colLookupValues, lookupDisplayField, (value) =>
                    AntLocalization.translateText(AntCondition.getValue(props.parentData, value))
                );
                col._antLookupTexts = colLookupValues.map((value) => value[lookupDisplayField]);

                for (let i = 0; i < colLookupValues.length; i++) {
                    const displayText = colLookupValues[i][lookupDisplayField];
                    if (displayText) {
                        var displayWidth = AntString.measureCellWidth(displayText);

                        if (labelWidth < displayWidth) labelWidth = displayWidth;
                    }
                }
            }

            if (colLookupValues instanceof Array && col.dataField) lookupBestFitWidths.set(col.dataField, getLookupBestFitWidth(labelWidth));

            // if (colWidth && colWidth !== 'auto' && colLabel && !col.isSystemCol) {
            //     if (colWidth < labelWidth) colWidth = labelWidth;
            // }

            if (!colMinWidth || colMinWidth < labelWidth) colMinWidth = labelWidth;

            // if (!colMinWidth) colMinWidth = colWidth;

            col.width = colWidth;
            col.minWidth = colMinWidth;
            if (String(colLabel).trim().length <= 0) col.minWidth = undefined;
            col.allowHiding = colAllowHiding;
            if (col.allowHiding === undefined) col.allowHiding = true;
            // Người dùng được tắt cột trong bảng ẩn hiện cột trừ khi cấu hình cột/field ghi rõ allowHiding: false.
            // Tách khỏi allowHiding của DevExtreme (màn hẹp tự ẩn) — bước bố cục đặt false cho cột nhập trực tiếp.
            col._antUserHideable = colAllowHiding !== false;

            if (!colAlignment) {
                if (String(col.dataField).endsWith('status')) colAlignment = 'center';
                if (String(col.dataField).endsWith('_code')) colAlignment = 'left';
                if (String(col.dataField).endsWith('code')) colAlignment = 'left';
                if (String(col.dataField).endsWith('_qty')) colAlignment = 'center';
                if (String(col.dataField).endsWith('qty')) colAlignment = 'center';
                if (String(col.dataField).endsWith('_pct')) colAlignment = 'center';
                if (String(col.dataField).endsWith('pct')) colAlignment = 'center';
                if (String(col.dataField).endsWith('_amt')) colAlignment = 'right';
                if (String(col.dataField).endsWith('amt')) colAlignment = 'right';
                if (String(col.dataField).endsWith('_price')) colAlignment = 'right';
                if (String(col.dataField).endsWith('price')) colAlignment = 'right';
            }
            // if (!colAlignment) colAlignment = 'left';
            col.alignment = colAlignment;

            delete col.sortOrder;

            if (sortByColumn.current) {
                if (sortByColumn.current === col.dataField) {
                    col.sortIndex = 0;
                    sortType.current = sortType.current ? sortType.current : 'asc';
                    col.sortOrder = sortType.current;
                }
            } else if (col.defaultSort) {
                sortByColumn.current = col.dataField;
                col.sortIndex = 0;
                sortType.current = col.defaultSort.order ? col.defaultSort.order : 'asc';
                col.sortOrder = sortType.current;
            }

            if (colLookupValues instanceof Array) {
                col.calculateCellValue = (data) => {
                    if (data) {
                        var colValue = data[col.dataField];
                        var valueField = col.valueField
                            ? col.valueField
                            : found && found.lookup && found.lookup.valueField
                            ? found.lookup.valueField
                            : 'code';
                        var displayField = col.displayField
                            ? col.displayField
                            : found && found.lookup && found.lookup.displayField
                            ? found.lookup.displayField
                            : 'name';
                        if (colValue != null) {
                            var obj = colLookupValues.find((f) => f[valueField] === colValue);
                            if (obj) return obj[displayField];
                        }
                        return colValue;
                    }
                    return null;
                };

                col.calculateDisplayValue = (data) => {
                    if (data) {
                        var colValue = data[col.dataField];
                        var valueField = col.valueField
                            ? col.valueField
                            : found && found.lookup && found.lookup.valueField
                            ? found.lookup.valueField
                            : 'code';
                        var displayField = col.displayField
                            ? col.displayField
                            : found && found.lookup && found.lookup.displayField
                            ? found.lookup.displayField
                            : 'name';
                        if (colValue != null) {
                            var obj = colLookupValues.find((f) => f[valueField] === colValue);
                            if (obj) colValue = obj[displayField];
                        }

                        if (col.customDisplay) colValue = col.customDisplay(data);
                        else if (col.config && col.config.customDisplay) colValue = col.config.customDisplay(data);

                        if (typeof colValue === 'string') colValue = String(colValue);
                        if (
                            colValue ===
                                AntLocalization.translateText({
                                    vi: 'Không',
                                    en: 'None',
                                    fr: 'Aucun',
                                    es: 'Ninguno',
                                    id: 'Tidak ada',
                                    ja: 'なし',
                                    zh: '无',
                                    ko: '없음',
                                    hi: 'कोई नहीं',
                                    ar: 'لا شيء'
                                }) &&
                            col.displayNoneAsEmpty !== false
                        )
                            colValue = '';
                        if (colValue === null || colValue === undefined) colValue = '';

                        return colValue;
                    }
                    return '';
                };
            } else {
                if (colType === 'bool' || colEditor == 'CheckBox') {
                    // if (!col.alignment)
                    col.alignment = 'center';

                    col.calculateCellValue = (data) => {
                        if (col.customCellValue) return col.customCellValue(data);

                        if (data) {
                            if (typeof data[col.dataField] == 'boolean') return data[col.dataField];
                            if (typeof data[col.dataField] == 'string') return String(data[col.dataField]).trim() !== '';

                            if (typeof data[col.dataField] == 'number') return data[col.dataField] != 0;

                            // if (data[col.dataField] === 1) return true;

                            if (colType === 'bool') return parseInt(data[col.dataField]) === 1;
                            if (colType === 'int') return parseInt(data[col.dataField]) > 0;
                            if (colType === 'float') return parseFloat(data[col.dataField]) > 0;
                            else return parseFloat(data[col.dataField]) > 0;
                        }
                        return false;
                    };
                    col.cellTemplate = 'renderCheckboxCell';
                    col.dataType = 'boolean';
                }

                if (colType === 'int') {
                    if (!col.format) {
                        // col.format = '#,##0';
                        col.format = (value) => {
                            return AntLocalization.translateInteger(
                                value,
                                col.showSign !== undefined
                                    ? col.showSign
                                    : col.config && col.config.showSign !== undefined
                                    ? col.config.showSign
                                    : false
                            );
                        };
                    }

                    // if (!col.format) col.format = { type: 'fixedPoint' };
                    if (!col.alignment) col.alignment = 'right';
                    col.calculateCellValue = (data) => {
                        if (col.customCellValue) return col.customCellValue(data);

                        var value = data ? data[col.dataField] : null;
                        if (value === null || value === undefined) return value;
                        if (typeof value === 'number') return parseInt(value);

                        return value;
                    };
                    col.calculateDisplayValue = (data) => {
                        var value = data ? data[col.dataField] : null;
                        if (typeof value === 'number') value = parseInt(value);
                        if (value === 0 && col.displayZeroAsEmpty !== false) value = '';
                        if (value === null || value === undefined) value = '';

                        return value;
                    };
                    col.dataType = 'number';
                }

                if (colType === 'float' || colType === 'decimal') {
                    // if (!col.format) {
                    //     var decimalDigit = found && found.decimalDigit !== undefined && found.decimalDigit !== null ? found.decimalDigit : undefined;
                    //     if (decimalDigit === undefined || decimalDigit === null) decimalDigit = AntLocalization.getCurrencyDecimalDigit();
                    //     if (decimalDigit === undefined || decimalDigit === null) decimalDigit = 2;

                    //     var strFormat = decimalDigit > 0 ? '#,##0.' + String('#').repeat(decimalDigit) : '#,##0';
                    //     if (col.unitType === 'Km') strFormat = strFormat + ' Km';

                    //     col.format = strFormat;
                    // }

                    if (!col.alignment) col.alignment = 'right';
                    col.calculateCellValue = (data) => {
                        if (col.customCellValue) return col.customCellValue(data);

                        var value = data ? data[col.dataField] : null;
                        if (value === null || value === undefined) return value;
                        if (typeof value === 'number') return parseFloat(value);

                        return value;
                    };
                    col.calculateDisplayValue = (data) => {
                        var value = data ? data[col.dataField] : null;
                        if (typeof value === 'number') value = parseFloat(value);

                        if (value === 0 && col.displayZeroAsEmpty !== false) value = '';
                        else if (value === null || value === undefined) value = '';
                        else {
                            let showSign = Boolean(col.showSign || (col.config && col.config.showSign && col.showSign !== false));
                            value = AntLocalization.translateDecimal(value, showSign);
                        }

                        return value;
                    };
                    col.dataType = 'number';
                }

                if (colType === 'day') {
                    if (!col.format) {
                        let strEnd = AntLocalization.translateText({
                            vi: 'Ngày',
                            en: 'Day',
                            fr: 'Jour',
                            es: 'Día',
                            id: 'Hari',
                            ja: '日',
                            zh: '天',
                            ko: '일',
                            hi: 'दिन',
                            ar: 'يوم'
                        });
                        col.format = '#,##0 ' + strEnd;
                    }
                    if (!col.alignment) col.alignment = 'right';
                    col.calculateCellValue = (data) => {
                        if (col.customCellValue) return col.customCellValue(data);

                        var value = data ? data[col.dataField] : null;
                        if (value === null || value === undefined) return value;
                        if (typeof value === 'number') return parseFloat(value);

                        return value;
                    };
                    col.calculateDisplayValue = (data) => {
                        var value = data ? data[col.dataField] : null;
                        if (typeof value === 'number') value = parseFloat(value);

                        if (value === 0 && col.displayZeroAsEmpty !== false) value = '';
                        if (value === null || value === undefined) value = '';

                        return value;
                    };
                    col.dataType = 'number';
                }

                if (colType === 'month') {
                    if (!col.alignment) col.alignment = 'center';
                    col.calculateDisplayValue = (data) => {
                        if (data && data[col.dataField] != null) {
                            var value = parseFloat(data[col.dataField]);
                            if (value) {
                                if (String(value).length > 6) {
                                    return AntTime.fromUnix(value).format('MM/YYYY');
                                } else return AntTime.fromString(format('{0}-{1}-01 00:01', Math.floor(value / 100), value % 100)).format('MM/YYYY');
                            }
                        } else return '';
                    };
                    col.dataType = 'number';
                }

                if (col.config && col.config.dataTypeDisplay === 'month') {
                    if (!col.format) {
                        let strEnd = AntLocalization.translateText({
                            vi: 'Tháng',
                            en: 'Month',
                            fr: 'Mois',
                            es: 'Mes',
                            id: 'Bulan',
                            ja: '月',
                            zh: '月',
                            ko: '월',
                            hi: 'महीना',
                            ar: 'شهر'
                        });
                        col.format = '#,##0 ' + strEnd;
                    }

                    if (!col.alignment) col.alignment = 'right';
                    col.calculateCellValue = (data) => {
                        if (col.customCellValue) return col.customCellValue(data);

                        var value = data ? data[col.dataField] : null;
                        if (value === null || value === undefined) return value;
                        if (typeof value === 'number') return parseFloat(value);

                        return value;
                    };
                    col.calculateDisplayValue = (data) => {
                        var value = data ? data[col.dataField] : null;
                        if (typeof value === 'number') value = parseFloat(value);

                        if (value === 0 && col.displayZeroAsEmpty !== false) value = '';
                        if (value === null || value === undefined) value = '';

                        return value;
                    };
                    col.dataType = 'number';
                }

                if (colType === 'year') {
                    if (!col.alignment) col.alignment = 'center';
                    col.calculateDisplayValue = (data) => {
                        if (data && data[col.dataField] != null) {
                            var value = parseFloat(data[col.dataField]);
                            if (value) {
                                if (String(value).length > 6) {
                                    return AntTime.fromUnix(value).format('YYYY');
                                } else return AntTime.fromString(format('{0}-01-01 00:01', parseInt(value))).format('YYYY');
                            }
                        } else return '';
                    };
                    col.dataType = 'number';
                }

                if (col.config && col.config.dataTypeDisplay === 'year') {
                    if (!col.format) {
                        let strEnd = AntLocalization.translateText({
                            vi: 'Năm',
                            en: 'Year',
                            fr: 'Année',
                            es: 'Año',
                            id: 'Tahun',
                            ja: '年',
                            zh: '年',
                            ko: '년',
                            hi: 'वर्ष',
                            ar: 'سنة'
                        });
                        col.format = '#,##0 ' + strEnd;
                    }

                    if (!col.alignment) col.alignment = 'right';
                    col.calculateCellValue = (data) => {
                        if (col.customCellValue) return col.customCellValue(data);

                        var value = data ? data[col.dataField] : null;
                        if (value === null || value === undefined) return value;
                        if (typeof value === 'number') return parseFloat(value);

                        return value;
                    };
                    col.calculateDisplayValue = (data) => {
                        var value = data ? data[col.dataField] : null;
                        if (typeof value === 'number') value = parseFloat(value);

                        if (value === 0 && col.displayZeroAsEmpty !== false) value = '';
                        if (value === null || value === undefined) value = '';

                        return value;
                    };
                    col.dataType = 'number';
                }

                if (colType === 'period') {
                    if (!col.format) {
                        let strEnd = AntLocalization.translateText({
                            vi: 'kỳ',
                            en: 'period',
                            fr: 'période',
                            es: 'período',
                            id: 'periode',
                            ja: '期間',
                            zh: '期',
                            ko: '기간',
                            hi: 'अवधि',
                            ar: 'فترة'
                        });
                        col.format = '#,##0 ' + strEnd;
                    }

                    if (!col.alignment) col.alignment = 'right';
                    col.calculateCellValue = (data) => {
                        if (col.customCellValue) return col.customCellValue(data);

                        var value = data ? data[col.dataField] : null;
                        if (value === null || value === undefined) return value;
                        if (typeof value === 'number') return parseFloat(value);

                        return value;
                    };
                    col.calculateDisplayValue = (data) => {
                        var value = data ? data[col.dataField] : null;
                        if (typeof value === 'number') value = parseFloat(value);

                        if (value === 0 && col.displayZeroAsEmpty !== false) value = '';
                        if (value === null || value === undefined) value = '';

                        return value;
                    };
                    col.dataType = 'number';
                }

                if (colType === 'percent') {
                    if (!col.format) {
                        var decimalDigit = found && found.decimalDigit !== undefined && found.decimalDigit !== null ? found.decimalDigit : undefined;
                        // if (decimalDigit === undefined || decimalDigit === null)
                        //     decimalDigit = AntLocalization.getCurrencyDecimalDigit();
                        if (decimalDigit === undefined || decimalDigit === null) decimalDigit = 0;
                        col.format = {
                            type: 'percent',
                            precision: decimalDigit
                        };
                    }

                    if (!col.alignment) col.alignment = 'right';
                    col.calculateCellValue = (data) => {
                        if (col.customCellValue) return col.customCellValue(data);

                        var value = data ? data[col.dataField] : null;
                        if (value === null || value === undefined) return value;
                        if (typeof value === 'number') return parseFloat(value);

                        return value;
                    };
                    col.calculateDisplayValue = (data) => {
                        var value = data ? data[col.dataField] : null;
                        if (typeof value === 'number') value = parseFloat(value);

                        if (value === 0 && col.displayZeroAsEmpty !== false) value = '';
                        if (value === null || value === undefined) value = '';

                        return value;
                    };
                    col.dataType = 'number';
                }

                if (colType === 'currency') {
                    // if (!col.format) {
                    //     // var currency = AntLocalStorage.getSetting('Sys_BaseCurrency');
                    //     // var lblValue = currency === 'VND' ? 'đ' : '$';
                    //     // col.format = currency === 'VND' ? '#,##0 ' + lblValue : lblValue + ' #,##0';

                    //     col.format = (value) => {
                    //         let fValue= AntLocalization.translateCurrency(
                    //             value,
                    //             col.showSign !== undefined
                    //                 ? col.showSign
                    //                 : col.config && col.config.showSign !== undefined
                    //                 ? col.config.showSign
                    //                 : false
                    //         );
                    //         return fValue;
                    //     };
                    // }

                    if (!col.alignment) col.alignment = 'right';
                    col.calculateCellValue = (data) => {
                        if (col.customCellValue) return col.customCellValue(data);

                        var value = data ? data[col.dataField] : null;
                        if (value === null || value === undefined) return value;

                        if (typeof value === 'number') return parseFloat(value);

                        return value;
                    };
                    col.calculateDisplayValue = (data) => {
                        var value = data ? data[col.dataField] : null;
                        if (typeof value === 'number') value = parseFloat(value);

                        if (value === 0 && col.displayZeroAsEmpty !== false) value = '';
                        else if (value === null || value === undefined) value = '';
                        else {
                            // Resolve currency theo chain: col.currency.keepBaseCurrency → literal
                            //   → col.currency.currencyField (đọc từ row data → parentData) → grid-level
                            //   props.currencyField → Sys_BaseCurrency.
                            var currencySpec = col.currency || {};
                            var resolvedCurrency = AntLocalization.resolveCurrency(currencySpec, data, props.parentData, props.currencyField);
                            var showSign = value > 0 && (col.showSign || (col.config && col.config.showSign && col.showSign !== false));
                            value = AntLocalization.translateCurrency(value, showSign, { currency: resolvedCurrency });
                        }

                        return value;
                    };

                    col.dataType = 'number';
                }

                if (colType === 'date') {
                    if (!col.alignment) col.alignment = 'center';
                    if (!col.format)
                        col.format = function (value) {
                            if (!value) return '';

                            if (AntTime.isUnixWithinToDay(value)) {
                                if (col.showTimeWithinToday) return AntTime.fromUnix(value).format('HH:mm');
                                else
                                    return AntLocalization.translateText({
                                        vi: 'Hôm nay',
                                        en: 'Today',
                                        fr: "Aujourd'hui",
                                        es: 'Hoy',
                                        id: 'Hari ini',
                                        ja: '今日',
                                        zh: '今天',
                                        ko: '오늘',
                                        hi: 'आज',
                                        ar: 'اليوم'
                                    });
                            }

                            if (AntTime.isUnixWithinYesterday(value))
                                return AntLocalization.translateText({
                                    vi: 'Hôm qua',
                                    en: 'Yesterday',
                                    fr: 'Hier',
                                    es: 'Ayer',
                                    id: 'Kemarin',
                                    ja: '昨日',
                                    zh: '昨天',
                                    ko: '어제',
                                    hi: 'कल (बीता)',
                                    ar: 'أمس'
                                });

                            if (AntTime.isUnixWithinTomorrow(value))
                                return AntLocalization.translateText({
                                    vi: 'Ngày mai',
                                    en: 'Tomorrow',
                                    fr: 'Demain',
                                    es: 'Mañana',
                                    id: 'Besok',
                                    ja: '明日',
                                    zh: '明天',
                                    ko: '내일',
                                    hi: 'कल (आने वाला)',
                                    ar: 'غداً'
                                });

                            if (AntTime.isUnixWithinCurrentYear(value)) return AntTime.fromUnix(value).format('DD/MM');

                            // if (col.showTimeWithinToday) return AntTime.fromUnix(value).format('DD/MM');

                            return AntTime.fromUnix(value).format('DD/MM/YY');
                        };
                    col.calculateCellValue = (data) => {
                        if (col.customCellValue) return col.customCellValue(data);

                        var value = data ? data[col.dataField] : null;
                        if (value === null || value === undefined) return value;
                        if (typeof value === 'number') return parseFloat(value);

                        return value;
                    };
                    col.calculateDisplayValue = (data) => {
                        var value = data ? data[col.dataField] : null;
                        if (typeof value === 'number') value = parseFloat(value);

                        if (col.customDisplay) value = col.customDisplay(data);
                        else if (col.config && col.config.customDisplay) value = col.config.customDisplay(data);

                        if (value === 0 && col.displayZeroAsEmpty !== false) value = '';
                        if (value === null || value === undefined) value = '';

                        return value;
                    };
                    col.dataType = 'date';
                }

                if (colType === 'datetime') {
                    if (!col.alignment) col.alignment = 'center';
                    if (!col.format)
                        col.format = function (value) {
                            if (!value) return '';

                            if (AntTime.isUnixWithinToDay(value)) return AntTime.fromUnix(value).format('HH:mm');

                            if (AntTime.isUnixWithinCurrentYear(value)) return AntTime.fromUnix(value).format('DD/MM HH:mm');

                            return AntTime.fromUnix(value).format('DD/MM/YY');
                        };
                    col.calculateCellValue = (data) => {
                        if (col.customCellValue) return col.customCellValue(data);

                        var value = data ? data[col.dataField] : null;
                        if (value === null || value === undefined) return value;
                        if (typeof value === 'number') return parseFloat(value);

                        return value;
                    };

                    col.calculateDisplayValue = (data) => {
                        var value = data ? data[col.dataField] : null;
                        if (typeof value === 'number') value = parseFloat(value);

                        if (col.customDisplay) value = col.customDisplay(data);
                        else if (col.config && col.config.customDisplay) value = col.config.customDisplay(data);

                        if (value === 0 && col.displayZeroAsEmpty !== false) value = '';
                        if (value === null || value === undefined) value = '';

                        return value;
                    };
                    col.dataType = 'date';
                }

                if (colType === 'time') {
                    if (!col.alignment) col.alignment = 'center';
                    if (!col.format) col.format = 'hh:mm a';

                    col.calculateCellValue = (data) => {
                        if (col.customCellValue) return col.customCellValue(data);

                        var value = data ? data[col.dataField] : null;
                        if (value === null || value === undefined) return value;
                        if (typeof value === 'number') return parseFloat(value);

                        return value;
                    };

                    col.calculateDisplayValue = (data) => {
                        var value = data ? data[col.dataField] : null;
                        if (typeof value === 'number') value = AntTime.fromUnix(parseFloat(value)).toDate();

                        if (col.customDisplay) value = col.customDisplay(data);
                        else if (col.config && col.config.customDisplay) value = col.config.customDisplay(data);

                        if (value === 0 && col.displayZeroAsEmpty !== false) value = '';
                        if (value === null || value === undefined) value = '';

                        return value;
                    };
                    col.dataType = 'date';
                }

                if (colType === 'weekday') {
                    if (!col.alignment) col.alignment = 'left';
                    if (!col.format)
                        col.format = function (value) {
                            if (!value) return '';

                            const dayOfWeek = parseInt(AntTime.fromUnix(value).isoWeekday());
                            if (dayOfWeek === 1)
                                return AntLocalization.translateText({
                                    vi: 'Thứ Hai',
                                    en: 'Monday',
                                    fr: 'Lundi',
                                    es: 'Lunes',
                                    id: 'Senin',
                                    ja: '月曜日',
                                    zh: '星期一',
                                    ko: '월요일',
                                    hi: 'सोमवार',
                                    ar: 'الإثنين'
                                });
                            if (dayOfWeek === 2)
                                return AntLocalization.translateText({
                                    vi: 'Thứ Ba',
                                    en: 'Tuesday',
                                    fr: 'Mardi',
                                    es: 'Martes',
                                    id: 'Selasa',
                                    ja: '火曜日',
                                    zh: '星期二',
                                    ko: '화요일',
                                    hi: 'मंगलवार',
                                    ar: 'الثلاثاء'
                                });
                            if (dayOfWeek === 3)
                                return AntLocalization.translateText({
                                    vi: 'Thứ Tư',
                                    en: 'Wednesday',
                                    fr: 'Mercredi',
                                    es: 'Miércoles',
                                    id: 'Rabu',
                                    ja: '水曜日',
                                    zh: '星期三',
                                    ko: '수요일',
                                    hi: 'बुधवार',
                                    ar: 'الأربعاء'
                                });
                            if (dayOfWeek === 4)
                                return AntLocalization.translateText({
                                    vi: 'Thứ Năm',
                                    en: 'Thursday',
                                    fr: 'Jeudi',
                                    es: 'Jueves',
                                    id: 'Kamis',
                                    ja: '木曜日',
                                    zh: '星期四',
                                    ko: '목요일',
                                    hi: 'गुरुवार',
                                    ar: 'الخميس'
                                });
                            if (dayOfWeek === 5)
                                return AntLocalization.translateText({
                                    vi: 'Thứ Sáu',
                                    en: 'Friday',
                                    fr: 'Vendredi',
                                    es: 'Viernes',
                                    id: 'Jumat',
                                    ja: '金曜日',
                                    zh: '星期五',
                                    ko: '금요일',
                                    hi: 'शुक्रवार',
                                    ar: 'الجمعة'
                                });
                            if (dayOfWeek === 6)
                                return AntLocalization.translateText({
                                    vi: 'Thứ Bảy',
                                    en: 'Saturday',
                                    fr: 'Samedi',
                                    es: 'Sábado',
                                    id: 'Sabtu',
                                    ja: '土曜日',
                                    zh: '星期六',
                                    ko: '토요일',
                                    hi: 'शनिवार',
                                    ar: 'السبت'
                                });
                            if (dayOfWeek === 7)
                                return AntLocalization.translateText({
                                    vi: 'Chủ Nhật',
                                    en: 'Sunday',
                                    fr: 'Dimanche',
                                    es: 'Domingo',
                                    id: 'Minggu',
                                    ja: '日曜日',
                                    zh: '星期日',
                                    ko: '일요일',
                                    hi: 'रविवार',
                                    ar: 'الأحد'
                                });

                            return AntTime.fromUnix(value).format('DD/MM/YY');
                        };

                    col.calculateCellValue = (data) => {
                        if (col.customCellValue) return col.customCellValue(data);

                        var value = data ? data[col.dataField] : null;
                        if (value === null || value === undefined) return value;
                        if (typeof value === 'number') return parseFloat(value);

                        return value;
                    };
                    col.calculateDisplayValue = (data) => {
                        var value = data ? data[col.dataField] : null;
                        if (typeof value === 'number') value = parseFloat(value);

                        if (col.customDisplay) value = col.customDisplay(data);
                        else if (col.config && col.config.customDisplay) value = col.config.customDisplay(data);

                        if (value === 0 && col.displayZeroAsEmpty !== false) value = '';
                        if (value === null || value === undefined) value = '';

                        return value;
                    };
                    col.dataType = 'date';
                }

                if (colType === 'duration') {
                    if (!col.alignment) col.alignment = 'right';
                    col.calculateCellValue = (data) => {
                        if (!data) return '';

                        if (col.customCellValue) return col.customCellValue(data);

                        let value = col.startField ? data[col.startField] : data[col.dataField];
                        if (!value) return '';

                        let minutes = AntTime.diffMinuteToNow(value, true);

                        if (col.endField) {
                            let value2 = data ? data[col.endField] : null;
                            if (value2) minutes = AntTime.diffMinutes(value, value2, true);
                        }

                        minutes = Math.ceil(minutes);

                        let vDays = Math.floor(Math.abs(minutes) / (60 * 24));
                        let vHours = Math.floor(Math.abs(minutes) / 60) - vDays * 24;
                        let vMinutes = Math.abs(minutes) - Math.floor(Math.abs(minutes) / 60) * 60;

                        // if (!vDays && !vHours && vMinutes)
                        //     return [vMinutes ? format('{0} phút', vMinutes) : null].filter((v) => Boolean(v)).join(' ');

                        // if (!vDays && vHours && !vMinutes) return [vHours ? format('{0} giờ', vHours) : null].filter((v) => Boolean(v)).join(' ');

                        // if (!vDays)
                        //     return [vHours ? format('{0}g', vHours) : null, vMinutes ? format('{0}ph', vMinutes) : null]
                        //         .filter((v) => Boolean(v))
                        //         .join(' ');

                        // value = [
                        //     vDays ? format('{0}ng', vDays) : null,
                        //     vHours ? format('{0}g', vHours) : null,
                        //     vMinutes ? format('{0}ph', vMinutes) : null
                        // ]
                        //     .filter((v) => Boolean(v))
                        //     .join(' ');

                        // value = [
                        //     vDays ? format('{0} ngày', vDays) : null,
                        //     vHours ? format('{0} giờ', vHours) : null,
                        //     vMinutes ? format('{0} phút', vMinutes) : null
                        // ]

                        if (vDays)
                            value = [
                                vDays
                                    ? format(
                                          '{0} {1}',
                                          vDays,
                                          AntLocalization.translateText({
                                              vi: 'ngày',
                                              en: vDays > 1 ? 'days' : 'day',
                                              fr: vDays > 1 ? 'jours' : 'jour',
                                              es: vDays > 1 ? 'días' : 'día',
                                              id: 'hari',
                                              ja: '日',
                                              zh: '天',
                                              ko: '일',
                                              hi: 'दिन',
                                              ar: vDays > 1 ? 'أيام' : 'يوم'
                                          })
                                      )
                                    : null,
                                vHours
                                    ? format(
                                          '{0} {1}',
                                          vHours,
                                          AntLocalization.translateText({
                                              vi: 'giờ',
                                              en: vHours > 1 ? 'hours' : 'hour',
                                              fr: vHours > 1 ? 'heures' : 'heure',
                                              es: vHours > 1 ? 'horas' : 'hora',
                                              id: 'jam',
                                              ja: '時間',
                                              zh: '小时',
                                              ko: '시간',
                                              hi: 'घंटे',
                                              ar: vHours > 1 ? 'ساعات' : 'ساعة'
                                          })
                                      )
                                    : null
                            ];
                        else if (vHours)
                            value = [
                                vHours
                                    ? format(
                                          '{0} {1}',
                                          vHours,
                                          AntLocalization.translateText({
                                              vi: 'giờ',
                                              en: vHours > 1 ? 'hours' : 'hour',
                                              fr: vHours > 1 ? 'heures' : 'heure',
                                              es: vHours > 1 ? 'horas' : 'hora',
                                              id: 'jam',
                                              ja: '時間',
                                              zh: '小时',
                                              ko: '시간',
                                              hi: 'घंटे',
                                              ar: vHours > 1 ? 'ساعات' : 'ساعة'
                                          })
                                      )
                                    : null,
                                vMinutes
                                    ? format(
                                          '{0} {1}',
                                          vMinutes,
                                          AntLocalization.translateText({
                                              vi: 'phút',
                                              en: vMinutes > 1 ? 'minutes' : 'minute',
                                              fr: vMinutes > 1 ? 'minutes' : 'minute',
                                              es: vMinutes > 1 ? 'minutos' : 'minuto',
                                              id: 'menit',
                                              ja: '分',
                                              zh: '分钟',
                                              ko: '분',
                                              hi: 'मिनट',
                                              ar: vMinutes > 1 ? 'دقائق' : 'دقيقة'
                                          })
                                      )
                                    : null
                            ];
                        else
                            value = [
                                vMinutes
                                    ? format(
                                          '{0} {1}',
                                          vMinutes,
                                          AntLocalization.translateText({
                                              vi: 'phút',
                                              en: vMinutes > 1 ? 'minutes' : 'minute',
                                              fr: vMinutes > 1 ? 'minutes' : 'minute',
                                              es: vMinutes > 1 ? 'minutos' : 'minuto',
                                              id: 'menit',
                                              ja: '分',
                                              zh: '分钟',
                                              ko: '분',
                                              hi: 'मिनट',
                                              ar: vMinutes > 1 ? 'دقائق' : 'دقيقة'
                                          })
                                      )
                                    : null
                            ];

                        value = value.filter((v) => Boolean(v)).join(' ');
                        if (minutes < 0)
                            value = format(
                                '{1} {0}',
                                value,
                                AntLocalization.translateText({
                                    vi: 'Còn',
                                    en: 'Remain',
                                    fr: 'Reste',
                                    es: 'Quedan',
                                    id: 'Sisa',
                                    ja: '残り',
                                    zh: '剩余',
                                    ko: '남은',
                                    hi: 'शेष',
                                    ar: 'متبقي'
                                })
                            );
                        return value;
                    };

                    col.dataType = 'string';
                }

                if (colType === 'join') {
                    col.calculateCellValue = (data) => {
                        if (col.customCellValue) return col.customCellValue(data);
                        var fields = col.fields;
                        if (fields instanceof Array) {
                            var tableName = col.cnfTable ? col.cnfTable : props.table ? props.table : props.API ? props.API.entityName : null;

                            var ar = [];

                            for (let i = 0; i < fields.length; i++) {
                                const fField = fields[i];

                                let fFieldName = fField;
                                if (fField && typeof fField === 'object' && fField.dataField) fFieldName = fField.dataField;

                                // Setting / phân quyền chặn field con → không hiển thị, kể cả khai báo visible: true.
                                if (
                                    (fField && typeof fField === 'object' && AntCondition.isAccessDenied(fField)) ||
                                    AntCondition.isAccessDenied(getFieldAccessConfig(fFieldName, tableName))
                                )
                                    continue;

                                if (!(fField && typeof fField === 'object' && fField.visible === true)) {
                                    var found = config.getCnfField(fField, tableName);
                                    if (found && found.cnfTable)
                                        found = config.getCnfField(found.cnfField, found.cnfTable ? found.cnfTable : tableName);

                                    if (found) {
                                        var visible = AntCondition.isVisible(props.parentData, found);
                                        if (
                                            visible &&
                                            found.visibleOnMain &&
                                            props.parentData &&
                                            Object.keys(props.parentData).length > 0 &&
                                            (props.parentData.id || props.parentData.code)
                                        ) {
                                            let vObj = found.visibleOnMain;
                                            if (found.visibleOnMain instanceof Array) {
                                                vObj = found.visibleOnMain.find(
                                                    (v) =>
                                                        v.table === props.parentTable ||
                                                        (v.table instanceof Array && v.table.includes(props.parentTable)) ||
                                                        (v.tables instanceof Array && v.tables.includes(props.parentTable))
                                                );

                                                if (vObj) vObj = vObj.value;
                                            }
                                            if (vObj)
                                                visible = AntCondition.isVisible(props.parentData, {
                                                    visible: vObj
                                                });
                                        }
                                        if (!visible) continue;
                                    }
                                }

                                var valueField = found && found.lookup && found.lookup.valueField ? found.lookup.valueField : 'code';
                                var displayField = found && found.lookup && found.lookup.displayField ? found.lookup.displayField : 'name';
                                var lookupValues = found && found.lookup && found.lookup.values instanceof Array ? found.lookup.values : [];

                                var fValue = data[fFieldName];
                                if (fValue != null) {
                                    var obj = lookupValues.find((f) => f[valueField] === fValue);
                                    if (obj) fValue = obj[displayField];
                                }

                                if (fValue instanceof Array) {
                                    for (let j = 0; j < fValue.length; j++) {
                                        let jValue = fValue[j];

                                        jValue = AntLocalization.translateText(jValue);

                                        if (typeof jValue === 'string') jValue = String(jValue);
                                        if (jValue === null || jValue === undefined) jValue = '';
                                        ar.push(jValue);
                                    }
                                } else {
                                    fValue = AntLocalization.translateText(fValue);

                                    if (typeof fValue === 'string') fValue = String(fValue);
                                    if (
                                        fValue ===
                                            AntLocalization.translateText({
                                                vi: 'Không',
                                                en: 'None',
                                                fr: 'Aucun',
                                                es: 'Ninguno',
                                                id: 'Tidak ada',
                                                ja: 'なし',
                                                zh: '无',
                                                ko: '없음',
                                                hi: 'कोई नहीं',
                                                ar: 'لا شيء'
                                            }) &&
                                        col.displayNoneAsEmpty !== false
                                    )
                                        fValue = '';
                                    if (fValue === null || fValue === undefined) fValue = '';

                                    if (fValue && parseInt(fValue) && String(fFieldName).endsWith('_adm2_name'))
                                        fValue =
                                            AntLocalization.translateText({
                                                vi: 'Quận',
                                                en: 'Dist',
                                                fr: 'District',
                                                es: 'Distrito',
                                                id: 'Distrik',
                                                ja: '地区',
                                                zh: '区',
                                                ko: '구역',
                                                hi: 'जिला',
                                                ar: 'منطقة'
                                            }) +
                                            ' ' +
                                            fValue;

                                    ar.push(fValue);
                                }
                            }

                            ar = AntArray.distinct(
                                ar
                                    .flat()
                                    .filter((f) => Boolean(f))
                                    .map((f) => String(f))
                            );

                            return ar.join(col.separator ? col.separator : ', ');
                        }

                        return '';
                    };
                    col.dataType = 'string';
                }

                if (colType === 'first') {
                    col.calculateCellValue = (data) => {
                        if (col.customCellValue) return col.customCellValue(data);
                        var fields = col.fields;
                        if (fields instanceof Array) {
                            var tableName = col.cnfTable ? col.cnfTable : props.table ? props.table : props.API ? props.API.entityName : null;

                            var ar = [];

                            for (let i = 0; i < fields.length; i++) {
                                const fField = fields[i];

                                let fFieldName = fField;
                                if (fField && typeof fField === 'object' && fField.dataField) fFieldName = fField.dataField;

                                // Setting / phân quyền chặn field con → không hiển thị, kể cả khai báo visible: true.
                                if (
                                    (fField && typeof fField === 'object' && AntCondition.isAccessDenied(fField)) ||
                                    AntCondition.isAccessDenied(getFieldAccessConfig(fFieldName, tableName))
                                )
                                    continue;

                                if (!(fField && typeof fField === 'object' && fField.visible === true)) {
                                    var found = config.getCnfField(fField, tableName);
                                    if (found && found.cnfTable)
                                        found = config.getCnfField(found.cnfField, found.cnfTable ? found.cnfTable : tableName);

                                    if (found) {
                                        var visible = AntCondition.isVisible(props.parentData, found);
                                        if (
                                            visible &&
                                            found.visibleOnMain &&
                                            props.parentData &&
                                            Object.keys(props.parentData).length > 0 &&
                                            (props.parentData.id || props.parentData.code)
                                        ) {
                                            let vObj = found.visibleOnMain;
                                            if (found.visibleOnMain instanceof Array) {
                                                vObj = found.visibleOnMain.find(
                                                    (v) =>
                                                        v.table === props.parentTable ||
                                                        (v.table instanceof Array && v.table.includes(props.parentTable)) ||
                                                        (v.tables instanceof Array && v.tables.includes(props.parentTable))
                                                );

                                                if (vObj) vObj = vObj.value;
                                            }
                                            if (vObj)
                                                visible = AntCondition.isVisible(props.parentData, {
                                                    visible: vObj
                                                });
                                        }
                                        if (!visible) continue;
                                    }
                                }

                                var valueField = found && found.lookup && found.lookup.valueField ? found.lookup.valueField : 'code';
                                var displayField = found && found.lookup && found.lookup.displayField ? found.lookup.displayField : 'name';
                                var lookupValues = found && found.lookup && found.lookup.values instanceof Array ? found.lookup.values : [];

                                var fValue = data[fFieldName];
                                if (fValue != null) {
                                    var obj = lookupValues.find((f) => f[valueField] === fValue);
                                    if (obj) fValue = obj[displayField];
                                }

                                if (fValue instanceof Array) {
                                    for (let j = 0; j < fValue.length; j++) {
                                        let jValue = fValue[j];

                                        jValue = AntLocalization.translateText(jValue);

                                        if (typeof jValue === 'string') jValue = String(jValue);
                                        if (jValue === null || jValue === undefined) jValue = '';
                                        ar.push(jValue);
                                    }
                                } else {
                                    fValue = AntLocalization.translateText(fValue);

                                    if (typeof fValue === 'string') fValue = String(fValue);
                                    if (
                                        fValue ===
                                            AntLocalization.translateText({
                                                vi: 'Không',
                                                en: 'None',
                                                fr: 'Aucun',
                                                es: 'Ninguno',
                                                id: 'Tidak ada',
                                                ja: 'なし',
                                                zh: '无',
                                                ko: '없음',
                                                hi: 'कोई नहीं',
                                                ar: 'لا شيء'
                                            }) &&
                                        col.displayNoneAsEmpty !== false
                                    )
                                        fValue = '';
                                    if (fValue === null || fValue === undefined) fValue = '';

                                    if (fValue && parseInt(fValue) && String(fFieldName).endsWith('_adm2_name'))
                                        fValue =
                                            AntLocalization.translateText({
                                                vi: 'Quận',
                                                en: 'Dist',
                                                fr: 'District',
                                                es: 'Distrito',
                                                id: 'Distrik',
                                                ja: '地区',
                                                zh: '区',
                                                ko: '구역',
                                                hi: 'जिला',
                                                ar: 'منطقة'
                                            }) +
                                            ' ' +
                                            fValue;

                                    ar.push(fValue);
                                }
                            }
                            return ar
                                .filter((f) => Boolean(f))
                                .map((f) => String(f))
                                .shift();
                        }

                        return '';
                    };
                    col.dataType = 'string';
                }

                if (colType === 'last') {
                    col.calculateCellValue = (data) => {
                        if (col.customCellValue) return col.customCellValue(data);
                        var fields = col.fields;
                        if (fields instanceof Array) {
                            var tableName = col.cnfTable ? col.cnfTable : props.table ? props.table : props.API ? props.API.entityName : null;

                            var ar = [];

                            for (let i = 0; i < fields.length; i++) {
                                const fField = fields[i];

                                let fFieldName = fField;
                                if (fField && typeof fField === 'object' && fField.dataField) fFieldName = fField.dataField;

                                // Setting / phân quyền chặn field con → không hiển thị, kể cả khai báo visible: true.
                                if (
                                    (fField && typeof fField === 'object' && AntCondition.isAccessDenied(fField)) ||
                                    AntCondition.isAccessDenied(getFieldAccessConfig(fFieldName, tableName))
                                )
                                    continue;

                                if (!(fField && typeof fField === 'object' && fField.visible === true)) {
                                    var found = config.getCnfField(fField, tableName);
                                    if (found && found.cnfTable)
                                        found = config.getCnfField(found.cnfField, found.cnfTable ? found.cnfTable : tableName);

                                    if (found) {
                                        var visible = AntCondition.isVisible(props.parentData, found);
                                        if (
                                            visible &&
                                            found.visibleOnMain &&
                                            props.parentData &&
                                            Object.keys(props.parentData).length > 0 &&
                                            (props.parentData.id || props.parentData.code)
                                        ) {
                                            let vObj = found.visibleOnMain;
                                            if (found.visibleOnMain instanceof Array) {
                                                vObj = found.visibleOnMain.find(
                                                    (v) =>
                                                        v.table === props.parentTable ||
                                                        (v.table instanceof Array && v.table.includes(props.parentTable)) ||
                                                        (v.tables instanceof Array && v.tables.includes(props.parentTable))
                                                );

                                                if (vObj) vObj = vObj.value;
                                            }
                                            if (vObj)
                                                visible = AntCondition.isVisible(props.parentData, {
                                                    visible: vObj
                                                });
                                        }
                                        if (!visible) continue;
                                    }
                                }

                                var valueField = found && found.lookup && found.lookup.valueField ? found.lookup.valueField : 'code';
                                var displayField = found && found.lookup && found.lookup.displayField ? found.lookup.displayField : 'name';
                                var lookupValues = found && found.lookup && found.lookup.values instanceof Array ? found.lookup.values : [];

                                var fValue = data[fFieldName];
                                if (fValue != null) {
                                    var obj = lookupValues.find((f) => f[valueField] === fValue);
                                    if (obj) fValue = obj[displayField];
                                }

                                if (fValue instanceof Array) {
                                    for (let j = 0; j < fValue.length; j++) {
                                        let jValue = fValue[j];

                                        jValue = AntLocalization.translateText(jValue);

                                        if (typeof jValue === 'string') jValue = String(jValue);
                                        if (jValue === null || jValue === undefined) jValue = '';
                                        ar.push(jValue);
                                    }
                                } else {
                                    fValue = AntLocalization.translateText(fValue);

                                    if (typeof fValue === 'string') fValue = String(fValue);
                                    if (
                                        fValue ===
                                            AntLocalization.translateText({
                                                vi: 'Không',
                                                en: 'None',
                                                fr: 'Aucun',
                                                es: 'Ninguno',
                                                id: 'Tidak ada',
                                                ja: 'なし',
                                                zh: '无',
                                                ko: '없음',
                                                hi: 'कोई नहीं',
                                                ar: 'لا شيء'
                                            }) &&
                                        col.displayNoneAsEmpty !== false
                                    )
                                        fValue = '';
                                    if (fValue === null || fValue === undefined) fValue = '';

                                    if (fValue && parseInt(fValue) && String(fFieldName).endsWith('_adm2_name'))
                                        fValue =
                                            AntLocalization.translateText({
                                                vi: 'Quận',
                                                en: 'Dist',
                                                fr: 'District',
                                                es: 'Distrito',
                                                id: 'Distrik',
                                                ja: '地区',
                                                zh: '区',
                                                ko: '구역',
                                                hi: 'जिला',
                                                ar: 'منطقة'
                                            }) +
                                            ' ' +
                                            fValue;

                                    ar.push(fValue);
                                }
                            }
                            return ar
                                .filter((f) => Boolean(f))
                                .map((f) => String(f))
                                .pop();
                        }

                        return '';
                    };
                    col.dataType = 'string';
                }

                if (colType === 'string') {
                    col.calculateCellValue = (data) => {
                        if (col.customCellValue) return col.customCellValue(data);

                        var value = data ? data[col.dataField] : null;
                        if (value && value instanceof Array) value = value.map((f) => String(f)).join(col.separator ? col.separator : ', ');

                        if (col.upper) value = String(value).toUpperCase();

                        return value;
                    };
                    col.dataType = 'string';
                }

                // if (col.autoShortten)
                // if (col.dataField === 'entity_name') col.cellTemplate = 'renderContentCell';
            }
            if (col.link) col.cellTemplate = 'renderLinkCell';
            if (col.boldable) col.cellTemplate = 'renderBoldCell';
            if (col.customFormatable) col.cellTemplate = 'renderCustomFormatCell';
            if (props.cellRenders && typeof props.cellRenders[col.dataField] === 'function') {
                col.cellTemplate = 'renderCustomTemplate';
                // eslint-disable-next-line no-console
            }

            // ------ EDITING START ------

            var editable = col.editable !== undefined ? Boolean(col.editable) : false;
            if (typeof col.editable === 'object') {
                if (col.editable.type === 'action' && col.editable.field) {
                    editable = false;
                    var condKey = Object.keys(searchConditions.current).find((k) => k === col.editable.field);
                    if (condKey && searchConditions.current[condKey] !== undefined)
                        editable = searchConditions.current[condKey] === col.editable.value;
                } else if (props.parentData) {
                    editable = AntCondition.isEditable(props.parentData, col);
                }
            }

            col.allowEditing = Boolean(editable);
            if (col.allowEditing) col.cssClass = 'ant-grid-col-editable';
            // Lưới nhập trực tiếp: ô dữ liệu KHÔNG nhập được tô xám nhạt để phân biệt với ô nhập được.
            else if (inlineActive && col.dataField && !col.isSystemCol)
                col.cssClass = String(col.cssClass || '')
                    .split(/\s+/)
                    .filter(Boolean)
                    .concat('ant-grid-col-readonly')
                    .join(' ');

            col.editorOptions = {
                ...props.editorOptions
            };

            if (colType === 'currency') {
                col.editorOptions.format = AntLocalization.getCurrencyFormat();
            }

            if (colType === 'int' || colType === 'fixedPoint') col.editorOptions.format = '#,##0';

            if (colType === 'float' || colType === 'decimal') {
                var decimalDigit = found ? found.decimalDigit : undefined;
                if (decimalDigit === undefined || decimalDigit === null) decimalDigit = AntLocalization.getCurrencyDecimalDigit();

                if (decimalDigit === undefined || decimalDigit === null) decimalDigit = 2;
                col.editorOptions.format = '#,##0.' + String('#').repeat(decimalDigit);
            }

            if (colType === 'percent') {
                var decimalDigit = found ? found.decimalDigit : undefined;
                // if (decimalDigit === undefined || decimalDigit === null) decimalDigit = AntLocalization.getCurrencyDecimalDigit();
                if (decimalDigit === undefined || decimalDigit === null) decimalDigit = 0;
                col.editorOptions.format = {
                    type: 'percent',
                    precision: decimalDigit
                };
            }
            // ------ EDITING END------
        });

        if (props.columns instanceof Array) {
            props.columns.forEach((rawCol) => {
                var col = columns.find((c) => c.name === 'col_' + rawCol.dataField);
                if (col) {
                    col.visible = isColumnVisible(col);
                }
            });
            keepTextColumnShown(columns);
        }

        const smartLayoutOptions = props.smartLayout && typeof props.smartLayout === 'object' ? props.smartLayout : {};
        columns = buildSmartGridLayout(columns, {
            ...smartLayoutOptions,
            rawColumns: props.columns,
            tableName,
            isItemGrid: Boolean(props.parentData),
            allowEdit: props.allowEdit || inlineActive,
            columnAutoWidth: props.columnAutoWidth ?? smartLayoutOptions.columnAutoWidth,
            columnHidingEnabled: props.columnHidingEnabled ?? smartLayoutOptions.columnHidingEnabled,
            // Nhập trực tiếp: cột sửa được không bị ẩn → có thể tràn, hiện thanh cuộn ngang thường trực.
            showScrollbar: props.showScrollbar ?? (inlineActive ? 'always' : smartLayoutOptions.showScrollbar),
            lookupFields,
            lookupBestFitWidths
        }).columns;

        // Độ rộng người dùng đã kéo:
        //  - cột có độ rộng cụ thể (cố định / tự đo theo nội dung): dùng đúng độ rộng đã lưu;
        //  - cột auto (co giãn): độ rộng đã lưu là mức TỐI THIỂU, cột vẫn nhận phần còn thừa sau khi các cột
        //    cố định lấy đủ — không co nhỏ hơn mức người dùng kéo, cũng không để khoảng trắng.
        // Thứ tự cột: nhớ vị trí theo cấu hình (để "Mặc định" trả lại) rồi xếp theo thứ tự người dùng đã kéo thả.
        columns.forEach((col, index) => {
            col._antDefaultIndex = index;
        });
        if (userColumnOrder.current) columns = applyColumnOrder(columns, userColumnOrder.current, isUserMovableColumn);

        if (allowColumnResizing) {
            const savedWidths = readSavedColWidths();
            columns.forEach((col) => {
                const saved = col.dataField && (!col.isSystemCol || isResizableSystemColumn(col)) ? savedWidths[col.dataField] : undefined;
                if (typeof saved !== 'number' || !(saved > 20)) return;
                if (col._antFlexibleWidth) {
                    // Cột auto: độ rộng đã kéo là mức tối thiểu khi chia chỗ (vẫn nhận phần thừa); không nâng minWidth
                    // của DevExtreme — người dùng phải kéo nhỏ lại được.
                    col._antUserMinWidth = saved;
                    col.width = Math.max(typeof col.width === 'number' ? col.width : 0, saved);
                    return;
                }
                // Giữ cấu hình gốc để "tự căn" (nhấp đúp vạch ngăn cột) trả cột về chế độ tự đo.
                backupAutoWidth(col);
                col.width = saved;
                if (typeof col.minWidth === 'number' && col.minWidth > saved) col.minWidth = saved;
                delete col._antBestFit;
                delete col._antFlexibleWidth;
                col._antUserWidth = true;
            });
        }
        // Nhập trực tiếp: không tự ẩn cột (kể cả Thành tiền) — tràn thì cuộn ngang. DevExtreme vẫn ẩn cột có
        // hidingPriority dù columnHidingEnabled=false, nên bỏ hẳn hidingPriority.
        if (inlineActive && props.columnHidingEnabled !== true) columns.forEach((col) => delete col.hidingPriority);

        // Cột xuống dòng khi hiển thị (giữ cả xuống dòng trong dữ liệu) — mặc định cho:
        //   - cột nhiều dòng: `multiline: true`, field dùng textArea (config/fields, addForm khi nhập trực tiếp) —
        //     ô nhập trực tiếp cũng là ô nhiều dòng;
        //   - cột văn bản dài theo tên field: *_name, *_desc, description, note (và *_description, *_note).
        // `multiline: false` trên cột để tắt.
        columns.forEach((col) => {
            if (!col.dataField || col.isSystemCol) return;
            const configured = col.rawConfig && col.rawConfig.multiline !== undefined ? col.rawConfig.multiline : col.multiline;
            if (configured === false) return;
            const inlineItem = col._antInlineField ? inlineFieldMap.get(col.dataField) : null;
            const fieldConfig = inlineItem && config && config.getCnfField ? config.getCnfField(inlineItem.dataField, tableName) : null;
            const columnFieldConfig = config && config.getCnfField ? config.getCnfField(col.dataField, tableName) : null;
            const multiline =
                configured === true ||
                isMultilineFormItem(inlineItem, fieldConfig) ||
                Boolean(columnFieldConfig && columnFieldConfig.editorType === 'textArea') ||
                Boolean(col.rawConfig && col.rawConfig.editorType === 'textArea');
            if (!multiline && !WRAP_FIELD_PATTERN.test(String(col.dataField))) return;
            if (multiline) col._antMultiline = true;
            // Nhiều dòng (textArea): giữ xuống dòng trong dữ liệu. Chỉ khớp theo tên field: xuống dòng thường.
            col.cssClass = String(col.cssClass || '')
                .split(/\s+/)
                .filter((c) => c && c !== 'ant-grid-cell-ellipsis')
                .concat(multiline ? 'ant-grid-cell-multiline' : 'ant-grid-cell-wrap')
                .join(' ');
        });
        // Đường phân cách mờ giữa các tiêu đề cột (chỗ kéo đổi độ rộng / nhấp đúp tự căn): cột dữ liệu + cột số thứ tự
        // (số lớn cần nới rộng); các cột hệ thống khác không có.
        columns.forEach((col) => {
            if (!col || (col.isSystemCol && !isResizableSystemColumn(col))) return;
            if (!String(col.cssClass || '').split(/\s+/).includes('ant-grid-col-sep')) col.cssClass = String(col.cssClass || '').concat(' ant-grid-col-sep').trim();
        });

        // Bộ lọc trên cột: loại editor theo cấu hình (chỉ cột có trên bảng của lưới — BE mới lọc được).
        columns.forEach((col) => {
            if (!columnFilterEnabled || col.isSystemCol || !col.dataField) {
                col.allowFiltering = false;
                delete col._antFilter;
                return;
            }
            let rawCol = props.columns.find((c) => c && c.dataField === col.dataField);
            if (rawCol && rawCol.rawConfig) rawCol = rawCol.rawConfig;
            // Tên danh mục như ô hiển thị: giá trị theo điều kiện (AntCondition.getValue) rồi dịch; bỏ mục bị ẩn theo setting.
            const spec = resolveColumnFilterSpec(
                col,
                rawCol,
                (name) => getFieldAccessConfig(name, tableName),
                (v) => AntLocalization.translateText(AntCondition.getValue(props.parentData, v)),
                (item) => AntCondition.isVisible(props.parentData, item) && !AntCondition.isAccessDenied(item)
            );
            if (spec) col._antFilter = spec;
            else delete col._antFilter;
            col.allowFiltering = Boolean(spec);
        });

        // Bootstrap only. Native contentReady owns the fit for committed data;
        // store callbacks may still contain a different page during React render.
        const initialSizes = calculateGridBestFit(columns, [], {
            cache: { get: gridWidthCache.get },
            measure: createGridTextMeasurer(gridContainer.current)
        });
        const initialLayout = calculateGridFlexibleWidths(columns, initialSizes, {
            width: getGridViewportWidth(gridContainer.current), instance: grid.current?.instance
        });
        getCommittedGridWidths(grid.current?.instance, columns).forEach((size, column) => initialLayout.set(column, size));
        applyGridBestFit(columns, initialLayout);
        // minWidth đưa cho DevExtreme = mức sàn khi kéo (GRID_RESIZE_FLOOR); mức tối thiểu tự chia chỗ (tiêu đề, chữ
        // danh mục...) giữ ở _antLayoutMinWidth — không chặn người dùng thu hẹp cột.
        columns.forEach((col) => {
            if (!col.dataField || col.isSystemCol) return;
            if (col._antLayoutMinWidth === undefined) col._antLayoutMinWidth = col.minWidth;
            col.minWidth = toResizeMinWidth(col.minWidth, typeof col.width === 'number' ? col.width : undefined);
        });

        return columns;
    }, [
        isRender,
        config,
        selectable,
        hasColMarkSelected,
        isColumnVisible,
        keepTextColumnShown,
        getFieldAccessConfig,
        columnFilterEnabled,
        props.showIndex,
        props.showDetail,
        props.showDetailPosition,
        props.showNote,
        props.showAttachments,
        props.showPriority,
        props.columns,
        props.customSelectionValue,
        props.rowActionWidth,
        props.rowActionsDisplay,
        gridRowActions,
        rowActionsDisplay,
        rowActionPrimaryActions,
        props.parentData,
        props.table,
        props.API,
        props.parentData,
        props.editorOptions,
        props.smartLayout,
        props.allowEdit,
        props.columnAutoWidth,
        props.columnHidingEnabled,
        props.showScrollbar,
        gridWidthCache,
        inlineActive,
        inlineFieldMap,
        allowColumnResizing,
        readSavedColWidths
    ]);

    const mainColumns = useMemo(() => initColumns(), [initColumns]);
    const mainColumnsRef = useRef(mainColumns);
    mainColumnsRef.current = mainColumns;

    const smartGridLayout = useMemo(() => {
        const smartLayoutOptions = props.smartLayout && typeof props.smartLayout === 'object' ? props.smartLayout : {};
        const financialMode = detectFinancialGrid(mainColumns, {
            ...smartLayoutOptions,
            tableName,
            isItemGrid: Boolean(props.parentData),
            allowEdit: props.allowEdit
        });

        return {
            financialMode,
            columnAutoWidth:
                props.columnAutoWidth !== undefined
                    ? props.columnAutoWidth
                    : smartLayoutOptions.columnAutoWidth !== undefined
                    ? smartLayoutOptions.columnAutoWidth
                    : false,
            columnHidingEnabled:
                props.columnHidingEnabled !== undefined
                    ? props.columnHidingEnabled
                    : inlineActive
                    ? false
                    : smartLayoutOptions.columnHidingEnabled !== undefined
                    ? smartLayoutOptions.columnHidingEnabled
                    : !financialMode,
            showScrollbar: props.showScrollbar || (inlineActive ? 'always' : smartLayoutOptions.showScrollbar) || (financialMode ? 'always' : 'onHover')
        };
    }, [mainColumns, props.smartLayout, props.columnAutoWidth, props.columnHidingEnabled, props.showScrollbar, props.parentData, props.allowEdit, tableName, inlineActive]);

    const dsGetQueryFields = useCallback(
        (opts) => {
            var ar = [];
            if (opts && opts.isDownloading) {
                if (props.showImport && props.import && props.import.mapping instanceof Array) {
                    for (let i = 0; i < props.import.mapping.length; i++) {
                        const c = props.import.mapping[i];

                        var fieldName = null;
                        if (typeof c === 'string') {
                            fieldName = String(c);
                        } else if (typeof c === 'object' && c.name) fieldName = c.name;

                        var strAlias = null;

                        var cnfTableName = c.cnfTable ? c.cnfTable : props.table ? props.table : props.API ? props.API.entityName : null;
                        var cnfFieldName = c.cnfField ? c.cnfField : fieldName;
                        var found = config.getCnfField(cnfFieldName, cnfTableName);
                        // Setting / phân quyền chặn field → không xuất ra file.
                        if (AntCondition.isAccessDenied(found) || AntCondition.isAccessDenied(getFieldAccessConfig(cnfFieldName, cnfTableName))) continue;
                        if (found) strAlias = AntLocalization.translateText(AntCondition.getValue(props.parentData, found.label));

                        let obj = {
                            field: fieldName,
                            alias: strAlias ? strAlias : undefined
                        };
                        if (c.dataType) obj.dataType = c.dataType;
                        else if (found && found.dataType) obj.dataType = found.dataType;

                        ar.push(obj);
                    }
                } else if (props.columns instanceof Array)
                    for (let i = 0; i < props.columns.length; i++) {
                        const c = props.columns[i];

                        var fieldName = null;
                        if (typeof c === 'string') {
                            fieldName = String(c);
                        } else if (typeof c === 'object' && c.dataField) fieldName = c.dataField;

                        var col1 = mainColumns.find((c1) => c1.dataField === fieldName);
                        // Cột bị setting / phân quyền chặn → không xuất ra file.
                        if (col1 && isColumnAccessDenied(col1, c && typeof c === 'object' ? (c.rawConfig ? c.rawConfig : c) : { dataField: fieldName }))
                            continue;
                        if (col1) {
                            var tableName = col1.cnfTable ? col1.cnfTable : props.table ? props.table : props.API ? props.API.entityName : null;

                            if ((col1.colType === 'join' || col1.colType === 'first' || col1.colType === 'last') && col1.fields instanceof Array) {
                                var ar2 = col1.fields
                                    .filter((fField) => {
                                        const fName = fField && typeof fField === 'object' ? fField.dataField : fField;
                                        return !(
                                            (fField && typeof fField === 'object' && AntCondition.isAccessDenied(fField)) ||
                                            AntCondition.isAccessDenied(getFieldAccessConfig(fName, tableName))
                                        );
                                    })
                                    .map((fField) => {
                                    let fFieldName = fField;
                                    if (fField && typeof fField === 'object' && fField.dataField) fFieldName = fField.dataField;

                                    let obj = {
                                        field: fFieldName,
                                        alias: fFieldName.charAt(0).toUpperCase() + fFieldName.slice(1).toLowerCase()
                                    };
                                    let found = config.getCnfField(fFieldName, tableName);
                                    if (found) {
                                        obj.alias = AntLocalization.translateText(AntCondition.getValue(props.parentData, found.label));
                                        obj.dataType = found.dataType;
                                    }

                                    return obj;
                                });
                                ar.push(...ar2);
                            } else {
                                var found = config.getCnfField(fieldName, tableName);
                                let obj = {
                                    field: fieldName,
                                    alias: col1 ? AntLocalization.translateText(col1.caption) : undefined
                                };
                                if (found && found.dataType) obj.dataType = found.dataType;
                                else if (col1.dataType) obj.dataType = col1.dataType;

                                ar.push(obj);
                            }
                        }
                    }
            } else {
                ar = ['created_at', 'checksum', 'id', 'code'];
                if (props.columns instanceof Array) {
                    for (let i = 0; i < props.columns.length; i++) {
                        const c = props.columns[i];

                        var fieldName = null;
                        if (typeof c === 'string') {
                            fieldName = String(c);
                        } else if (typeof c === 'object' && c.dataField) fieldName = c.dataField;

                        if (fieldName) {
                            var col1 = mainColumns.find((c1) => c1.dataField === fieldName);
                            if (
                                col1 &&
                                (col1.colType === 'join' || col1.colType === 'first' || col1.colType === 'last') &&
                                col1.fields instanceof Array
                            ) {
                                for (let j = 0; j < col1.fields.length; j++) {
                                    const fField = col1.fields[j];

                                    let fFieldName = fField;
                                    if (fField && typeof fField === 'object' && fField.dataField) fFieldName = fField.dataField;

                                    ar.push(fFieldName);
                                }
                            } else ar.push(fieldName);
                        }
                    }

                    ar.push(
                        ...Array.from(props.columns, (c) =>
                            typeof c === 'object' && c.defaultValue && typeof c.defaultValue === 'object' && c.defaultValue.rowField
                                ? c.defaultValue.rowField
                                : undefined
                        )
                    );
                }
            }

            if (props.showDetail) {
                if (
                    typeof props.showDetail === 'object' &&
                    props.showDetail.key &&
                    !ar.includes(props.showDetail.key) &&
                    !ar.some((a) => a && typeof a === 'object' && a.field === props.showDetail.key)
                ) {
                    ar.push(props.showDetail.key);
                } else if (props.showDetail instanceof Array) {
                    for (let i = 0; i < props.showDetail.length; i++) {
                        const item = props.showDetail[i];

                        if (
                            typeof item === 'object' &&
                            item.key &&
                            !ar.includes(item.key) &&
                            !ar.some((a) => a && typeof a === 'object' && a.field === item.key)
                        ) {
                            ar.push(item.key);
                        }
                    }
                }
            }

            if (props.queryFields instanceof Array) ar.push(...props.queryFields);
            if (props.selectFields instanceof Array) ar.push(...props.selectFields);

            if (props.getQueryFields) {
                var fields = props.getQueryFields();
                if (fields instanceof Array) ar.push(...fields);
            }

            if (props.columns) ar.push(...AntJSON.getKeys(props.columns));

            if (props.edit) ar.push(...AntJSON.getKeys(props.edit));
            if (props.showDetail) ar.push(...AntJSON.getKeys(props.showDetail));
            if (props.scheduler) ar.push(...AntJSON.getKeys(props.scheduler));
            if (props.cardview) ar.push(...AntJSON.getKeys(props.cardview));
            if (props.cellStyles) ar.push(...AntJSON.getKeys(props.cellStyles));
            if (props.flashConds) ar.push(...AntJSON.getKeys(props.flashConds));
            if (props.rowStyles) ar.push(...AntJSON.getKeys(props.rowStyles));

            if (props.rowActions) ar.push(...AntJSON.getKeys(props.rowActions));

            if (gridRowActions) ar.push(...AntJSON.getKeys(gridRowActions));

            if (props.cardview) {
                for (let i = 0; i < config.cnfFields.length; i++) {
                    const cnf = config.cnfFields[i];

                    if (ar.includes(cnf.dataField)) {
                        if (cnf.visibleOnMain) ar.push(...AntJSON.getKeys(cnf.visibleOnMain));
                        if (cnf.visibleSelf) ar.push(...AntJSON.getKeys(cnf.visibleSelf));
                    }
                }
            }

            ar = ar.flat();
            ar = ar
                .filter((v) => Boolean(v))
                .filter((v, index, self) => {
                    return self.indexOf(v) === index;
                });

            let tmpAr = ar.map((a) => {
                if (typeof a === 'object' && a) return a.field;
                return a;
            });
            tmpAr = tmpAr.filter((a) => config.hasField(a));
            tmpAr = AntArray.distinct(tmpAr);

            ar = ar.filter((a) => (typeof a === 'string' && tmpAr.includes(a)) || (typeof a === 'object' && a && tmpAr.includes(a.field)));

            return ar;
        },
        [
            config,
            mainColumns,
            gridRowActions,
            getFieldAccessConfig,
            isColumnAccessDenied,
            props.showImport,
            props.import,
            props.table,
            props.API,
            props.parentData,
            props.columns,
            props.showDetail,
            props.queryFields,
            props.selectFields,
            props.getQueryFields,
            props.edit,
            props.scheduler,
            props.cardview,
            props.cellStyles,
            props.flashConds,
            props.rowStyles,
            props.rowActions
        ]
    );

    const queryFields = useMemo(() => dsGetQueryFields(), [dsGetQueryFields]);

    const dsGetSearchConditions = useCallback(() => {
        return searchConditions.current ? JSON.parse(stringify(searchConditions.current)) : {};
    }, []);

    const dsGetParentSearchConditions = useCallback(() => {
        return searchParentConditions ? JSON.parse(stringify(searchParentConditions)) : {};
    }, [searchParentConditions]);

    const dsGetFilteredGroupConditions = useCallback(() => {
        if (filteredGroup && filteredGroup.searchConditions) return filteredGroup.searchConditions;

        return {};
    }, [filteredGroup]);

    const dsGetOrderBy = useCallback(() => {
        return sortByColumn.current;
    }, []);

    const dsGetOrderings = useCallback(() => {
        if (props.ordering instanceof Array) return props.ordering;

        if (props.orderBy || props.orderType)
            return [
                {
                    name: props.orderBy,
                    type: props.orderType ? props.orderType : 'asc'
                }
            ];

        return null;
    }, [props.ordering, props.orderBy, props.orderType]);

    const dsGetOrderType = useCallback(() => {
        return sortType.current;
    }, []);

    const _baseInitMenuItem = useCallback(
        (obj) => {
            if (!obj) return null;

            var current = {
                valueExpr: obj.valueExpr,
                displayExpr: obj.displayExpr,
                icon: obj.icon,
                text: obj.label
                    ? AntLocalization.translateText(AntCondition.getValue(props.parentData, obj.label))
                    : AntLocalization.translateText(AntCondition.getValue(props.parentData, obj.text)),

                value: obj.value,
                width: obj.width,
                stylingMode: obj.stylingMode ? obj.stylingMode : 'text'
            };

            if (obj.items instanceof Array && obj.items.length > 0) {
                current.items = [];

                obj.items.forEach((i) => {
                    var child = _baseInitMenuItem(i);
                    if (child) current.items.push(child);
                });
            }
            return current;
        },
        [props.parentData]
    );

    const baseInitMenuItem = useCallback(
        (mItem) => {
            if (!mItem || !mItem.isMenu) return;

            var m = _baseInitMenuItem(mItem);
            if (m) {
                return {
                    ...mItem,
                    widget: 'Menu',
                    location: mItem.location,
                    items: [m]
                };
            }
        },
        [_baseInitMenuItem]
    );

    const initActions = useCallback(() => {
        var actions = props.actionItems instanceof Array ? props.actionItems : [];
        if (actions instanceof Array)
            actions = actions.map((c) => {
                var nItem = JSON.parse(stringify(c));

                nItem.text = AntLocalization.translateText(nItem.text);
                if (nItem.isMenu) {
                    nItem = baseInitMenuItem(nItem);
                } else if (nItem.widget === 'ButtonGroup') {
                    if (nItem.items instanceof Array) {
                        nItem.items = nItem.items.filter((item) => {
                            return AntCondition.isVisible(props.parentData, item);
                        });
                    }

                    if (nItem.defaultSelect && (typeof nItem.defaultSelect === 'object' || nItem.defaultSelect instanceof Array))
                        nItem.defaultSelect = AntCondition.getValue(props.parentData, nItem.defaultSelect);
                }

                return nItem;
            });

        actions = actions.filter((item) => {
            var isVisible = AntCondition.isVisible(props.parentData, item);

            if (
                isVisible &&
                item.visibleOnMain &&
                props.parentData &&
                Object.keys(props.parentData).length > 0 &&
                (props.parentData.id || props.parentData.code)
            ) {
                let vObj = item.visibleOnMain;
                if (item.visibleOnMain instanceof Array) {
                    vObj = item.visibleOnMain.find(
                        (v) =>
                            v.table === props.parentTable ||
                            (v.table instanceof Array && v.table.includes(props.parentTable)) ||
                            (v.tables instanceof Array && v.tables.includes(props.parentTable))
                    );

                    if (vObj) vObj = vObj.value;
                }
                if (vObj)
                    isVisible = AntCondition.isVisible(props.parentData, {
                        visible: vObj
                    });
            }

            if (
                isVisible &&
                typeof item.visible === 'object' &&
                item.visible &&
                typeof item.visible.whenAction === 'object' &&
                item.visible.whenAction
            ) {
                isVisible = AntCondition.isVisible(searchConditions.current, {
                    visible: {
                        when: {
                            ...item.visible.whenAction
                        }
                    }
                });
            }
            return isVisible;
        });
        actions.forEach((item) => {
            item.editable = AntCondition.isEditable(props.parentData, item);
        });
        return actions;
    }, [isRender, baseInitMenuItem, props.actionItems, props.parentData]);

    const mainActions = useMemo(() => initActions(), [initActions]);

    const initDefaultFilteredGroup = useCallback(() => {
        if (mainActions instanceof Array) {
            var item = mainActions.find((i) => i.widget === 'ButtonGroup');
            if (item && item.items instanceof Array && item.items.length > 0) {
                if (props.filteredGroup) {
                    var found = item.items.find((i) => i.name === props.filteredGroup);
                    if (found) return found;
                }
                if (item.defaultSelect) {
                    var found = item.items.find((i) => i.name === item.defaultSelect);
                    if (found) return found;
                }
                if (item && item.items instanceof Array) {
                    var found = item.items.find((i) => i.default === true);
                    if (found) return [found];
                }
                if (item.items.length > 0) {
                    return item.items[0];
                }
            }
        }

        return null;
    }, [mainActions, props.filteredGroup]);

    useEffect(() => {
        if (!filteredGroup) setFilteredGroup(defaultStates.filteredGroup ? JSON.parse(defaultStates.filteredGroup) : initDefaultFilteredGroup());
    }, [mainActions, props.filteredGroup]);

    const isShowEdittedRowsOnly = useCallback(() => {
        return filterBySelected.current;
    }, []);

    const isAllowQuery = useCallback(() => {
        if (showCardView.current) return false;
        if (showScheduler.current) return false;

        if (props.searchConditionsRequired && (!searchConditions.current || Object.keys(searchConditions.current).length === 0)) return false;

        if (props.isAllowQuery && typeof props.isAllowQuery === 'function') return props.isAllowQuery();

        return true;
    }, [props.searchConditionsRequired, props.isAllowQuery]);

    const isAllowSchedulerQuery = useCallback(() => {
        if (!showScheduler.current) return false;

        if (props.searchConditionsRequired && (!searchConditions.current || Object.keys(searchConditions.current).length === 0)) return false;

        if (props.isAllowQuery && typeof props.isAllowQuery === 'function') return props.isAllowQuery();

        return true;
    }, [props.searchConditionsRequired, props.isAllowQuery]);

    const isAllowCardViewQuery = useCallback(() => {
        if (!showCardView.current) return false;

        if (props.searchConditionsRequired && (!searchConditions.current || Object.keys(searchConditions.current).length === 0)) return false;

        if (props.isAllowQuery && typeof props.isAllowQuery === 'function') return props.isAllowQuery();

        return true;
        return true;
    }, [props.searchConditionsRequired, props.isAllowQuery]);

    const getKeyField = useCallback(() => {
        return props.keyExpr ? props.keyExpr : 'id';
    }, [props.keyExpr]);

    const getEditedData = useCallback(() => {
        if (dataSource.current) return dataSource.current.getEditedData();
        return null;
    }, []);

    const getCachedData = useCallback(() => {
        if (dataSource.current) return dataSource.current.getCachedData();
        return null;
    }, []);

    const modifiedRows = useCallback(
        (inColumnOnly) => {
            var data = dataSource.current.getEditedData();
            if (data instanceof Array) {
                if (inColumnOnly && props.columns instanceof Array) {
                    for (let i = 0; i < data.length; i++) {
                        var row = data[i];
                        var keys = Object.keys(row);

                        for (let j = 0; j < keys.length; j++) {
                            const field = keys[j];

                            var isValid = field === props.keyExpr || (row[field] !== undefined && props.columns.some((c) => c.dataField === field));
                            if (!isValid) row[field] = undefined;
                        }
                    }
                }
            }
            return data;
        },
        [props.columns]
    );

    const cleanData = useCallback(() => {
        filterBySelected.current = false;
        hasSelectedRowsRef.current = false;
        if (actionBar.current) actionBar.current.resetItems({ filterBySelected: false, hasSelectedRows: false });
        dataSource.current.reset(null, true, true);
    }, []);
    const repaint = useCallback(() => {
        if (grid.current && grid.current.instance) {
            grid.current.instance.repaint();
        }
    }, []);

    const refreshAndPaint = useCallback(async () => {
        if (grid.current && grid.current.instance) {
            await dataSource.current.willGetLastResult();
            grid.current.instance.refresh(true);
        }
    }, []);

    const isDataLoading = useCallback(() => {
        return Boolean(loading.current);
    }, []);

    const isDataLoaded = useCallback(() => {
        return Boolean(loaded.current);
    }, []);

    const onDatasourceLoading = useCallback(() => {
        loading.current = true;
    }, []);

    const onDatasourceGotData = useCallback((data) => {
        // Mark new data, but wait until native DataSource has committed its page.
        // Resizing here races contentReady, which can still expose the old rows.
        invalidateGridBestFit(grid.current?.instance);
        if (scheduler.current) scheduler.current.reload();
        if (cardview.current) cardview.current.reload();
    }, []);

    const clearSelection = useCallback(() => {
        selectedRowsRef.current = [];
        if (grid.current && grid.current.instance) grid.current.instance.clearSelection();
    }, []);

    const getSelectedRows = useCallback(() => {
        if (grid.current && grid.current.instance) return grid.current.instance.getSelectedRowsData().filter((row) => !isInlineDraftRow(row));
        return [];
    }, []);

    const getSelectedObjectId = useCallback(() => {
        var key = props.keyExpr ? props.keyExpr : 'id';
        var data = getSelectedRows();
        if (data && data instanceof Array && data.length == 1 && data[0][key]) return data[0][key];
        return null;
    }, [props.keyExpr, getSelectedRows]);

    const showColumnChooser = useCallback(() => {
        if (grid.current && grid.current.instance) grid.current.instance.showColumnChooser();
        return [];
    }, []);

    const hideColumnChooser = useCallback(() => {
        if (grid.current && grid.current.instance) grid.current.instance.hideColumnChooser();
    }, []);

    // Số dòng "đã chọn" theo đúng cách onFiltering lọc khi bật "Đã chọn":
    // selectable = dòng DevExtreme đang chọn; cột isMarkSelected = dòng đã sửa trong store.
    const countSelectedRows = useCallback(
        (selectedRowsData) => {
            if (selectable) return selectedRowsData instanceof Array ? selectedRowsData.length : 0;
            if (hasColMarkSelected) {
                const edited = getEditedData();
                return edited instanceof Array ? edited.length : 0;
            }
            return 0;
        },
        [selectable, hasColMarkSelected, getEditedData]
    );

    // Đồng bộ ẩn/hiện checkbox "Đã chọn". Bỏ chọn hết khi đang bật lọc thì tắt lọc để không
    // kẹt ở danh sách rỗng mà checkbox đã ẩn.
    const syncHasSelectedRows = useCallback((selectedCount) => {
        const has = selectedCount > 0;
        const shouldTurnOffFilter = !has && Boolean(filterBySelected.current);
        if (has === hasSelectedRowsRef.current && !shouldTurnOffFilter) return;
        hasSelectedRowsRef.current = has;

        if (shouldTurnOffFilter) filterBySelected.current = false;
        // Tắt checkbox qua AntGridBar: effect của nó gọi onFilterBySelected(false) và nạp lại.
        if (actionBar.current)
            actionBar.current.resetItems(shouldTurnOffFilter ? { hasSelectedRows: has, filterBySelected: false } : { hasSelectedRows: has });
        else if (shouldTurnOffFilter && loaded.current && refreshRef.current) refreshRef.current();
    }, []);

    const resetActionBar = useCallback(
        (selectedRowsData) => {
            var rows = selectedRowsData ? selectedRowsData : getSelectedRows();
            selectedRowsRef.current = rows;
            syncHasSelectedRows(countSelectedRows(rows));
            const contextualBatchActions = getContextualBatchActions(gridBatchActions, rows);
            const actionPermissions = getSelectionActionPermissions(rows, {
                canEdit: canEditAction,
                canDelete: canDeleteAction
            });
            if (actionBar.current) {
                actionBar.current.resetItems({
                    enableEdit: actionPermissions.enableEdit,
                    enableDelete: actionPermissions.enableDelete,
                    contextualBatchActions
                });
            }
            // var isSelectedAll = dataSource.current ? dataSource.current.isSelectedAll() : false;
            // setSelectedAll(isSelectedAll);
        },
        [getSelectedRows, countSelectedRows, syncHasSelectedRows, gridBatchActions, canEditAction, canDeleteAction]
    );

    useEffect(() => {
        if (!selectable) {
            clearSelection();
            resetActionBar([]);
        } else resetActionBar();
    }, [selectable, clearSelection, resetActionBar]);

    const resetSelectedActionGroups = useCallback((selectedGroup) => {
        if (actionBar.current) {
            actionBar.current.resetSelectGroups(selectedGroup);
        }
    }, []);

    const selectAll = useCallback(() => {
        if (grid.current && grid.current.instance) {
            // lockUpdatedEvent.current = true;

            if (hasColMarkSelected) {
                grid.current.instance.beginUpdate();
                var rows = getCachedData();
                rows.forEach((r) => {
                    selectRow(r);
                });
                grid.current.instance.endUpdate();
            } else if (selectable && !isRemotePaging) {
                grid.current.instance.selectAll();
            }

            // lockUpdatedEvent.current = false;

            if (props.onDataSourceEdited) props.onDataSourceEdited();
        }
    }, [hasColMarkSelected, getCachedData, selectable, isRemotePaging, props.onDataSourceEdited]);

    const unSelectAll = useCallback(() => {
        if (grid.current && grid.current.instance) {
            // lockUpdatedEvent.current = true;

            if (hasColMarkSelected) {
                grid.current.instance.beginUpdate();
                var rows = getEditedData();
                rows.forEach((r) => {
                    unSelectRow(r);
                });
                if (grid.current && grid.current.instance) grid.current.instance.endUpdate();
            } else if (selectable && !isRemotePaging) {
                grid.current.instance.deselectAll();
            }
            // setLockUpdatedEvent(false);

            if (props.onDataSourceEdited) props.onDataSourceEdited();

            grid.current.instance.endUpdate();
        }
    }, [hasColMarkSelected, getEditedData, selectable, isRemotePaging, props.onDataSourceEdited]);

    const onSelectAll = useCallback(
        (value) => {
            if (value) selectAll();
            else unSelectAll();
        },
        [selectAll, unSelectAll]
    );

    const renderDetailLink = useCallback(
        (rowData) => {
            var ar = [];
            if (props.showDetail && props.showDetail instanceof Array) {
                for (let i = 0; i < props.showDetail.length; i++) {
                    const item = props.showDetail[i];
                    ar.push(item);
                }
            } else if (props.showDetail && typeof props.showDetail === 'object')
                ar.push({
                    when: props.showDetail.when,
                    whenType: props.showDetail.whenType,
                    url: props.showDetail.url,
                    key: props.showDetail.key
                });

            for (let i = 0; i < ar.length; i++) {
                const item = ar[i];

                if (item.when) {
                    var isValid = true;

                    var isValid = AntCondition.isValid(rowData, {
                        when: item.when,
                        whenType: item.whenType
                    });

                    if (!isValid) continue;
                }

                var url = item.url ? item.url : null;
                var key = null;

                if (url) {
                    if (item.key) {
                        key = item.key;
                        if (!rowData[key]) continue;
                    }

                    if (!key || !rowData[key]) key = 'code';
                    if (!key || !rowData[key]) key = 'id';
                    if (!key || !rowData[key]) key = props.keyExpr;

                    if (key && rowData[key]) {
                        var value = rowData[key];

                        var linkUrl = format('{0}/{1}', url, value);
                        return {
                            url: linkUrl,
                            value: value,
                            rowData: rowData
                        };
                    }
                }
            }

            return null;
        },
        [props.keyExpr, props.showDetail]
    );

    const showEditPopup = useCallback(
        async (id) => {
            if (editPopup.current) {
                var defaultObj = await editPopup.current.showById(id);
                if (props.edit && props.edit.onEditPrepared) props.edit.onEditPrepared(defaultObj);
            }
        },
        [props.edit]
    );

    const onRowDblClick = useCallback(
        (e) => {
            if (e && isInlineDraftRow(e.data)) return;
            if (e && e.data) {
                var lnk = renderDetailLink(e.data);
                if (lnk && lnk.url) {
                    navigate(lnk.url);
                    return;
                }
            }
            const canEditRow = getSelectionActionPermissions(e.data ? [e.data] : [], { canEdit: canEditAction }).enableEdit;
            if (canEditRow && e.data && e.data.id) showEditPopup(e.data.id);

            if (props.onRowDblClick) props.onRowDblClick(e);
        },
        [renderDetailLink, showEditPopup, props.onRowDblClick, canEditAction]
    );

    const onDataSourceEdited = useCallback(
        async (keyValue, values) => {
            var key = props.keyExpr ? props.keyExpr : 'id';

            if (!selectable) syncHasSelectedRows(countSelectedRows());

            if (props.allowAutoUpdate) {
                var obj = dataSource.current ? dataSource.current.getCachedItem(keyValue) : null;
                if (obj) {
                    var result = await props.API.postUpdateValidation(
                        {
                            [key]: keyValue,
                            checksum: obj.checksum
                        },
                        values
                    );
                    var error = config.translateFirstError(result, {
                        vi: 'Dữ liệu không hợp lệ!',
                        en: 'Invalid data !',
                        fr: 'Données invalides !',
                        es: '¡Datos inválidos!',
                        id: 'Data tidak valid!',
                        ja: '無効なデータ！',
                        zh: '无效数据！',
                        ko: '잘못된 데이터!',
                        hi: 'अमान्य डेटा!',
                        ar: 'بيانات غير صالحة!'
                    });

                    if (!error) {
                        var result = await props.API.postUpdate(
                            {
                                [key]: keyValue,
                                checksum: obj.checksum
                            },
                            values
                        );
                        if (!result || result.error || !result.data || !result.data.updated)
                            error = config.translateFirstError(result, {
                                vi: 'Dữ liệu không hợp lệ!',
                                en: 'Invalid data !',
                                fr: 'Données invalides !',
                                es: '¡Datos inválidos!',
                                id: 'Data tidak valid!',
                                ja: '無効なデータ！',
                                zh: '无效数据！',
                                ko: '잘못된 데이터!',
                                hi: 'अमान्य डेटा!',
                                ar: 'بيانات غير صالحة!'
                            });
                    }

                    // this.refresh(true);
                }
            } else {
                if (props.columns instanceof Array) {
                    var row = getEditedData().find((r) => r[key] === keyValue);
                    if (row) {
                        var cols = props.columns
                            .filter((col) => col.dataField)
                            .map((col) => {
                                return {
                                    ...col,
                                    index: col.formulaIndex !== undefined ? col.formulaIndex : 0
                                };
                            })
                            .sort((a, b) => (a.index > b.index ? 1 : -1));

                        for (let i = 0; i < cols.length; i++) {
                            const col = cols[i];
                            if (col.defaultValue && col.defaultValue.minValue !== undefined && row[col.dataField] === undefined) {
                                await dataSource.current.updateItem(keyValue, {
                                    [col.dataField]: col.defaultValue.minValue
                                });
                                return;
                            }
                            if (col.defaultValue && col.defaultValue.value !== undefined && row[col.dataField] === undefined) {
                                await dataSource.current.updateItem(keyValue, {
                                    [col.dataField]: col.defaultValue.value
                                });
                                return;
                            }

                            if (col.formula instanceof Array) {
                                var fm = col.formula[0];
                                var defaultNullValue =
                                    col.formula[1] !== undefined && col.formula[1] !== null && typeof col.formula[1] === 'number'
                                        ? col.formula[1]
                                        : 0;

                                var value = calculator.execNum(row, fm, defaultNullValue);
                                if (value !== row[col.dataField]) {
                                    await dataSource.current.updateItem(keyValue, { [col.dataField]: value }, { byPassEvent: true });
                                    row = getEditedData().find((r) => r[key] === keyValue);
                                }
                            }
                        }
                    }
                }
            }
            // if (!lockUpdatedEvent)
            if (props.onDataSourceEdited)
                props.onDataSourceEdited({
                    field: keyValue,
                    value: values
                });
        },
        [config, getEditedData, selectable, countSelectedRows, syncHasSelectedRows, props.keyExpr, props.allowAutoUpdate, props.API, props.columns, props.onDataSourceEdited]
    );

    const onCellValueChanged = useCallback((cell, e) => {
        cell.setValue(e.value);
    }, []);
    const onStartSearchText = useCallback(() => {
        setSearchBarFocused(true);
    }, []);

    const onEndScanBarcode = useCallback(() => {
        // dsSetPageIndex(0);
    }, [dsSetPageIndex]);

    const onActionDownload = useCallback(() => {
        dataSource.current.callDownloadAPI();
    }, []);

    const onActionDelete = useCallback(() => {
        const rows = getSelectedRows();
        if (getSelectionActionPermissions(rows, { canDelete: canDeleteAction }).enableDelete && deletePopup.current)
            deletePopup.current.show(rows);
    }, [getSelectedRows, canDeleteAction]);

    const onBatchAction = useCallback(
        (event) => {
            const actionCode = event?.name || event?.code;
            const action = gridBatchActions.find((item) => item.code === actionCode);
            const rows = selectedRowsRef.current instanceof Array ? selectedRowsRef.current : getSelectedRows();
            if (action && rows.length > 0 && batchActionPopup.current) batchActionPopup.current.show(action, rows);
        },
        [getSelectedRows, gridBatchActions]
    );

    const onActionImport = useCallback(() => {
        if (importPopup.current) importPopup.current.show(searchParentConditions);
    }, [searchParentConditions]);

    const onFiltering = useCallback(
        (e) => {
            var rows = e.data;
            var totalCount = e.totalCount;

            if (rows instanceof Array) {
                if (filterBySelected.current) {
                    var key = props.keyExpr ? props.keyExpr : 'id';

                    if (selectable) {
                        const selectedRows = selectedRowsRef.current instanceof Array ? selectedRowsRef.current : getSelectedRows();
                        const selectedPage = getSelectedRowsPage(rows, selectedRows, {
                            keyExpr: key,
                            pageSize: dsGetPageSize(),
                            pageIndex: dsGetPageIndex()
                        });
                        rows = selectedPage.data;
                        totalCount = selectedPage.totalCount;
                    } else if (hasColMarkSelected) {
                        var mRows = modifiedRows();
                        if (mRows instanceof Array) {
                            // mRows = mRows.filter((r) => {
                            //     var value = r[markSelectedField.current];
                            //     if (value === null || value === undefined) return false;
                            //     if (typeof value === 'string' && String(value).trim() === '') return false;
                            //     if (typeof value === 'number' && parseFloat(value) == 0) return false;
                            //     if (typeof value === 'bigint' && parseInt(value) == 0) return false;

                            //     return true;
                            // });

                            rows = rows.filter((r) => {
                                var found = mRows.find((s) => s[key] === r[key]);
                                return found !== null && found !== undefined;
                            });
                        }
                    }
                    if (!selectable) {
                        totalCount = rows.length;
                        const pageSize = Math.max(1, Number(dsGetPageSize()) || rows.length || 1);
                        const pageIndex = dsGetPageIndex();
                        rows = rows.slice(pageIndex * pageSize, (pageIndex + 1) * pageSize);
                    }
                }

                // var isRemotePaging = props.remotePaging !== undefined ? props.remotePaging : true;
                // if (isRemotePaging) rows = rows.slice(0, dsGetPageSize());
                return { data: rows, totalCount: totalCount };
            }
            return { data: [], totalCount: 0 };
        },
        [getSelectedRows, dsGetPageSize, dsGetPageIndex, modifiedRows, hasColMarkSelected, props.keyExpr, selectable]
    );

    const onActionAdd = useCallback(async () => {
        if (addPopup.current) {
            let obj = { ...props.parentData, ...searchParentConditions };
            if (props.add && props.add.onCustomDefaultData) obj = props.add.onCustomDefaultData(obj);

            var defaultObj = await addPopup.current.show(obj);
            if (props.add && props.add.onAddPrepared) props.add.onAddPrepared(defaultObj);
        }
    }, [searchParentConditions, props.add]);

    const onActionEdit = useCallback(() => {
        const rows = getSelectedRows();
        if (!getSelectionActionPermissions(rows, { canEdit: canEditAction }).enableEdit) return;
        let id = getSelectedObjectId();
        showEditPopup(id);
    }, [getSelectedRows, getSelectedObjectId, showEditPopup, canEditAction]);

    const resetVisibility = useCallback(
        (visible) => {
            if (grid.current && grid.current.instance) {
                var oldVisible = grid.current.instance.option('visible');
                if (oldVisible != visible) grid.current.instance.option('visible', visible);
            }
            if (props.showActionBar != false && actionBar.current) actionBar.current.resetVisibility(visible);
        },
        [props.showActionBar]
    );

    const resetDisabled = useCallback(
        (disabled) => {
            if (grid.current && grid.current.instance) {
                var oldDisabled = grid.current.instance.option('disabled');
                if (oldDisabled != disabled) grid.current.instance.option('disabled', disabled);
            }
            if (props.showActionBar != false && actionBar.current) actionBar.current.resetDisabled(disabled);
        },
        [props.showActionBar]
    );

    const getDataRowActions = useCallback(() => {
        if (dataSource.current && dataSource.current.isQuerried()) {
            let actions = dataSource.current
                .getCurrentData()
                .map((r) => (r.actions instanceof Array ? r.actions.filter((a) => Boolean(a.visible)).map((a) => a.name) : []))
                .flat();

            actions = actions.filter((a, i) => actions.indexOf(a) === i);
            return actions;
        }
        return null;
    }, []);

    const getActionColumnWidth = useCallback(() => {
        if (isBatchOnlyRowActions(rowActionsDisplay)) return 0;
        if (props.rowActionWidth) return props.rowActionWidth;

        if (dataSource.current && dataSource.current.isQuerried()) {
            let widths = dataSource.current
                .getCurrentData()
                .filter((row) => row.actions instanceof Array)
                .map((row) => {
                    row.actions = row.actions.filter((a) => Boolean(a.visible));
                    row.actions = row.actions.filter((a) => gridRowActions.some((rAct) => rAct.code === a.name));
                    return row;
                })
                .filter((row) => row.actions.length > 0)
                .map((row) => {
                    const rowActions = gridRowActions
                        .filter((rAct) => row.actions.some((a) => rAct.code === a.name))
                        .map((rAct) => {
                            if (
                                [
                                    'actionDelete',
                                    'actionCancel',
                                    'actionPost',
                                    'actionApprove',
                                    'actionReject',
                                    'actionClose',
                                    'actionRelease'
                                ].includes(rAct.code) &&
                                !rAct.name
                            )
                                rAct.width = 30;
                            return rAct;
                        });

                    if (rowActionsDisplay === 'menu') return ROW_ACTION_MENU_WIDTH;

                    const inlineActions =
                        rowActionsDisplay === 'smart'
                            ? rowActions.filter((action) => rowActionPrimaryActions.includes(action.code)).slice(0, 1)
                            : rowActions;
                    const hasOverflowActions = rowActions.length > inlineActions.length;
                    let width = inlineActions.reduce((total, action) => total + (action.width ? action.width : 60) + 8, 0);
                    if (hasOverflowActions) width += ROW_ACTION_MENU_WIDTH + (inlineActions.length > 0 ? 4 : 0);

                    return width;
                });

            return widths.length > 0 ? Math.max.apply(Math, widths) : 0;
        }
        return 0;
    }, [props.rowActionWidth, gridRowActions, rowActionsDisplay, rowActionPrimaryActions]);

    const resetPager = useCallback(() => {
        if (grid.current && grid.current.instance && props.pagerHideable) {
            var hidePager = dataSource.current && dataSource.current.isOnePageOnly();

            var newValue = !hidePager;

            var oldValue = grid.current.instance.option('paging.visible');
            if (oldValue !== newValue) grid.current.instance.option('pager.visible', newValue);
        }
    }, []);

    const resetColumnVisibility = useCallback(() => {
        if (columnLayoutFrozen.current) return;
        if (grid.current && grid.current.instance) {
            const targets = mainColumns.filter((col) => !col.isSystemCol || col.name === 'priority');
            targets.forEach((col) => {
                col.visible = isColumnVisible(col);
            });
            keepTextColumnShown(mainColumns);
            targets.forEach((col) => {
                var oldValue = grid.current.instance.columnOption(col.name, 'visible');
                if (oldValue !== col.visible) {
                    grid.current.instance.columnOption(col.name, 'visible', col.visible);
                }
            });
        }
    }, [isColumnVisible, keepTextColumnShown, mainColumns]);

    const resetActionColumn = useCallback(() => {
        if (grid.current && grid.current.instance) {
            if (gridRowActions instanceof Array)
                mainColumns.forEach((col) => {
                    if (col.isSystemCol && col.name === 'actions') {
                        var newValue = getActionColumnWidth();
                        if (newValue) {
                            var oldValue = grid.current.instance.columnOption(col.name, 'width');
                            if (oldValue !== newValue) grid.current.instance.columnOption(col.name, 'width', newValue);
                        }

                        var actions = getDataRowActions();
                        if (actions instanceof Array) {
                            var oldValue = grid.current.instance.columnOption(col.name, 'visible');
                            if (oldValue !== Boolean(actions.length))
                                grid.current.instance.columnOption(col.name, 'visible', Boolean(actions.length));
                        }
                    }
                });
        }
    }, [mainColumns, gridRowActions, getActionColumnWidth, getDataRowActions]);

    const resetColumnEditable = useCallback(() => {
        if (grid.current) {
            if (grid.current.instance) {
                mainColumns.forEach((col) => {
                    if (!col.isSystemCol) {
                        var editable = Boolean(col.allowEditing);
                        var rawCol = props.columns.find((c) => c.dataField === col.dataField);
                        if (rawCol && rawCol.rawConfig) rawCol = rawCol.rawConfig;

                        if (rawCol) {
                            editable = rawCol.editable !== undefined ? Boolean(rawCol.editable) : editable;

                            if (typeof rawCol.editable === 'object') {
                                if (rawCol.editable.type === 'action' && rawCol.editable.field) {
                                    editable = false;
                                    var condKey = Object.keys(searchConditions.current).find((k) => k === rawCol.editable.field);
                                    if (condKey && searchConditions.current[condKey] !== undefined)
                                        editable = searchConditions.current[condKey] === rawCol.editable.value;
                                } else if (props.parentData) {
                                    editable = AntCondition.isEditable(props.parentData, rawCol);
                                }
                            }
                        }

                        var oldValue = grid.current.instance.columnOption(col.name, 'allowEditing');
                        if (oldValue !== editable) grid.current.instance.columnOption(col.name, 'allowEditing', editable);
                    }
                });
            }
        }
    }, [props.columns, props.parentData, mainColumns]);

    const renderCheckboxCell = useCallback((cell) => {
        return <CheckBox value={cell.value} hoverStateEnabled={false} activeStateEnabled={false} focusStateEnabled={false} />;
    }, []);

    const renderSmartTextCell = useCallback((cell) => {
        let displayValue = cell.text;
        if (displayValue === undefined || displayValue === null || displayValue === '') {
            if (cell.displayValue !== undefined && cell.displayValue !== null) displayValue = cell.displayValue;
            else displayValue = cell.value;
        }
        if (displayValue instanceof Array) displayValue = displayValue.filter((value) => value !== null && value !== undefined && value !== '').join(' ');
        if (displayValue === undefined || displayValue === null) displayValue = '';

        return (
            <div className="ant-grid-cell-text ant-grid-cell-text-wrap-2" title={typeof displayValue === 'string' ? displayValue : undefined}>
                {displayValue}
            </div>
        );
    }, []);

    const renderDetailCell = useCallback(
        (cell) => {
            var row = cell.row;
            var rowData = cell.row.data;
            if (isInlineDraftRow(rowData)) return <div></div>;

            var lnk = renderDetailLink(rowData);
            if (lnk) return <AntGridLink value={lnk.value} row={row} rowData={rowData} linkUrl={lnk.url} newWindow={props.showDetailOnNewWindow} />;

            return <div></div>;
        },
        [renderDetailLink, props.showDetailOnNewWindow]
    );

    const renderCustomFormatCell = useCallback(
        (cell) => {
            let fieldName = cell.column.dataField;

            var row = cell.row;
            var rowData = cell.row.data;

            let displayValue = rowData[fieldName];
            if (cell.column.calculateDisplayValue) displayValue = cell.column.calculateDisplayValue(rowData);

            let oStyle = {};

            if (rowData.isBold) oStyle.fontWeight = 'bold';

            if (rowData.format) {
                if (rowData.format.marginLeft) oStyle.marginLeft = rowData.format.marginLeft;
            }
            return (
                <div className="ant-grid-cell-text ant-grid-cell-text-ellipsis" style={oStyle}>
                    {displayValue}
                </div>
            );
        },
        [renderDetailLink, props.showDetailOnNewWindow]
    );

    const renderBoldCell = useCallback(
        (cell) => {
            let fieldName = cell.column.dataField;

            var row = cell.row;
            var rowData = cell.row.data;

            let displayValue = rowData[fieldName];
            if (cell.column.calculateDisplayValue) displayValue = cell.column.calculateDisplayValue(rowData);

            if (rowData.isBold)
                return (
                    <div className="ant-grid-cell-text ant-grid-cell-text-ellipsis" style={{ fontWeight: 'bold' }}>
                        {displayValue}
                    </div>
                );
            return <div className="ant-grid-cell-text ant-grid-cell-text-ellipsis">{displayValue}</div>;
        },
        [renderDetailLink, props.showDetailOnNewWindow]
    );

    const renderCustomTemplate = useCallback(
        (cell) => {
            const dataField = cell.column.dataField;
            const fn = props.cellRenders ? props.cellRenders[dataField] : undefined;

            // displayValue: ưu tiên text/displayValue do DevExtreme đã chạy calculateDisplayValue +
            // format/lookup. Với cột join/lookup/values mapping → đây mới là giá trị người xem thấy.
            let displayValue = cell.text;
            if (displayValue === undefined || displayValue === null || displayValue === '') {
                if (cell.displayValue !== undefined && cell.displayValue !== null) displayValue = cell.displayValue;
                else displayValue = cell.value;
            }
            if (displayValue instanceof Array) displayValue = displayValue.filter((f) => f !== null && f !== undefined && f !== '').join(' ');

            if (typeof fn !== 'function') return <div className="ant-grid-cell-text ant-grid-cell-text-ellipsis">{displayValue}</div>;

            const userSettings = AntAuth.getSessionInfo('user_settings') || {};
            const busSettings = AntAuth.getSessionInfo('bus_settings') || {};

            const ctx = {
                value: displayValue,            // giá trị HIỂN THỊ (đã format/translate/join)
                rawValue: cell.value,           // giá trị thô từ data row
                displayValue,                   // alias rõ nghĩa
                rowData: cell.row ? cell.row.data : undefined,
                rowIndex: cell.row ? cell.row.rowIndex : -1,
                column: cell.column,
                parentData: props.parentData,
                session: props.session,
                settings: { sys: busSettings, user: userSettings },
                extra: props.cellContext
            };

            try {
                const out = fn(ctx);
                // Trả về false (strict) = không override → render mặc định.
                if (out === false) return <div className="ant-grid-cell-text ant-grid-cell-text-ellipsis">{displayValue}</div>;
                return out;
            } catch (err) {
                // eslint-disable-next-line no-console
                console.warn('[AntGrid] cellRenders[' + dataField + '] threw:', err);
                return <div className="ant-grid-cell-text ant-grid-cell-text-ellipsis">{displayValue}</div>;
            }
        },
        [props.cellRenders, props.parentData, props.session, props.cellContext]
    );

    // onRowPrepared = (e) => {
    //     if (e.rowType === 'data') {
    //         if (props.rowStyles instanceof Array)
    //             for (let i = 0; i < props.rowStyles.length; i++) {
    //                 const rowStyle = props.rowStyles[i];

    //                 if (rowStyle.when && typeof rowStyle.when === 'object') {
    //                     var isValid = AntCondition.isValid(e.data, {
    //                         when: rowStyle.when,
    //                         whenType: rowStyle.whenType
    //                     });

    //                     if (isValid) {
    //                         e.element.style.backgroundColor = rowStyle.backgroundColor;
    //                         e.element.style.color = rowStyle.textColor;
    //                         return;
    //                     }
    //                 }
    //             }
    //     }
    // };

    const onRowPrepared = useCallback(
        (e) => {
            if (e.rowType === 'data') {
                if (props.rowStyles instanceof Array)
                    for (let i = 0; i < props.rowStyles.length; i++) {
                        const rowStyle = props.rowStyles[i];

                        if (rowStyle.when && typeof rowStyle.when === 'object') {
                            var isValid = AntCondition.isValid(e.data, {
                                when: rowStyle.when,
                                whenType: rowStyle.whenType
                            });

                            if (isValid) {
                                e.rowElement.style.setProperty('background-color', rowStyle.backgroundColor, 'important');
                                e.rowElement.style.setProperty('color', rowStyle.textColor, 'important');

                                // e.rowElement.style.backgroundColor = rowStyle.backgroundColor;
                                // e.rowElement.style.color = rowStyle.textColor;
                                e.rowElement.style.textDecoration = rowStyle.textDecoration;
                                e.rowElement.style.fontWeight = rowStyle.fontWeight;

                                let arCls = ['ant-grid-custom-row'];
                                if (rowStyle.className) arCls.push(rowStyle.className);
                                e.rowElement.classList.add(arCls);

                                break;
                            }
                        }
                    }

                if (props.flashConds instanceof Array)
                    for (let i = 0; i < props.flashConds.length; i++) {
                        const rowStyle = props.flashConds[i];

                        if (rowStyle.when && typeof rowStyle.when === 'object') {
                            var isValid = AntCondition.isValid(e.data, {
                                when: rowStyle.when,
                                whenType: rowStyle.whenType
                            });

                            if (isValid) {
                                e.rowElement.classList.add('ant-grid-row-flash');
                                break;
                            }
                        }
                    }
            }
        },
        [props.rowStyles, props.flashConds]
    );

    // Dòng nháp của lưới nhập trực tiếp có kiểu riêng (viền nét đứt, nền nhạt) để luôn nhận ra dòng mới.
    const onRowPreparedWithInline = useCallback(
        (e) => {
            if (inlineActive && e && e.rowType === 'data' && isInlineDraftRow(e.data) && e.rowElement) {
                const rowElement = e.rowElement.classList ? e.rowElement : e.rowElement[0];
                if (rowElement && rowElement.classList) rowElement.classList.add('ant-grid-inline-draft');
            }
            if (props.rowStyles instanceof Array || props.flashConds instanceof Array) onRowPrepared(e);
        },
        [inlineActive, onRowPrepared, props.rowStyles, props.flashConds]
    );

    const onCellPrepared = useCallback(
        (e) => {
            // Lưới nhập trực tiếp: ô vừa dựng lại (sửa xong, cuộn…) gắn lại dấu lỗi/cảnh báo.
            if (e.rowType === 'data' && e.column && e.column.dataField && inlineCellIssueRef.current) {
                const { getInlineCellIssues, applyInlineCellIssue } = inlineCellIssueRef.current;
                applyInlineCellIssue(e.cellElement, getInlineCellIssues(e.data).get(e.column.dataField));
            }
            if (e.rowType === 'data') {
                if (props.cellStyles instanceof Array)
                    for (let i = 0; i < props.cellStyles.length; i++) {
                        const cellStyle = props.cellStyles[i];

                        if (!cellStyle.dataField || cellStyle.dataField === e.column.dataField) {
                            const hasRowCond =
                                (cellStyle.when && typeof cellStyle.when === 'object') ||
                                (cellStyle.whenSys && typeof cellStyle.whenSys === 'object') ||
                                (cellStyle.whenUser && typeof cellStyle.whenUser === 'object') ||
                                (cellStyle.whenSysAndUser && typeof cellStyle.whenSysAndUser === 'object') ||
                                (cellStyle.whenSysOrUser && typeof cellStyle.whenSysOrUser === 'object') ||
                                (cellStyle.whenSession && typeof cellStyle.whenSession === 'object') ||
                                typeof cellStyle.whenCustom === 'function';

                            const hasMainCond = cellStyle.whenMain && typeof cellStyle.whenMain === 'object';

                            if (!hasRowCond && !hasMainCond) continue;

                            let isValid = true;

                            if (hasRowCond) {
                                isValid = AntCondition.isValid(e.data, {
                                    when: cellStyle.when,
                                    whenType: cellStyle.whenType,
                                    whenSys: cellStyle.whenSys,
                                    whenSysType: cellStyle.whenSysType,
                                    whenUser: cellStyle.whenUser,
                                    whenUserType: cellStyle.whenUserType,
                                    whenSysAndUser: cellStyle.whenSysAndUser,
                                    whenSysAndUserType: cellStyle.whenSysAndUserType,
                                    whenSysOrUser: cellStyle.whenSysOrUser,
                                    whenSysOrUserType: cellStyle.whenSysOrUserType,
                                    whenSession: cellStyle.whenSession,
                                    whenSessionType: cellStyle.whenSessionType,
                                    whenCustom: cellStyle.whenCustom
                                });
                            }

                            if (isValid && hasMainCond) {
                                isValid = AntCondition.isValid(props.parentData || {}, {
                                    when: cellStyle.whenMain,
                                    whenType: cellStyle.whenMainType
                                });
                            }

                            if (isValid) {
                                if (cellStyle.backgroundColor) e.cellElement.style.backgroundColor = cellStyle.backgroundColor;
                                if (cellStyle.textColor) e.cellElement.style.color = cellStyle.textColor;
                                if (cellStyle.textDecoration) e.cellElement.style.textDecoration = cellStyle.textDecoration;
                                if (cellStyle.fontWeight) e.cellElement.style.fontWeight = cellStyle.fontWeight;
                                if (cellStyle.className) e.cellElement.classList.add(cellStyle.className);
                                return;
                            }
                        }
                    }
            }
        },
        [props.cellStyles, props.parentData]
    );

    const renderContentCell = useCallback((cell) => {
        // console.log('ant-log-cell=', cell);
    }, []);

    const renderLinkCell = useCallback(
        (cell) => {
            var dataField = cell.column.dataField;
            var value = cell.value;
            var row = cell.row;
            var rowData = cell.row.data;

            var linkUrl = '';
            var keyField = dataField;
            if (props.columns && props.columns instanceof Array) {
                var field = props.columns.filter((col) => col.dataField == dataField)[0];
                if (field.link) {
                    linkUrl = field.link.url;
                    if (field.link.keyField) keyField = field.link.keyField;
                }
            }

            if (!linkUrl.startsWith('/')) linkUrl = '/' + linkUrl;
            if (!linkUrl.endsWith('/')) linkUrl = linkUrl + '/';
            linkUrl = format('{0}{2}', linkUrl, keyField, value);
            return (
                <AntGridLink
                    text={value}
                    field={dataField}
                    value={value}
                    row={row}
                    rowData={rowData}
                    linkUrl={linkUrl}
                    // onClick={this.handleLinkClicked}
                />
            );
        },
        [props.columns]
    );

    const renderNoteCell = useCallback((cell) => {
        var dataField = cell.column.dataField;
        var value = cell.value;
        var row = cell.row;
        var rowData = cell.row.data;

        // if (row.rowIndex % 5 == 1) rowData.note = "nsdsdgsdg";
        // if (row.rowIndex % 5 == 3) rowData.note = "urge sfd sdgsdnt";

        if (!rowData || !rowData.note || String(rowData.note).trim() == '') return <div></div>;

        var notes = rowData.note.split('\n');

        var id = 'ant-grid-note-' + row.rowIndex;

        return (
            <div>
                <Button
                    className="ant-grid-icon ant-icon-note"
                    id={id}
                    type="normal"
                    stylingMode="text"
                    focusStateEnabled={false}
                    hoverStateEnabled={false}
                    activeStateEnabled={false}
                >
                    <i className={'dx-icon dx-icon-comment'}></i>
                </Button>
                <Tooltip
                    target={`#${id}`}
                    className="ant-tooltip"
                    hideEvent="mouseleave"
                    showEvent={{
                        name: 'mouseenter dxclick keyup'
                    }}
                    hideOnOutsideClick={true}
                >
                    <div>
                        {notes.map((item, key) => {
                            if (key < notes.length - 1)
                                return (
                                    <div>
                                        <caption>{item}</caption>
                                        <br />
                                    </div>
                                );
                            else
                                return (
                                    <div>
                                        <caption>{item}</caption>
                                    </div>
                                );
                        })}
                    </div>
                </Tooltip>
            </div>
        );
    }, []);

    const renderPriorityCell = useCallback(
        (cell) => {
            var dataField = cell.column.dataField;
            var value = cell.value;
            var row = cell.row;
            var rowData = cell.row.data;

            // if (row.rowIndex % 6 == 1) rowData.priority = 'high';
            // if (row.rowIndex % 6 == 3) rowData.priority = 'urgent';

            var priorityField = props.priorityField ? props.priorityField : 'priority';

            if (!rowData || !rowData[priorityField] || String(rowData[priorityField]).trim() == '') return <div></div>;

            var priority = '';
            if (rowData[priorityField] === 'Lowest') priority = 'lowest';
            if (rowData[priorityField] === 'Low') priority = 'low';
            if (rowData[priorityField] === 'Normal') priority = 'normal';
            if (rowData[priorityField] === 'High') priority = 'high';
            if (rowData[priorityField] === 'Highest') priority = 'highest';

            if (priority !== 'high' && priority !== 'highest') return <div></div>;

            var id = 'ant-grid-priority-' + row.rowIndex;

            return (
                <div>
                    <Button
                        className={`ant-grid-icon ant-icon-priority-${priority}`}
                        id={id}
                        type="normal"
                        stylingMode="text"
                        focusStateEnabled={false}
                        hoverStateEnabled={false}
                        activeStateEnabled={false}
                    >
                        {/* <i className={`dx-icon dx-icon-${priority == 'high' ? 'favorites' : 'warning'}`}></i> */}
                        <i className={`dx-icon dx-icon-favorites`}></i>
                    </Button>
                    <Tooltip
                        target={`#${id}`}
                        className="ant-tooltip"
                        hideEvent="mouseleave"
                        showEvent={{
                            name: 'mouseenter dxclick keyup'
                        }}
                        hideOnOutsideClick={true}
                    >
                        <div>
                            {priority === 'high' && (
                                <div>
                                    <caption>
                                        {AntLocalization.translateText({
                                            vi: 'Ưu tiên',
                                            en: 'Priority',
                                            fr: 'Priorité',
                                            es: 'Prioridad',
                                            id: 'Prioritas',
                                            ja: '優先度',
                                            zh: '优先级',
                                            ko: '우선순위',
                                            hi: 'प्राथमिकता',
                                            ar: 'أولوية'
                                        })}
                                    </caption>
                                </div>
                            )}
                            {priority === 'highest' && (
                                <div>
                                    <caption>
                                        {AntLocalization.translateText({
                                            vi: 'Ưu tiên',
                                            en: 'Priority',
                                            fr: 'Priorité',
                                            es: 'Prioridad',
                                            id: 'Prioritas',
                                            ja: '優先度',
                                            zh: '优先级',
                                            ko: '우선순위',
                                            hi: 'प्राथमिकता',
                                            ar: 'أولوية'
                                        })}
                                    </caption>
                                </div>
                            )}
                        </div>
                    </Tooltip>
                </div>
            );
        },
        [props.priorityField]
    );

    const renderAttachmentCell = useCallback((cell) => {
        var dataField = cell.column.dataField;
        var value = cell.value;
        var row = cell.row;
        var rowData = cell.row.data;

        // if (!rowData || !rowData.attach || rowData.attach instanceof Array == false) return <div></div>;

        var id = 'ant-grid-attach-' + row.rowIndex;

        return (
            <div>
                <Button
                    className="ant-grid-icon ant-icon-attach"
                    id={id}
                    type="normal"
                    stylingMode="text"
                    focusStateEnabled={false}
                    hoverStateEnabled={false}
                    activeStateEnabled={false}
                >
                    <i className={'dx-icon dx-icon-file'}></i>
                </Button>
            </div>
        );
    }, []);
    // const renderCellEditor = useCallback((cell) => {
    //     var col = cell.column;
    //     var row = cell.row;
    //     var rowData = cell.data;
    //     var dataField = cell.column.dataField;

    //     var cnfField = null;
    //     if (this.state.cnfFields instanceof Array) cnfField = this.state.cnfFields.find((f) => f.field === dataField);

    //     var value = cell.value;
    //     var colType = col.dataType;
    //     var colEditor = col.dataType;
    //     var colEditorOptions = col.editorOptions;
    //     if (!colType && props.columns instanceof Array) {
    //         var found = props.columns.find((f) => f.field === dataField);
    //         if (found && found.dataType) colType = found.dataType;
    //         if (found && found.editor) colEditor = found.editor;
    //         if (found && found.editorOptions) colEditorOptions = found.editorOptions;
    //     }
    //     if (!colType && cnfField && cnfField.dataType) colType = cnfField.dataType;

    //     let onCellValueChanged = this.onCellValueChanged.bind(this, cell);

    //     if (colEditor == 'textArea')
    //         return (
    //             <TextArea
    //                 {...colEditorOptions}
    //                 defaultValue={value}
    //                 value={value}
    //                 onValueChanged={onCellValueChanged}
    //                 onFocusIn={(e) => {
    //                     let inputEl = e.element.querySelector('.dx-texteditor-input');
    // if (inputEl) {
    //     inputEl.selectionStart = 0;
    //     inputEl.selectionEnd = inputEl.value.length;
    // }
    //                 }}
    //             />
    //         );

    //     if (colEditor == 'checkBox' || colType == 'bool' || colType == 'boolean')
    //         return <CheckBox {...colEditorOptions} defaultValue={value} value={value} onValueChanged={onCellValueChanged} />;

    //     if (colEditor == 'dxSelectBox') {
    //         var allowNew = false;
    //         var datasource = [];
    //         if (col.lookup) {
    //             if (col.lookup.allowNew) allowNew = col.lookup.allowNew;
    //             if (col.lookup.values instanceof Array) datasource = col.lookup.values;
    //         } else if (cnfField && cnfField.lookup) {
    //             if (cnfField.lookup.allowNew) allowNew = cnfField.lookup.allowNew;
    //             if (cnfField.lookup.values instanceof Array) datasource = cnfField.lookup.values;
    //         }
    //         return (
    //             <SelectBox
    //                 items={datasource}
    //                 acceptCustomValue={allowNew}
    //                 placeholder={'...'}
    //                 showClearButton={true}
    //                 {...colEditorOptions}
    //                 noDataText={'Không có dữ liệu'}
    //                 defaultValue={value}
    //                 value={value}
    //                 onValueChanged={onCellValueChanged}
    //             />
    //         );
    //     }

    //     if (colEditor == 'antDropDownGrid') {
    //         var allowNew = false;
    //         var valueField = null;
    //         var displayField = null;
    //         var datasource = [];
    //         if (col.lookup) {
    //             if (col.lookup.allowNew) allowNew = col.lookup.allowNew;
    //             if (col.lookup.valueField) valueField = col.lookup.valueField;
    //             if (col.lookup.displayField) displayField = col.lookup.displayField;
    //             if (col.lookup.values instanceof Array) datasource = col.lookup.values;
    //         } else if (cnfField && cnfField.lookup) {
    //             if (cnfField.lookup.allowNew) allowNew = cnfField.lookup.allowNew;
    //             if (cnfField.lookup.valueField) valueField = cnfField.lookup.valueField;
    //             if (cnfField.lookup.displayField) displayField = cnfField.lookup.displayField;
    //             if (cnfField.lookup.values instanceof Array) datasource = cnfField.lookup.values;
    //         }

    //         return (
    //             <AntDropDownGrid
    //                 gridOptions={{
    //                     dataSource: datasource,
    //                     valueExpr: valueField,
    //                     displayExpr: displayField,
    //                     showClearButton: true,
    //                     ...colEditorOptions,
    //                     noDataText: 'Không có dữ liệu'
    //                 }}
    //                 width={col.lookup.width}
    //                 defaultValue={value}
    //                 value={value}
    //                 onValueChanged={onCellValueChanged}
    //             />
    //         );
    //     }

    //     if (colType === 'float' || colType === 'decimal') {
    //         return (
    //             <NumberBox
    //                 {...colEditorOptions}
    //                 format={'#,##0.' + String('#').repeat(colEditorOptions && colEditorOptions.decimalDigit ? colEditorOptions.decimalDigit : 2)}
    //                 value={value}
    //                 onValueChanged={onCellValueChanged}
    //             />
    //         );
    //     }

    //     if (colType === 'day' || (colType === 'int' && col.dataTypeDisplay === 'day')) {
    //         return <NumberBox {...colEditorOptions} format={'#,##0 ngày'} value={value} onValueChanged={onCellValueChanged} />;
    //     }

    //     if (colType === 'month' || (colType === 'int' && col.dataTypeDisplay === 'month')) {
    //         return <NumberBox {...colEditorOptions} format={'#,##0 tháng'} value={value} onValueChanged={onCellValueChanged} />;
    //     }

    //     if (colType === 'year' || (colType === 'int' && col.dataTypeDisplay === 'year')) {
    //         return <NumberBox {...colEditorOptions} format={'#,##0 năm'} value={value} onValueChanged={onCellValueChanged} />;
    //     }

    //     if (colType === 'period' || (colType === 'int' && col.dataTypeDisplay === 'period')) {
    //         return <NumberBox {...colEditorOptions} format={'#,##0 kỳ'} value={value} onValueChanged={onCellValueChanged} />;
    //     }

    //     if (colType === 'fixedPoint' || colType === 'int') {
    //         // return <NumberBox {...colEditorOptions} format={{ type: 'fixedPoint' }} value={value} onValueChanged={onCellValueChanged} />;
    //         return <NumberBox {...colEditorOptions} format={'#,##0'} value={parseInt(value)} onValueChanged={onCellValueChanged} />;
    //     }
    //     if (colType === 'percent') {
    //         return (
    //             <NumberBox
    //                 {...colEditorOptions}
    //                 format={{
    //                     type: 'percent',
    //                     precision: colEditorOptions && colEditorOptions.decimalDigit ? parseInt(colEditorOptions.decimalDigit) : 0
    //                 }}
    //                 value={parseFloat(value)}
    //                 onValueChanged={onCellValueChanged}
    //             />
    //         );
    //     }

    //     if (colType === 'currency') {
    //         return <NumberBox {...colEditorOptions} format={'#,##0 đ'} value={parseInt(value)} onValueChanged={onCellValueChanged} />;
    //     }

    //     if (colType === 'phone') {
    //         return (
    //             <TextBox
    //                 {...colEditorOptions}
    //                 mask="(+84) X000 000 000"
    //                 maskRules={{ X: /[02-9]/ }}
    //                 value={value}
    //                 onValueChanged={onCellValueChanged}
    //             />
    //         );
    //     }

    //     var mode = 'text';
    //     if (colType == 'password') mode = 'password';
    //     return <TextBox {...colEditorOptions} mode={mode} defaultValue={value} value={value} onValueChanged={onCellValueChanged} />;
    // });

    const onInitialized = useCallback(
        (e) => {
            // DevExtreme also hides columns with hidingPriority when
            // columnHidingEnabled is false. Its adaptive-more command must remain available.
            // Dòng lọc đặt qua instance (không qua prop): bật/tắt bằng instance.option không bị devextreme-react trả về.
            if (columnFilterEnabled && e && e.component)
                e.component.option('filterRow', { visible: filterRowVisible.current, showOperationChooser: false, applyFilter: 'auto' });
            if (props.onInitialized) props.onInitialized(e);
        },
        [props.onInitialized, columnFilterEnabled]
    );

    // const onContentReady = useCallback((e) => {
    //     setTimeout(() => {
    //         resetUI();
    //     }, 500);
    // }, []);

    const onSelectionChanged = useCallback(
        (e) => {
            let selectedRowsData = e.selectedRowsData;
            resetActionBar(selectedRowsData);
            // var rows = getSelectedRows();
            if (props.onSelectionChanged) props.onSelectionChanged(selectedRowsData);
        },
        [resetActionBar, props.onSelectionChanged]
    );

    const getSearchCategories = useCallback(() => {
        let ar = [];
        if (
            props.searchCategories1 &&
            props.searchCategories1.lookups instanceof Array &&
            props.searchCategories1.lookups.length > 0 &&
            itemsCats1.length > 0 &&
            selectedCats1.filter((s) => s.value && s.value.length > 0)
        )
            ar.push({
                categories: props.searchCategories1.lookups,
                items: itemsCats1,
                selectedItems: selectedCats1
            });

        if (
            props.searchCategories2 &&
            props.searchCategories2.lookups instanceof Array &&
            props.searchCategories2.lookups.length > 0 &&
            itemsCats2.length > 0
        )
            ar.push({
                categories: props.searchCategories2.lookups,
                items: itemsCats2,
                selectedItems: selectedCats2
            });

        if (
            props.searchCategories3 &&
            props.searchCategories3.lookups instanceof Array &&
            props.searchCategories3.lookups.length > 0 &&
            itemsCats3.length > 0
        )
            ar.push({
                categories: props.searchCategories3.lookups,
                items: itemsCats3,
                selectedItems: selectedCats3
            });

        if (
            props.searchCategories4 &&
            props.searchCategories4.lookups instanceof Array &&
            props.searchCategories4.lookups.length > 0 &&
            itemsCats4.length > 0
        )
            ar.push({
                categories: props.searchCategories4.lookups,
                items: itemsCats4,
                selectedItems: selectedCats4
            });

        if (
            props.searchCategories5 &&
            props.searchCategories5.lookups instanceof Array &&
            props.searchCategories5.lookups.length > 0 &&
            itemsCats5.length > 0
        )
            ar.push({
                categories: props.searchCategories5.lookups,
                items: itemsCats5,
                selectedItems: selectedCats5
            });

        if (
            props.searchCategories6 &&
            props.searchCategories6.lookups instanceof Array &&
            props.searchCategories6.lookups.length > 0 &&
            itemsCats6.length > 0
        )
            ar.push({
                categories: props.searchCategories6.lookups,
                items: itemsCats6,
                selectedItems: selectedCats6
            });

        if (
            props.searchCategories7 &&
            props.searchCategories7.lookups instanceof Array &&
            props.searchCategories7.lookups.length > 0 &&
            itemsCats7.length > 0
        )
            ar.push({
                categories: props.searchCategories7.lookups,
                items: itemsCats7,
                selectedItems: selectedCats7
            });

        if (
            props.searchCategories8 &&
            props.searchCategories8.lookups instanceof Array &&
            props.searchCategories8.lookups.length > 0 &&
            itemsCats8.length > 0
        )
            ar.push({
                categories: props.searchCategories8.lookups,
                items: itemsCats8,
                selectedItems: selectedCats8
            });

        if (
            props.searchCategories9 &&
            props.searchCategories9.lookups instanceof Array &&
            props.searchCategories9.lookups.length > 0 &&
            itemsCats9.length > 0
        )
            ar.push({
                categories: props.searchCategories9.lookups,
                items: itemsCats9,
                selectedItems: selectedCats9
            });

        if (
            props.searchCategories10 &&
            props.searchCategories10.lookups instanceof Array &&
            props.searchCategories10.lookups.length > 0 &&
            itemsCats10.length > 0
        )
            ar.push({
                categories: props.searchCategories10.lookups,
                items: itemsCats10,
                selectedItems: selectedCats10
            });

        return ar;
    }, [
        props.searchCategories1,
        props.searchCategories2,
        props.searchCategories3,
        props.searchCategories4,
        props.searchCategories5,
        props.searchCategories6,
        props.searchCategories7,
        props.searchCategories8,
        props.searchCategories9,
        props.searchCategories10,
        itemsCats1,
        itemsCats2,
        itemsCats3,
        itemsCats4,
        itemsCats5,
        itemsCats6,
        itemsCats7,
        itemsCats8,
        itemsCats9,
        itemsCats10,
        selectedCats1,
        selectedCats2,
        selectedCats3,
        selectedCats4,
        selectedCats5,
        selectedCats6,
        selectedCats7,
        selectedCats8,
        selectedCats9,
        selectedCats10
    ]);

    const resetUI = useCallback(
        (opts) => {
            // if (loading.current || !grid.current || !grid.current.instance || !grid.current.instance.option('visible')) {
            //     setTimeout(() => {
            //         resetUI();
            //     }, 500);

            //     return;
            // }

            if (!opts || !opts.bysPassUpdate) beginUpdate();
            resetPager();
            if (!opts || !opts.byPassColumnVisibility) resetColumnVisibility();
            resetActionColumn();
            resetColumnEditable();
            if (!opts || !opts.byPassActionBar) {
                resetActionBar();
            }

            if (!opts || !opts.bysPassUpdate) endUpdate();
        },
        [beginUpdate, resetPager, resetColumnVisibility, resetActionColumn, resetColumnEditable, resetActionBar, endUpdate]
    );

    const generateSearchConditions = useCallback(
        (opts) => {
            let objS = {};
            // Selection-change handlers update React state asynchronously. Use the
            // just-selected category values for the immediate reload instead of
            // querying once with the previous render's state.
            // Callback giữ closure cũ (setTimeout sau row action, ref bên ngoài...) cũng
            // gọi hàm này; đọc lựa chọn mới nhất từ ref để không ghi đè điều kiện lọc
            // bằng giá trị cũ trong khi nút searchCategories vẫn hiện đang chọn.
            const categorySelections = { ...latestCatSelections.current, ...(opts?.categorySelections || {}) };
            const cats1 = categorySelections[1] !== undefined ? categorySelections[1] : selectedCats1;
            const cats2 = categorySelections[2] !== undefined ? categorySelections[2] : selectedCats2;
            const cats3 = categorySelections[3] !== undefined ? categorySelections[3] : selectedCats3;
            const cats4 = categorySelections[4] !== undefined ? categorySelections[4] : selectedCats4;
            const cats5 = categorySelections[5] !== undefined ? categorySelections[5] : selectedCats5;
            const cats6 = categorySelections[6] !== undefined ? categorySelections[6] : selectedCats6;
            const cats7 = categorySelections[7] !== undefined ? categorySelections[7] : selectedCats7;
            const cats8 = categorySelections[8] !== undefined ? categorySelections[8] : selectedCats8;
            const cats9 = categorySelections[9] !== undefined ? categorySelections[9] : selectedCats9;
            const cats10 = categorySelections[10] !== undefined ? categorySelections[10] : selectedCats10;

            if (props.searchCategories1)
                objS = cats1.reduce((obj, c) => {
                    if (obj[c.field] !== undefined) obj[c.field].push(c.value);
                    else obj[c.field] = [c.value];
                    return obj;
                }, objS);

            if (props.searchCategories2)
                objS = cats2.reduce((obj, c) => {
                    if (obj[c.field] !== undefined) obj[c.field].push(c.value);
                    else obj[c.field] = [c.value];
                    return obj;
                }, objS);

            if (props.searchCategories3)
                objS = cats3.reduce((obj, c) => {
                    if (obj[c.field] !== undefined) obj[c.field].push(c.value);
                    else obj[c.field] = [c.value];
                    return obj;
                }, objS);

            if (props.searchCategories4)
                objS = cats4.reduce((obj, c) => {
                    if (obj[c.field] !== undefined) obj[c.field].push(c.value);
                    else obj[c.field] = [c.value];
                    return obj;
                }, objS);

            if (props.searchCategories5)
                objS = cats5.reduce((obj, c) => {
                    if (obj[c.field] !== undefined) obj[c.field].push(c.value);
                    else obj[c.field] = [c.value];
                    return obj;
                }, objS);

            if (props.searchCategories6)
                objS = cats6.reduce((obj, c) => {
                    if (obj[c.field] !== undefined) obj[c.field].push(c.value);
                    else obj[c.field] = [c.value];
                    return obj;
                }, objS);

            if (props.searchCategories7)
                objS = cats7.reduce((obj, c) => {
                    if (obj[c.field] !== undefined) obj[c.field].push(c.value);
                    else obj[c.field] = [c.value];
                    return obj;
                }, objS);

            if (props.searchCategories8)
                objS = cats8.reduce((obj, c) => {
                    if (obj[c.field] !== undefined) obj[c.field].push(c.value);
                    else obj[c.field] = [c.value];
                    return obj;
                }, objS);

            if (props.searchCategories9)
                objS = cats9.reduce((obj, c) => {
                    if (obj[c.field] !== undefined) obj[c.field].push(c.value);
                    else obj[c.field] = [c.value];
                    return obj;
                }, objS);

            if (props.searchCategories10)
                objS = cats10.reduce((obj, c) => {
                    if (obj[c.field] !== undefined) obj[c.field].push(c.value);
                    else obj[c.field] = [c.value];
                    return obj;
                }, objS);

            Object.keys(objS).forEach((k) => {
                if (objS[k] instanceof Array && objS[k].length === 1) objS[k] = objS[k][0];
            });

            let newObj = {
                ...formSearchConditions
            };

            if (props.searchCategories1 && props.searchCategories1.lookups instanceof Array)
                props.searchCategories1.lookups.forEach((k) => delete newObj[k.field]);
            if (props.searchCategories2 && props.searchCategories2.lookups instanceof Array)
                props.searchCategories2.lookups.forEach((k) => delete newObj[k.field]);
            if (props.searchCategories3 && props.searchCategories3.lookups instanceof Array)
                props.searchCategories3.lookups.forEach((k) => delete newObj[k.field]);
            if (props.searchCategories4 && props.searchCategories4.lookups instanceof Array)
                props.searchCategories4.lookups.forEach((k) => delete newObj[k.field]);
            if (props.searchCategories5 && props.searchCategories5.lookups instanceof Array)
                props.searchCategories5.lookups.forEach((k) => delete newObj[k.field]);
            if (props.searchCategories6 && props.searchCategories6.lookups instanceof Array)
                props.searchCategories6.lookups.forEach((k) => delete newObj[k.field]);
            if (props.searchCategories7 && props.searchCategories7.lookups instanceof Array)
                props.searchCategories7.lookups.forEach((k) => delete newObj[k.field]);
            if (props.searchCategories8 && props.searchCategories8.lookups instanceof Array)
                props.searchCategories8.lookups.forEach((k) => delete newObj[k.field]);
            if (props.searchCategories9 && props.searchCategories9.lookups instanceof Array)
                props.searchCategories9.lookups.forEach((k) => delete newObj[k.field]);
            if (props.searchCategories10 && props.searchCategories10.lookups instanceof Array)
                props.searchCategories10.lookups.forEach((k) => delete newObj[k.field]);

            if (props.searchConditions) {
                if (typeof props.searchConditions === 'function') {
                    var obj = props.searchConditions();
                    if (obj)
                        newObj = {
                            ...newObj,
                            ...obj
                        };
                } else {
                    newObj = {
                        ...newObj,
                        ...props.searchConditions
                    };
                }
            }

            if (props.actionItems instanceof Array) {
                props.actionItems.forEach((item) => {
                    if (item.name && item.widget !== 'Button' && item.widget !== 'ButtonGroup' && item.widget !== 'Menu')
                        newObj[item.name] = item.defaultValue !== undefined ? item.defaultValue : false;
                });
            }

            if (actionBar.current) {
                var obj = actionBar.current.getSearchConditions();
                if (obj)
                    newObj = {
                        ...newObj,
                        ...obj
                    };
            }

            if (props.searchFields instanceof Array && props.searchFields.length > 0) {
                Object.keys(newObj).map((k) => {
                    var found = props.searchFields.find((f) => typeof f === 'object' && f.alias && f.field === k);
                    if (found) {
                        newObj[found.alias] = newObj[k];
                        delete newObj[k];
                    }
                });

                Object.keys(newObj).map((k) => {
                    var found = props.searchFields.find(
                        (f) =>
                            f === k ||
                            f === k + '_oneMonth' ||
                            f === k + '_oneYear' ||
                            f === k + '_startDate' ||
                            f === k + '_startMonth' ||
                            f === k + '_startYear' ||
                            f === k + '_endDate' ||
                            f === k + '_endMonth' ||
                            f === k + '_endYear' ||
                            k === f + '_oneMonth' ||
                            k === f + '_oneYear' ||
                            k === f + '_startDate' ||
                            k === f + '_startMonth' ||
                            k === f + '_startYear' ||
                            k === f + '_endDate' ||
                            k === f + '_endMonth' ||
                            k === f + '_endYear' ||
                            (typeof f === 'object' && f.alias === k)
                    );

                    if (!found && props.actionItems instanceof Array) found = props.actionItems.find((f) => f.name === k);

                    if (!found) newObj[k] = undefined;
                });
            }

            delete newObj.filterBySelected;

            newObj = { ...newObj, ...objS };

            if (dateFilterField && isValidDateFilter(dateFilterRef.current)) {
                newObj[dateFilterField + '_startDate'] = dateFilterRef.current.startDate;
                newObj[dateFilterField + '_endDate'] = dateFilterRef.current.endDate;
            }

            // Bộ lọc trên cột: chỉ khi dòng lọc đang hiện, bỏ cột đang ẩn (người dùng không thấy ô lọc của nó).
            if (columnFilterEnabled && filterRowVisible.current) {
                const defs = mainColumnsRef.current || [];
                const columnConditions = buildColumnFilterConditions(columnFilterValues.current, (field) => {
                    const def = defs.find((c) => c.dataField === field);
                    return def && def.visible !== false ? def._antFilter : null;
                });
                appliedColumnFilterKey.current = stringify(columnConditions);
                Object.assign(newObj, columnConditions);
            } else appliedColumnFilterKey.current = stringify({});

            // Nhập trực tiếp: BE gắn cảnh báo theo dòng (getRowWarnings) — chỉ lưới này yêu cầu.
            if (inlineActive) newObj.checkRowWarnings = true;

            Object.keys(newObj).map((k) => {
                if (newObj[k] !== null && typeof newObj[k] === 'object') newObj[k] = AntCondition.getValueFromSession(newObj[k]);
            });

            Object.keys(newObj).map((k) => {
                if (newObj[k] === null || newObj[k] === '') newObj[k] = undefined;
            });

            Object.keys(newObj).forEach((key) => {
                if (newObj[key] === undefined) {
                    delete newObj[key];
                }
            });

            Object.keys(newObj).forEach((key) => {
                if (newObj[key] instanceof Array) {
                    newObj[key + '_search_inner_join'] = true;
                }
            });

            if (props.isSearching) newObj.isSearching = true;

            if (!opts || !opts.byPassCheckActions) {
                if (gridRowActions instanceof Array && gridRowActions.length > 0) {
                    var selectedGroup = filteredGroup;

                    newObj.checkActions = gridRowActions
                        .filter(
                            (r) => !selectedGroup || !r.filterGroups || r.filterGroups instanceof Array === false || r.filterGroups.includes(r.code)
                        )
                        .map((a) => a.code);
                }
            }

            if (props.FKField && props.parentData) {
                var childValue = props.parentIDField ? props.parentData[props.parentIDField] : props.parentData.code;
                newObj[props.FKField] = childValue;
            }

            searchConditions.current = newObj;
            if (!AntJSON.isDeepEqual(newObj, finalSearchConditionsRef.current)) {
                finalSearchConditionsRef.current = newObj;
                if (props.summaryHeader) setFinalSearchConditions(newObj);
            }

            // console.log('ant-searchConditions.current : ',newObj);

            return newObj;
        },
        [
            filteredGroup,
            props.summaryHeader,
            props.searchConditions,
            formSearchConditions,
            props.actionItem,
            actionBar.current,
            props.searchFields,
            props.isSearching,
            props.showRowActions,
            props.rowActionPack,
            props.rowActionWidth,
            props.rowActions,
            gridRowActions,
            props.parentData,
            selectedCats1,
            selectedCats2,
            selectedCats3,
            selectedCats4,
            selectedCats5,
            selectedCats6,
            selectedCats7,
            selectedCats8,
            selectedCats9,
            selectedCats10,
            dateFilterField,
            inlineActive,
            columnFilterEnabled
        ]
    );

    const forceReload = useCallback(
        async (opts, changesOnly = true) => {
            if (opts && opts.isResetUI) beginUpdate();

            generateSearchConditions(opts);

            if (grid.current && grid.current.instance) {
                grid.current.instance.refresh(changesOnly);
            }

            if (cardview.current && cardview.current) {
                cardview.current.reload();
            }
            if (scheduler.current && scheduler.current) {
                scheduler.current.reload();
            }

            // if (opts && opts.isResetUI)
            await resetUI({ bysPassUpdate: true, byPassColumnVisibility: true });
            // setTimeout(() => {
            //     resetUI();
            // }, 500);

            if (opts && opts.isResetUI) endUpdate();
        },
        [generateSearchConditions, resetUI, beginUpdate, endUpdate]
    );

    const onAction = useCallback(
        (e) => {
            if (e.name) forceReload();

            if (props.onAction && typeof props.onAction === 'function') props.onAction(e);
        },
        [props.onAction, forceReload]
    );

    const refresh = useCallback(
        (changesOnly) => {
            const refreshOptions = changesOnly && typeof changesOnly === 'object' ? changesOnly : null;
            if (refreshOptions?.forceQuery) {
                dataSource.current?.requestCacheRefresh?.(refreshOptions);
                cardViewDataSource.current?.requestCacheRefresh?.(refreshOptions);
                schedulerDataSource.current?.requestCacheRefresh?.(refreshOptions);
                return forceReload();
            }
            const refreshChangesOnly = refreshOptions ? true : changesOnly !== false;
            forceReload(undefined, refreshChangesOnly);

            // forceRender();
        },
        [forceReload]
    );

    const [categoryRefreshVersion, setCategoryRefreshVersion] = useState(0);
    const reload = useCallback(
        async (opts) => {
            if (props.searchCategories2?.cachePolicy === 'ar-orders-catalogues-v1') setCategoryRefreshVersion(v => v + 1);
            if (opts && opts.clearSelection) clearSelection();
            // if (!isRemotePaging && !isAllowNew && hasColMarkSelected && props.showSelectAll !== false) {
            //     var isSelectedAll = dataSource.current ? dataSource.current.isSelectedAll() : false;
            //     setSelectedAll(isSelectedAll);
            //         // await dataSource.current.reset(null, false, Boolean(opts && opts.clearSelection));
            // }

            refresh(true);
        },
        // [clearSelection, isRemotePaging, isAllowNew, hasColMarkSelected, props.showSelectAll,  refresh]
        [clearSelection, refresh, props.searchCategories2?.cachePolicy]
    );

    const onBatchExecuted = useCallback(
        async (event) => {
            await reload({ clearSelection: true });
            if (props.onBatchExecuted) await props.onBatchExecuted(event);
        },
        [props.onBatchExecuted, reload]
    );

    const autoReload = useCallback(() => {
        reload();
        if (autoRefreshTimer.current) clearInterval(autoRefreshTimer.current);
        autoRefreshTimer.current = setInterval(() => {
            reload();
        }, 60 * 1000 * 2);
    }, [reload]);

    const onScanBarcode = useCallback(
        async (barcode) => {
            searchBarcode.current = barcode;
            if (barcode) {
                var result = await dataSource.current.callScanBarcode();

                if (props.onBarcodeScanned) props.onBarcodeScanned(barcode, result.data);

                searchBarcode.current = '';

                if (result && result.data && result.data.inserted) {
                    reload();
                }
                return result;
            }
        },
        [props.onBarcodeScanned, reload]
    );

    const onRowAction = useCallback(
        async (e, done) => {
            if (props.onRowAction) {
                let close = await props.onRowAction(e);
                if (close) {
                    if (done) done();
                    return close;
                }
            }

            let actionName = e.actionId;
            if (actionName === 'actionCancel') actionName = 'cancel';
            if (actionName === 'actionDelete') actionName = 'delete';
            if (actionName === 'actionRelease') actionName = 'release';
            if (actionName === 'actionClose') actionName = 'close';
            if (actionName === 'actionApprove') actionName = 'approve';
            if (actionName === 'actionPost') actionName = 'post';
            if (actionName === 'actionReject') actionName = 'reject';

            var btn = gridRowActions instanceof Array ? gridRowActions.find((a) => a.code === e.actionId) : null;
            if (!btn) {
                if (done) done();
                return;
            }

            var actAPI = btn.API ? btn.API : props.API;

            var result;

            if (props.rowActionCustomData) {
                let data = props.rowActionCustomData(e);
                result = await actAPI.postActionWithData(actionName, data);
            } else {
                result = await actAPI.postAction(actionName, e.data.code, e.data.id);
            }

            // Lời xoá bị luật configDelete chặn: hiện lý do của luật (trước đây lưới chỉ nạp lại, không báo gì).
            if (result && typeof result.error === 'string' && result.error && actionName === 'delete') notify(result.error, 'error', 5000);

            if (result && result.data) {
                var code = result.data.code;

                if (btn && btn.navigateLink && code) {
                    var value;
                    var link;

                    if (btn.navigateLink instanceof Array) {
                        btn.navigateLink.forEach((l) => {
                            if (l && l.link) {
                                if (l.when && typeof l.when === 'object') {
                                    var isValid = AntCondition.isValid(result.data, {
                                        when: l.when,
                                        whenType: l.whenType
                                    });
                                    if (!isValid) return;
                                }
                                value = l.field ? result.data[l.field] : result.data.code;
                                link = String(l.link);
                            }
                        });
                    } else {
                        value = btn.navigateField ? result.data[btn.navigateField] : result.data.code;
                        link = String(btn.navigateLink);
                    }

                    if (link && value !== undefined && value !== null) {
                        if (!link.startsWith('/')) link = '/' + link;
                        if (!link.endsWith('/')) link = link + '/';
                        link = link + value;
                        navigate(link);
                    }
                }
            }
            if (btn && (!btn.opts || !btn.opts.byPassRefreshGrid)) {
                reload();

                if (afterActionRefreshTimeout.current) clearTimeout(afterActionRefreshTimeout.current);
                afterActionRefreshTimeout.current = setTimeout(() => {
                    reload();
                    if (grid.current && grid.current.instance) grid.current.instance.repaint();
                }, 1500);
            }
            if (props.afterRowAction) props.afterRowAction(result);

            if (done) done();
            return result;
        },
        [reload, props.onRowAction, gridRowActions, props.API, props.rowActionCustomData, props.afterRowAction]
    );

    const onItemClick = useCallback(
        async (data, actList, opts) => {
            if (data?.actions instanceof Array === false || data?.actions.length <= 0) {
                onRowDblClick({ data: data });
                return;
            }

            if (actList instanceof Array) {
                if (data.actions instanceof Array && data.actions.filter((a) => a.visible).length === 1) {
                    let act = data.actions.filter((a) => a.visible)[0];
                    act = actList.find((a) => a.code === act.name && a.isQuickAction);
                    if (act) {
                        onRowAction({
                            actionId: act.code,
                            data: data
                        });
                        return;
                    }
                }
            }

            if (opts && opts.isOnActionButton === false) {
                onRowDblClick({ data: data });
            }
        },
        [onRowDblClick, onRowAction]
    );

    const renderButtonsCell = useCallback(
        (cell) => {
            var value = cell.value;
            var row = cell.row;
            var rowData = cell.row.data;
            if (isInlineDraftRow(rowData)) return <div />;

            if (gridRowActions instanceof Array === false || gridRowActions.length <= 0) return <div />;

            var actions =
                gridRowActions instanceof Array
                    ? gridRowActions.filter(
                          (r) =>
                              r.code &&
                              cell.row.data.actions instanceof Array &&
                              cell.row.data.actions.some(
                                  (a) => a.name === r.code && Boolean(a.visible)
                                  //    && ['actionDelete', 'actionCancel'].includes(r.code) == false
                              )
                      )
                    : [];

            actions = actions.map((a) => {
                let strText = a.name instanceof Array ? AntCondition.getValue(rowData, a.name) : a.name;
                const menuText = AntLocalization.translateText(strText || getRowActionFallbackLabel(a.code));
                let strIcon = a.icon;
                let stylingMode = a.stylingMode;
                let width = a.width;
                if (!a.name) {
                    if (['actionDelete', 'actionCancel'].includes(a.code)) {
                        stylingMode = 'text';
                        strIcon = 'trash';
                        strText = '';
                        width = 30;
                    }
                    if (['actionReject'].includes(a.code)) {
                        stylingMode = 'text';
                        strIcon = 'clear';
                        strText = '';
                        width = 30;
                    }
                    if (['actionPost', 'actionApprove', 'actionClose'].includes(a.code)) {
                        stylingMode = 'text';
                        strIcon = 'check';
                        strText = '';
                        width = 30;
                    }
                    if (['actionRelease'].includes(a.code)) {
                        stylingMode = 'text';
                        strIcon = 'parentfolder';
                        strText = '';
                        width = 30;
                    }
                }
                strText = AntLocalization.translateText(strText);
                return {
                    id: a.code,
                    text: strText,
                    menuText,
                    icon: strIcon,
                    type: a.type,
                    stylingMode: strText ? stylingMode : 'text',
                    width: strText ? (width ? width : 60) + 5 : 30
                };
            });

            if (!actions || actions.length <= 0) return <div />;
            const inlineActions =
                rowActionsDisplay === 'menu'
                    ? []
                    : rowActionsDisplay === 'smart'
                    ? actions.filter((action) => rowActionPrimaryActions.includes(action.id)).slice(0, 1)
                    : actions;
            const overflowActions = actions
                .filter((action) => !inlineActions.some((inlineAction) => inlineAction.id === action.id))
                .map((action) => ({ ...action, text: action.menuText }));

            return <AntGridRowActions inlineActions={inlineActions} overflowActions={overflowActions}
                rowData={rowData} onRowAction={onRowAction} menuWidth={ROW_ACTION_MENU_WIDTH} />;
        },
        [gridRowActions, onRowAction, rowActionsDisplay, rowActionPrimaryActions]
    );

    const onFilterBySelected = useCallback(
        (value) => {
            filterBySelected.current = value;
            if (value) dsSetPageIndex(0);
            refresh();
        },
        [dsSetPageIndex, refresh]
    );

    refreshRef.current = refresh;

    const setCellValue = useCallback(
        async (rowKey, dataField, value, opts) => {
            var newValue = value;
            if (props.onCellValueChanging) newValue = await props.onCellValueChanging(rowKey, dataField, value);

            if (newValue && newValue.cancel) return;

            await dataSource.current.updateItem(rowKey, { [dataField]: newValue }, opts);
            if (isShowEdittedRowsOnly()) refresh(true);
            else refreshAndPaint();
        },
        [isShowEdittedRowsOnly, refresh, refreshAndPaint, props.onCellValueChanging]
    );

    const resetCellValue = useCallback(
        async (rowKey, dataField, opts) => {
            var cached = await dataSource.current.getCachedItem(rowKey);
            if (!cached) return;

            var newValue = cached[dataField];
            if (props.onCellValueChanging) newValue = await props.onCellValueChanging(rowKey, dataField, newValue);

            if (newValue && newValue.cancel) return;

            await dataSource.current.resetEditedItem(rowKey, opts);
            if (isShowEdittedRowsOnly()) refresh(true);
            else refreshAndPaint();
        },
        [isShowEdittedRowsOnly, refresh, refreshAndPaint, props.onCellValueChanging]
    );

    const selectRow = useCallback(
        (rowData, field) => {
            var keyField = getKeyField();
            var keyValue = rowData[keyField];
            var col = null;
            if (props.columns instanceof Array) col = props.columns.find((col) => col.isMarkSelected && col.dataField === markSelectedField.current);

            if (col && (!field || col.dataField === field)) {
                var currentValue = rowData[col.dataField];

                if (col.defaultValue) {
                    var value = null;

                    if (col.defaultValue.formula instanceof Array) {
                        var itemFormula = col.defaultValue.formula;

                        var fm = itemFormula[0];
                        var defaultNullValue =
                            itemFormula[1] !== undefined && itemFormula[1] !== null && typeof itemFormula[1] === 'number' ? itemFormula[1] : 0;
                        value = calculator.execNum(rowData, fm, defaultNullValue);
                    } else if (col.defaultValue.rowField && rowData[col.defaultValue.rowField] !== undefined) {
                        value = rowData[col.defaultValue.rowField];
                    } else if (col.defaultValue.rowField1 && rowData[col.defaultValue.rowField1] !== undefined) {
                        value = rowData[col.defaultValue.rowField1];
                    } else if (col.defaultValue.rowField2 && rowData[col.defaultValue.rowField2] !== undefined) {
                        value = rowData[col.defaultValue.rowField2];
                    } else if (col.defaultValue.rowField3 && rowData[col.defaultValue.rowField3] !== undefined) {
                        value = rowData[col.defaultValue.rowField3];
                    }

                    if (col.defaultValue.minValue !== undefined) {
                        var setMin = false;

                        if (value == undefined) setMin = true;
                        else if (col.defaultValue.minWhen instanceof Array) {
                            setMin = col.defaultValue.minWhen.includes(value);
                        } else if (value == null) setMin = true;

                        if (setMin) value = col.defaultValue.minValue;
                    }

                    // if ((value == undefined || value == null ||value === 0) && col.defaultValue.minValue !== undefined) value = col.defaultValue.minValue;
                    // if (value == null || value === 0) value = 1;

                    // if (currentValue !== value)
                    setCellValue(keyValue, col.dataField, value);
                    // else this.setCellValue(keyValue, col.dataField, 0);
                }
            }
        },
        [getKeyField, props.columns, setCellValue]
    );

    const unSelectRow = useCallback(
        (rowData, field) => {
            var keyField = getKeyField();
            var keyValue = rowData[keyField];

            var col = null;

            if (props.columns instanceof Array) col = props.columns.find((col) => col.isMarkSelected && col.dataField === markSelectedField.current);

            if (col && (!field || col.dataField === field)) resetCellValue(keyValue, col.dataField);
        },
        [getKeyField, props.columns, resetCellValue]
    );

    const onCellClick = useCallback(
        (e) => {
            if (!e || !e.column) return;

            if (e.rowType === 'header') {
                if (e.component) {
                    let colId = e.column.dataField ? e.column.dataField : e.columnIndex;

                    if (sortByColumn.current && sortByColumn.current !== e.column.dataField) {
                        e.component.beginUpdate();
                        e.component.clearSorting();
                        e.component.columnOption(sortByColumn.current, {
                            sortOrder: null
                        });
                        e.component.endUpdate();
                    }

                    if (e.column.sortOrder === 'asc') {
                        setTimeout(
                            (comp, colId) => {
                                if (sortType.current !== 'desc') {
                                    comp.beginUpdate();
                                    comp.clearSorting();
                                    comp.columnOption(colId, {
                                        sortOrder: 'desc'
                                    });
                                    comp.endUpdate();
                                }
                            },
                            300,
                            e.component,
                            colId
                        );
                    }
                    if (e.column.sortOrder === 'desc') {
                        setTimeout(
                            (comp, colId) => {
                                if (sortType.current !== 'asc') {
                                    comp.beginUpdate();
                                    comp.clearSorting();
                                    comp.columnOption(colId, {
                                        sortOrder: 'asc'
                                    });
                                    comp.endUpdate();
                                }
                            },
                            300,
                            e.component,
                            colId
                        );
                    }
                }

                return;
            }

            var field = e.column.dataField;

            var canSelect = Boolean(markSelectedField.current);
            var hasEditableCol = mainColumns.some((c) => !c.isSystemCol && c.editable && c.visible);
            var isOK =
                selectable ||
                (canSelect && !hasEditableCol) ||
                (e.data && field === markSelectedField.current && e.column.dataType === 'boolean');

            if (isOK && e.data) {
                var keyField = getKeyField();
                var keyValue = e.data[keyField];

                var rowData = e.data;
                if (dataSource.current) rowData = dataSource.current.getItem(keyValue);

                if (rowData) {
                    if (grid.current && grid.current.instance) grid.current.instance.beginUpdate();

                    if (field === markSelectedField.current && e.column.dataType === 'boolean') {
                        if (e.value === true) unSelectRow(rowData, field);
                        else selectRow(rowData, field);
                    } else {
                        if (rowData[markSelectedField.current]) {
                            unSelectRow(rowData, markSelectedField.current);
                        } else {
                            selectRow(rowData, markSelectedField.current);
                        }
                    }

                    if (grid.current && grid.current.instance) grid.current.instance.endUpdate();
                }
            }
            if (props.onCellClick) props.onCellClick(e);
        },
        [mainColumns, getKeyField, unSelectRow, selectRow, selectable, props.onCellClick]
    );

    const onFocusedRowChanged = useCallback(
        (e) => {
            const dataRow = e.row && e.row.data;
            setFocusedRow({ row: dataRow ? dataRow : null });
            selectRow(dataRow);
            if (props.onFocusedRowChanged) props.onFocusedRowChanged(focusedRow);
        },
        [selectRow, props.onFocusedRowChanged]
    );

    // Ghi nhận độ rộng người dùng kéo (tiêu đề cột hoặc góc ô nhập nhiều dòng): lưu localStorage + cập nhật cấu hình cột.
    // deferLayout: editor trong ô đang mở — đổi minWidth / phân bổ lại cột làm DevExtreme vẽ lại toàn bộ dòng
    // (editor bị dựng lại, mất chiều cao vừa kéo) nên để đến khi đóng editor (flushUserColumnLayout).
    const pendingUserColumnLayout = useRef(null);
    const flushUserColumnLayout = useCallback(() => {
        const pending = pendingUserColumnLayout.current;
        if (!pending) return;
        pendingUserColumnLayout.current = null;
        (mainColumnsRef.current || []).forEach((col) => {
            if (col._antFlexibleWidth && pending[col.dataField] !== undefined) col._antUserMinWidth = pending[col.dataField];
        });
        if (grid.current && grid.current.instance) scheduleGridBestFit(grid.current.instance, mainColumnsRef.current, gridWidthCache);
    }, [gridWidthCache]);
    const commitUserColumnWidths = useCallback(
        (changed, deferLayout) => {
            const fields = Object.keys(changed);
            if (!fields.length) return;
            writeSavedColWidths(changed);
            const defs = mainColumnsRef.current || [];
            defs.forEach((col) => {
                if (!fields.includes(col.dataField)) return;
                if (col._antFlexibleWidth) {
                    // Cột auto: giữ co giãn, độ rộng vừa kéo thành mức tối thiểu.
                    col._antUserMinWidth = changed[col.dataField];
                    return;
                }
                backupAutoWidth(col);
                col.width = changed[col.dataField];
                delete col._antBestFit;
                col._antUserWidth = true;
            });
            // Cấu hình cột đã khớp → áp lại width: devextreme-react có thể đã trả option về độ rộng cũ trong props.
            const instance = grid.current && grid.current.instance;
            if (instance && !deferLayout) {
                instance.beginUpdate();
                try {
                    defs.forEach((col) => {
                        if (!fields.includes(col.dataField) || col._antFlexibleWidth) return;
                        instance.columnOption(col.dataField, 'visibleWidth', undefined);
                        instance.columnOption(col.dataField, 'width', col.width);
                    });
                } finally {
                    instance.endUpdate();
                }
            }
            if (deferLayout) {
                pendingUserColumnLayout.current = { ...(pendingUserColumnLayout.current || {}), ...changed };
                return;
            }
            // Phân phối lại chỗ trống theo độ rộng mới (cột auto nhận phần còn thừa).
            if (grid.current && grid.current.instance) scheduleGridBestFit(grid.current.instance, mainColumnsRef.current, gridWidthCache);
        },
        [writeSavedColWidths, gridWidthCache]
    );


    // Tự căn độ rộng các cột (nhấp đúp vạch ngăn) — hàm định nghĩa sau scheduleGridHeaderLayout.
    const autoFitVisibleColumnsRef = useRef(null);

    // Bắt thao tác kéo đổi độ rộng của NGƯỜI DÙNG (best-fit cũng đổi width bằng columnOption nên không
    // dựa vào optionChanged): kéo vạch ngăn cột → thả chuột → lưu các cột đã đổi.
    useEffect(() => {
        const element = gridContainer.current;
        if (!element || !allowColumnResizing) return undefined;
        let before = null;
        // Mốc nhấp đúp tự căn: 2 lượt nhấp có thể lệch 1px — bước lưu (trễ 150ms sau khi thả chuột) bỏ qua.
        let autoFitAt = 0;
        const snapshot = () => {
            const instance = grid.current && grid.current.instance;
            if (!instance) return null;
            const widths = new Map();
            instance.getVisibleColumns().forEach((c) => {
                if (c.dataField && !c.command) widths.set(c.dataField, typeof c.width === 'number' ? c.width : c.visibleWidth);
            });
            return widths;
        };
        let downX = 0;
        const onDown = (e) => {
            if (e.target && e.target.closest && e.target.closest('.dx-datagrid-columns-separator')) {
                before = snapshot();
                downX = e.clientX;
            }
        };
        const onUp = (e) => {
            if (!before) return;
            const previous = before;
            before = null;
            // Nhấn vạch ngăn mà không kéo: độ rộng có đổi trong lúc đó là do lưới tự chia chỗ (dữ liệu mới, sắp xếp…),
            // không phải người dùng → không lưu.
            if (Math.abs(e.clientX - downX) < 2) return;
            setTimeout(() => {
                if (Date.now() - autoFitAt < 600) return;
                const instance = grid.current && grid.current.instance;
                if (!instance) return;
                const defs = mainColumnsRef.current || [];
                // Lưới KHÔNG có cột tự ẩn (có thì AntGrid tự xử lý kéo — onOwnResizeDown): DevExtreme (nextColumn) đổi cột
                // kéo và cột kế bên bù phần chênh → lưu cả hai đúng như người dùng thấy.
                const changed = {};
                instance.getVisibleColumns().forEach((c) => {
                    if (!c.dataField || c.command || !previous.has(c.dataField)) return;
                    const def = defs.find((d) => d.dataField === c.dataField);
                    if (def && def.isSystemCol && !isResizableSystemColumn(def)) return;
                    const width = typeof c.width === 'number' ? c.width : c.visibleWidth;
                    if (typeof width === 'number' && Math.abs(width - (previous.get(c.dataField) || 0)) >= 1) changed[c.dataField] = Math.round(width);
                });
                commitUserColumnWidths(changed);
            }, 150);
        };
        // Nhấp đúp ranh giới 2 cột ở tiêu đề (DevExtreme không có sẵn): tự căn mọi cột đang hiện (AntGridHeaderDblClick).
        const detachDblClick = attachHeaderBoundaryDblClick(element, {
            hint: AntLocalization.translateText({
                vi: 'Kéo để đổi độ rộng · Nhấp đúp để tự căn độ rộng các cột',
                en: 'Drag to resize · Double-click to auto-fit all columns',
                fr: 'Glisser pour redimensionner · Double-clic : ajuster les colonnes',
                es: 'Arrastre para ajustar · Doble clic: autoajustar columnas',
                id: 'Seret untuk ubah lebar · Klik ganda: sesuaikan semua kolom',
                ja: 'ドラッグで幅変更 · ダブルクリックで全列自動調整',
                zh: '拖动调整宽度 · 双击自动适应所有列',
                ko: '드래그로 너비 조정 · 더블클릭으로 전체 열 자동 맞춤',
                hi: 'आकार बदलने हेतु खींचें · डबल-क्लिक: कॉलम ऑटो-फ़िट',
                ar: 'اسحب لتغيير العرض · نقر مزدوج للضبط التلقائي للأعمدة'
            }),
            onAutoFit: () => {
                autoFitAt = Date.now();
                before = null;
                if (autoFitVisibleColumnsRef.current) autoFitVisibleColumnsRef.current();
            }
        });
        // Lưới đang có cột tự ẩn (màn hẹp): tự xử lý kéo thay DevExtreme — CHỈ cột được kéo đổi độ rộng, cột kế bên giữ
        // nguyên; phần trống để trống tới khi đủ chỗ thì cột tự ẩn hiện ra (holdGridLayoutUntilReveal).
        let ownDrag = null;
        const endOwnDrag = () => {
            if (!ownDrag) return;
            const drag = ownDrag;
            ownDrag = null;
            window.removeEventListener('pointermove', drag.onMove, true);
            window.removeEventListener('pointerup', drag.onEnd, true);
            window.removeEventListener('pointercancel', drag.onEnd, true);
            document.documentElement.classList.remove('ant-grid-col-resizing');
            if (drag.frame) cancelAnimationFrame(drag.frame);
            if (!drag.moved) return;
            drag.apply();
            holdGridLayoutUntilReveal(drag.instance);
            commitUserColumnWidths({ [drag.field]: drag.width });
        };
        const onOwnResizeDown = (e) => {
            if (typeof e.button === 'number' && e.button !== 0) return;
            if (!e.target || !e.target.closest || !e.target.closest('.dx-datagrid-columns-separator')) return;
            const instance = grid.current && grid.current.instance;
            if (!instance || instance.option('columnResizingMode') === 'widget' || !hasAdaptiveHiddenColumns(instance)) return;
            // Cột có mép phải tại vạch ngăn.
            let cell = null;
            let distance = 4;
            element.querySelectorAll('.dx-datagrid-headers .dx-header-row > td').forEach((td) => {
                if (!td.id || !td.offsetWidth) return;
                const d = Math.abs(td.getBoundingClientRect().right - e.clientX);
                if (d <= distance) {
                    distance = d;
                    cell = td;
                }
            });
            if (!cell) return;
            const column = instance.getVisibleColumns().find((c) => c.headerId === cell.id);
            if (!column || !column.dataField || column.command || column.allowResizing === false) return;
            const def = (mainColumnsRef.current || []).find((d) => d.dataField === column.dataField);
            if (def && def.isSystemCol && !isResizableSystemColumn(def)) return;
            e.stopImmediatePropagation();
            e.stopPropagation();
            e.preventDefault();
            endOwnDrag();
            const key = column.dataField;
            const startX = e.clientX;
            const startWidth = cell.getBoundingClientRect().width;
            const min = Math.max(20, Number(instance.columnOption(key, 'minWidth')) || GRID_RESIZE_FLOOR);
            const drag = { instance, field: column.dataField, width: Math.round(startWidth), moved: false, frame: 0 };
            drag.apply = () => {
                drag.frame = 0;
                instance.beginUpdate();
                try {
                    instance.columnOption(key, 'visibleWidth', undefined);
                    instance.columnOption(key, 'width', drag.width);
                } finally {
                    instance.endUpdate();
                }
            };
            drag.onMove = (ev) => {
                const width = Math.max(min, Math.round(startWidth + ev.clientX - startX));
                if (width === drag.width) return;
                drag.width = width;
                drag.moved = true;
                if (!drag.frame) drag.frame = requestAnimationFrame(drag.apply);
            };
            drag.onEnd = () => endOwnDrag();
            ownDrag = drag;
            // Giữ bố cục trong lúc kéo: cột khác không nhận phần trống (thả chuột mới xét hiện cột tự ẩn).
            holdGridLayoutUntilReveal(instance, { sticky: true });
            document.documentElement.classList.add('ant-grid-col-resizing');
            window.addEventListener('pointermove', drag.onMove, true);
            window.addEventListener('pointerup', drag.onEnd, true);
            window.addEventListener('pointercancel', drag.onEnd, true);
        };
        element.addEventListener('pointerdown', onOwnResizeDown, true);
        element.addEventListener('pointerdown', onDown, true);
        document.addEventListener('pointerup', onUp, true);
        return () => {
            endOwnDrag();
            element.removeEventListener('pointerdown', onOwnResizeDown, true);
            detachDblClick();
            element.removeEventListener('pointerdown', onDown, true);
            document.removeEventListener('pointerup', onUp, true);
        };
    }, [isRender, allowColumnResizing, commitUserColumnWidths]);

    // ---- Nhập trực tiếp: dòng nháp, lưu tự động, cảnh báo theo dòng ----
    // Giá trị mặc định của dòng nháp — cùng popup Thêm: create/prepare (BE) + copyFromHeaderFields + defaultObj/default.
    const getInlineDraftBase = useCallback(() => {
        if (!inlinePrepared.current) return null;
        return {
            ...buildInlineDraftBase({
                prepared: inlinePrepared.current,
                parentData: props.parentData,
                copyFromParentFields: inlineCopyFields,
                formItems: inlineFormItems,
                defaultObj: props.add ? props.add.defaultObj : undefined
            }),
            ...searchParentConditions
        };
    }, [props.parentData, inlineCopyFields, inlineFormItems, props.add, searchParentConditions]);

    const dsGetAppendRows = useCallback(() => {
        const base = canInlineAdd ? getInlineDraftBase() : null;
        if (!base) return [];
        const row = applyInlineFormulas({ ...base, ...inlineDraftValues.current }, inlineFormItems);
        return [{ ...row, id: INLINE_DRAFT_ID, warnings: undefined, actions: undefined }];
    }, [canInlineAdd, getInlineDraftBase, inlineFormItems]);

    // create/prepare một lần cho lưới nhập trực tiếp: giá trị mặc định + lookups cho dòng nháp, và (khi
    // không có form) metadata field sửa được từ BE.
    useEffect(() => {
        if (!inlineEdit) return undefined;
        let cancelled = false;
        (async () => {
            let prepared = null;
            if (props.API && props.API.postCreatePrepare) {
                try {
                    prepared = await props.API.postCreatePrepare(
                        { ...searchParentConditions },
                        {
                            ...((props.add && props.add.prepareConditions) || props.prepareConditions || {}),
                            ...(hasInlineForm ? {} : { withInlineFields: true })
                        }
                    );
                } catch (e) {
                    prepared = null;
                }
            }
            if (cancelled) return;
            inlineLookups.current = prepared && prepared.lookups instanceof Array ? prepared.lookups : [];
            const clean = prepared && typeof prepared === 'object' && !prepared.error ? { ...prepared } : {};
            ['lookups', 'actions', 'edit', 'delete', 'infos', 'approve', 'warnings', 'inlineFields'].forEach((k) => delete clean[k]);
            inlinePrepared.current = clean;
            if (!hasInlineForm) setInlineMeta(prepared && prepared.inlineFields instanceof Array ? prepared.inlineFields : []);
            if (loaded.current) refreshAndPaint();
        })();
        return () => {
            cancelled = true;
        };
    }, [inlineEdit, hasInlineForm, props.parentData && props.parentData.id, props.parentData && props.parentData.code]);


    // Nạp lại sau khi lưu nhưng HOÃN khi người dùng còn đang gõ ở một ô của lưới (Tab sang ô kế):
    // nạp giữa chừng sẽ vẽ lại dòng và mất ô đang nhập. Lưu lên BE vẫn chạy ngay.
    const inlineReloadTimer = useRef();
    const inlinePendingReload = useRef(null);
    const scheduleInlineReload = useCallback(
        (mode) => {
            inlinePendingReload.current = inlinePendingReload.current === 'full' || mode === 'full' ? 'full' : 'paint';
            clearTimeout(inlineReloadTimer.current);
            const attempt = () => {
                const root = gridContainer.current;
                const typing = root && root.querySelector('.dx-datagrid-rowsview .dx-editor-cell .dx-state-focused, .dx-datagrid-rowsview .dx-editor-cell :focus');
                if (typing) {
                    inlineReloadTimer.current = setTimeout(attempt, 400);
                    return;
                }
                const pending = inlinePendingReload.current;
                inlinePendingReload.current = null;
                if (pending === 'full') {
                    if (refreshRef.current) refreshRef.current();
                } else refreshAndPaint();
            };
            inlineReloadTimer.current = setTimeout(attempt, 50);
        },
        [refreshAndPaint]
    );
    useEffect(() => () => clearTimeout(inlineReloadTimer.current), []);

    const inlineFieldCaption = useCallback((field) => {
        const cols = mainColumnsRef.current instanceof Array ? mainColumnsRef.current : [];
        const col = cols.find((c) => c._antInlineField === field) || cols.find((c) => c.dataField === field);
        return col ? AntLocalization.translateText(col.caption || col.label || field) : field;
    }, []);

    const runInlineSave = useCallback(
        async (row, patch) => {
            const invalidText = { vi: 'Dữ liệu không hợp lệ!', en: 'Invalid data !', fr: 'Données invalides !', es: '¡Datos inválidos!', id: 'Data tidak valid!', ja: '無効なデータ！', zh: '数据无效！', ko: '잘못된 데이터!', hi: 'अमान्य डेटा!', ar: 'بيانات غير صالحة!' };
            const reload = () => scheduleInlineReload('full');

            if (isInlineDraftRow(row)) {
                inlineDraftValues.current = { ...inlineDraftValues.current, ...patch };
                inlineDraftError.current = null;
                const full = applyInlineFormulas({ ...(getInlineDraftBase() || {}), ...inlineDraftValues.current }, inlineFormItems);
                // Chưa đủ field bắt buộc: giữ nháp, chỉ vẽ lại (không gọi API).
                if (getMissingRequiredFields(full, inlineFormItems).length > 0) {
                    scheduleInlineReload('paint');
                    return;
                }
                const payload = buildInlineCreatePayload({
                    row: full,
                    formItems: inlineFormItems,
                    postFields: props.add ? props.add.postFields : undefined,
                    parentFK: props.parentFK,
                    parentData: props.parentData,
                    copyFromParentFields: inlineCopyFields
                });
                const validation = await props.API.postCreateValidation(payload);
                let error = config.translateFirstError(validation, invalidText);
                let errorField = error ? getResultErrorField(validation) : null;
                if (!error) {
                    const result = await props.API.postCreate(payload);
                    if (!result || result.error || !result.data || !result.data.inserted) {
                        error = config.translateFirstError(result, invalidText);
                        errorField = getResultErrorField(result);
                    }
                }
                if (error) {
                    // Lỗi kèm field → hiện ngay tại ô của field đó (và ở biểu tượng dòng).
                    inlineDraftError.current = { message: error, field: errorField };
                    notify(error, 'error', 4000);
                    scheduleInlineReload('paint');
                    return;
                }
                inlineDraftValues.current = {};
                reload();
                if (props.onDataSourceEdited) props.onDataSourceEdited({ field: null, value: payload });
                return;
            }

            const key = props.keyExpr ? props.keyExpr : 'id';
            // FE kiểm tra trước: xoá trống field bắt buộc → không lưu (giữ giá trị cũ), báo ngay tại ô.
            const clearedRequired = getMissingRequiredFields({ ...row, ...patch }, inlineFormItems).filter((field) =>
                Object.prototype.hasOwnProperty.call(patch, field)
            );
            if (clearedRequired.length) {
                const message = clearedRequired.map(inlineFieldCaption).join(', ') + ': ' + AntLocalization.translateText(INLINE_TEXTS.required);
                inlineRowErrors.current.set(row[key], { message, field: clearedRequired[0] });
                notify(message, 'error', 4000);
                scheduleInlineReload('paint');
                return;
            }
            const ref = { [key]: row[key], checksum: row.checksum };
            const validation = await props.API.postUpdateValidation(ref, patch);
            let error = config.translateFirstError(validation, invalidText);
            let errorField = error ? getResultErrorField(validation) : null;
            if (!error) {
                const result = await props.API.postUpdate(ref, patch);
                if (!result || result.error || !result.data || !result.data.updated) {
                    error = config.translateFirstError(result, invalidText);
                    errorField = getResultErrorField(result);
                }
            }
            if (error) {
                // Lỗi BE không nói field: gắn vào field vừa sửa (1 ô) để người dùng thấy ô gây lỗi.
                const patchFields = Object.keys(patch || {});
                inlineRowErrors.current.set(row[key], { message: error, field: errorField || (patchFields.length === 1 ? patchFields[0] : null) });
                notify(error, 'error', 4000);
            } else inlineRowErrors.current.delete(row[key]);
            // Nạp lại để lấy giá trị BE tính (Thành tiền, thuế...), checksum mới và cảnh báo theo dòng.
            reload();
            if (!error && props.onDataSourceEdited) props.onDataSourceEdited({ field: row[key], value: patch });
        },
        [config, inlineFormItems, inlineCopyFields, inlineFieldCaption, getInlineDraftBase, scheduleInlineReload, props.add, props.API, props.parentFK, props.parentData, props.keyExpr, props.onDataSourceEdited]
    );

    // Lưu tuần tự: sửa liên tiếp nhiều ô không chạy song song (checksum).
    const onInlineCommit = useCallback(
        (row, patch) => {
            inlineQueue.current = inlineQueue.current.then(() => runInlineSave(row, patch)).catch(() => {});
        },
        [runInlineSave]
    );

    // Chiều cao dòng lúc CHƯA mở editor — editor nhiều dòng mở ra cao bằng (dựng editor xong dòng đã co lại).
    const inlineEditRowHeight = useRef(0);

    // Kéo góc ô nhập nhiều dòng: đổi độ rộng cột trực tiếp (editor vẫn mở), thả chuột thì lưu như kéo tiêu đề.
    // Chỉ đổi width (đổi minWidth làm DevExtreme vẽ lại dòng → editor bị dựng lại); minWidth và phân bổ lại
    // các cột chạy khi đóng editor.
    const resizeInlineColumn = useCallback(
        (dataField, width, done) => {
            const instance = grid.current && grid.current.instance;
            if (!instance || !dataField || !(width > 0)) return;
            const def = (mainColumnsRef.current || []).find((d) => d.dataField === dataField);
            // Sửa cấu hình cột TRƯỚC: devextreme-react so option với props (chính các object cột này) —
            // lệch là tự trả về độ rộng cũ và cũng vẽ lại toàn bộ dòng.
            if (def) def.width = width;
            const minWidth = instance.columnOption(dataField, 'minWidth');
            const next = typeof minWidth === 'number' && minWidth > width ? minWidth : width;
            instance.beginUpdate();
            try {
                instance.columnOption(dataField, 'visibleWidth', undefined);
                instance.columnOption(dataField, 'width', next);
            } finally {
                instance.endUpdate();
            }
            if (def) def.width = next;
            if (done) commitUserColumnWidths({ [dataField]: Math.round(width) }, true);
        },
        [commitUserColumnWidths]
    );

    const onInlineEditingStart = useCallback(
        (e) => {
            inlineEditRowHeight.current = 0;
            try {
                const index = e.component.getRowIndexByKey(e.key);
                const rowElement = index >= 0 ? e.component.getRowElement(index) : null;
                const node = rowElement && (rowElement[0] || (rowElement.get && rowElement.get(0)));
                if (node) inlineEditRowHeight.current = node.offsetHeight;
            } catch (err) {
                // không đo được: editor dùng chiều cao mặc định
            }
            const draft = isInlineDraftRow(e.data);
            if (!e.column || !e.column._antInlineField) {
                if (draft) e.cancel = true;
                return;
            }
            if (draft ? !canInlineAdd : !canInlineEditRows) {
                e.cancel = true;
                return;
            }
            // Field khoá / ẩn theo điều kiện của form (disable / visible dạng { when }) — xét trên dữ liệu dòng
            // (ưu tiên) + phiếu cha, như form thêm/sửa dòng.
            const item = inlineFieldMapRef.current.get(e.column.dataField);
            const hasCondition = (v) => v !== undefined && v !== null && typeof v === 'object';
            if (item && (hasCondition(item.disable) || hasCondition(item.disabled) || hasCondition(item.visible) || hasCondition(item.editable))) {
                const data = { ...(props.parentData || {}), ...(e.data || {}) };
                const disabled =
                    (hasCondition(item.disabled) && AntCondition.isValid(data, item.disabled)) ||
                    ((hasCondition(item.disable) || hasCondition(item.editable)) && AntCondition.isDisable(data, item)) ||
                    (hasCondition(item.visible) && !AntCondition.isVisible(data, item));
                if (disabled) e.cancel = true;
            }
        },
        [canInlineAdd, canInlineEditRows, props.parentData]
    );

    const renderInlineEditCell = useCallback(
        (cellInfo) => {
            const item = inlineFieldMapRef.current.get(cellInfo.column.dataField);
            if (!item) return null;
            const close = () => {
                try {
                    cellInfo.component.cancelEditData();
                } catch (e) {
                    // lưới đã huỷ
                }
            };
            return (
                <AntGridCellEditor
                    item={item}
                    config={config}
                    tableName={tableName}
                    API={props.API}
                    row={cellInfo.data}
                    prepareLookups={inlineLookups.current}
                    multiline={Boolean(cellInfo.column._antMultiline)}
                    rowHeight={inlineEditRowHeight.current}
                    onClose={flushUserColumnLayout}
                    onResizeColumn={
                        allowColumnResizing ? (width, done) => resizeInlineColumn(cellInfo.column.dataField, width, done) : undefined
                    }
                    onCommit={(patch, opts) => {
                        const row = cellInfo.data;
                        // Ghi ngay vào dòng đang hiển thị: ô kế tiếp (Tab) thấy giá trị mới trước khi nạp lại.
                        if (row && typeof row === 'object') Object.assign(row, patch);
                        if (opts && opts.close) close();
                        onInlineCommit({ ...row }, patch);
                    }}
                    onCancel={close}
                />
            );
        },
        [config, tableName, props.API, onInlineCommit, allowColumnResizing, resizeInlineColumn, flushUserColumnLayout]
    );

    // Nút mở form sửa ở cột trạng thái (cùng chỗ dấu + của dòng nháp): giống nhấp đúp dòng — có form sửa
    // (edit.items), được phép sửa trên lưới (canEditAction) và dòng cho sửa (quyền theo dòng từ BE).
    const hasInlineEditPopup = inlineActive && showEdit && Boolean(props.edit) && props.edit.items instanceof Array;
    const canOpenInlineEditPopup = useCallback(
        (row) =>
            hasInlineEditPopup &&
            Boolean(row) &&
            !isInlineDraftRow(row) &&
            Boolean(row.id) &&
            getSelectionActionPermissions([row], { canEdit: canEditAction }).enableEdit,
        [hasInlineEditPopup, canEditAction]
    );

    // ---- Lỗi / cảnh báo của lưới nhập trực tiếp: tại ô + ở biểu tượng dòng ----
    const tt = useCallback((text) => AntLocalization.translateText(text), []);
    // Field (addForm) → cột lưới hiển thị nó (null: không có cột).
    const inlineColumnOf = useCallback((field) => {
        const cols = mainColumnsRef.current instanceof Array ? mainColumnsRef.current : [];
        const col = cols.find((c) => c._antInlineField === field) || cols.find((c) => c.dataField === field && !c.isSystemCol);
        return col ? col.dataField : null;
    }, []);
    // Field bắt buộc còn trống của 1 dòng. Dòng đã lưu: chỉ xét field lưới có tải về (có khoá trong dòng) và có cột.
    const getInlineMissing = useCallback(
        (row) => {
            if (!row) return [];
            if (isInlineDraftRow(row)) return Object.keys(inlineDraftValues.current).length ? getMissingRequiredFields(row, inlineFormItems) : [];
            return getMissingRequiredFields(row, inlineFormItems).filter(
                (field) => Object.prototype.hasOwnProperty.call(row, field) && inlineColumnOf(field)
            );
        },
        [inlineFormItems, inlineColumnOf]
    );
    const getInlineRowError = useCallback(
        (row) => {
            if (!row) return null;
            if (isInlineDraftRow(row)) return inlineDraftError.current;
            return inlineRowErrors.current.get(row[props.keyExpr ? props.keyExpr : 'id']) || null;
        },
        [props.keyExpr]
    );
    const getInlineCellIssues = useCallback(
        (row) =>
            buildInlineCellIssues({
                missing: getInlineMissing(row),
                error: getInlineRowError(row),
                warnings: row && !isInlineDraftRow(row) && row.warnings instanceof Array ? row.warnings : [],
                columnOf: inlineColumnOf,
                translate: tt
            }),
        [getInlineMissing, getInlineRowError, inlineColumnOf, tt]
    );
    // Gắn dấu lỗi/cảnh báo vào 1 ô (td): viền + biểu tượng góc có tooltip nội dung.
    const applyInlineCellIssue = useCallback((cellElement, issue) => {
        const td = cellElement && cellElement.get ? cellElement.get(0) : cellElement;
        if (!td || !td.classList) return;
        const old = td.querySelector(':scope > .ant-grid-cell-issue');
        if (old) old.remove();
        td.classList.remove('ant-grid-cell-invalid', 'ant-grid-cell-warn');
        if (!issue || !issue.messages.length) return;
        td.classList.add(issue.level === 'error' ? 'ant-grid-cell-invalid' : 'ant-grid-cell-warn');
        const badge = document.createElement('span');
        badge.className = 'ant-grid-cell-issue';
        badge.textContent = '!';
        badge.title = issue.messages.join('\n');
        td.appendChild(badge);
    }, []);
    // DevExtreme chỉ vẽ lại ô có giá trị đổi (repaintChangesOnly) → quét lại toàn bộ ô sau mỗi lần vẽ.
    const decorateInlineCells = useCallback(() => {
        const instance = grid.current && grid.current.instance;
        if (!instance || !inlineActive) return;
        const cols = instance.getVisibleColumns().filter((c) => c.dataField && !c.command && c.visibleWidth !== 'adaptiveHidden');
        instance.getVisibleRows().forEach((r) => {
            if (r.rowType !== 'data') return;
            const issues = getInlineCellIssues(r.data);
            cols.forEach((c) => {
                const cell = instance.getCellElement(r.rowIndex, c.dataField);
                if (cell) applyInlineCellIssue(cell, issues.get(c.dataField));
            });
        });
    }, [inlineActive, getInlineCellIssues, applyInlineCellIssue]);
    inlineCellIssueRef.current = inlineActive ? { getInlineCellIssues, applyInlineCellIssue } : null;

    const renderInlineStatusCell = useCallback(
        (cell) => {
            const row = (cell && cell.data) || {};
            let icon = null;
            let color = '#8a94a6';
            let title = '';
            let openEdit = false;
            // "Tên cột: nội dung" — người dùng biết ô nào cần sửa.
            const withField = (field, message) => {
                const text = message || tt(INLINE_TEXTS.reviewRow);
                return field ? inlineFieldCaption(field) + ': ' + text : text;
            };
            const missingLine = (missing) => tt(INLINE_TEXTS.missing) + missing.map(inlineFieldCaption).join(', ');
            const error = getInlineRowError(row);
            const missing = getInlineMissing(row);
            if (isInlineDraftRow(row)) {
                const started = Object.keys(inlineDraftValues.current).length > 0;
                if (error) {
                    icon = 'warning';
                    color = '#d9534f';
                    title = tt(INLINE_TEXTS.rowError) + '\n' + withField(error.field, error.message);
                } else if (started) {
                    icon = 'edit';
                    title = tt(INLINE_TEXTS.notSaved) + (missing.length ? '. ' + missingLine(missing) : '');
                } else {
                    icon = 'add';
                    color = 'var(--AnteTitleColor)';
                    title = tt(INLINE_TEXTS.newRow);
                }
            } else {
                const warnings = (row.warnings instanceof Array ? row.warnings : []).filter(Boolean);
                const lines = [];
                if (error) lines.push(tt(INLINE_TEXTS.rowError), withField(error.field, error.message));
                if (missing.length) lines.push(missingLine(missing));
                if (warnings.length) {
                    lines.push(tt(INLINE_TEXTS.rowWarning) + ':');
                    warnings.forEach((w) => lines.push('• ' + withField(w.field, inlineMessageText(w.message, tt))));
                }
                if (lines.length) {
                    icon = 'warning';
                    color = error || missing.length ? '#d9534f' : '#e0a800';
                    title = lines.join('\n');
                }
                if (canOpenInlineEditPopup(row)) {
                    openEdit = true;
                    // Có cảnh báo/lỗi: giữ biểu tượng cảnh báo (bấm vẫn mở form sửa để xử lý).
                    if (!icon) {
                        icon = 'edit';
                        title = tt(INLINE_TEXTS.openEdit);
                    } else title = title + '\n' + tt(INLINE_TEXTS.clickToEdit);
                }
            }
            if (!icon) return <div />;
            if (!openEdit) return <i className={'dx-icon dx-icon-' + icon + ' ant-grid-inline-status'} title={title} style={{ color: color }} />;
            return (
                <i
                    role="button"
                    className={'dx-icon dx-icon-' + icon + ' ant-grid-inline-status ant-grid-inline-status-action' + (icon === 'edit' ? ' ant-grid-inline-open-edit' : '')}
                    title={title}
                    style={icon === 'edit' ? undefined : { color: color }}
                    onClick={(e) => {
                        e.stopPropagation();
                        showEditPopup(row.id);
                    }}
                />
            );
        },
        [tt, inlineFieldCaption, getInlineRowError, getInlineMissing, canOpenInlineEditPopup, showEditPopup]
    );

    // ---- Bộ lọc trên cột (dòng lọc) ----
    // Áp dụng: lưu cấu hình, về trang đầu, nạp lại — bỏ qua khi điều kiện không đổi (gõ rồi xoá, đổi định dạng số...).
    const applyColumnFilters = useCallback(() => {
        clearTimeout(columnFilterTimer.current);
        columnFilterTimer.current = null;
        saveCachingStates();
        const defs = mainColumnsRef.current || [];
        const nextKey = stringify(
            filterRowVisible.current
                ? buildColumnFilterConditions(columnFilterValues.current, (field) => {
                      const def = defs.find((c) => c.dataField === field);
                      return def && def.visible !== false ? def._antFilter : null;
                  })
                : {}
        );
        if (nextKey === appliedColumnFilterKey.current) return;
        if (dsGetPageIndex() != 0) dsSetPageIndex(0);
        forceReload();
    }, [saveCachingStates, dsGetPageIndex, dsSetPageIndex, forceReload]);

    const setColumnFilterValue = useCallback(
        (field, value, immediate) => {
            const next = { ...columnFilterValues.current };
            if (value === undefined || value === null || value === '' || (Array.isArray(value) && value.length === 0)) delete next[field];
            else next[field] = value;
            columnFilterValues.current = next;
            clearTimeout(columnFilterTimer.current);
            if (immediate) applyColumnFilters();
            else columnFilterTimer.current = setTimeout(applyColumnFilters, 500);
        },
        [applyColumnFilters]
    );

    // Editor từng ô của dòng lọc theo loại cột. Không gọi e.setValue: DevExtreme không tự lọc (lưới lấy dữ liệu
    // theo trang từ server); giá trị giữ ở columnFilterValues và gán lại mỗi lần DevExtreme vẽ lại dòng lọc.
    const onGridEditorPreparing = useCallback(
        (e) => {
            if (e.parentType !== 'filterRow') return;
            const def = (mainColumnsRef.current || []).find((c) => c.dataField === e.dataField);
            prepareColumnFilterEditor(e, {
                spec: def && def._antFilter,
                value: columnFilterValues.current[e.dataField],
                onChange: (value, immediate) => setColumnFilterValue(e.dataField, value, immediate),
                focusState: activeFilterEditor
            });
        },
        [setColumnFilterValue]
    );

    // Bật/tắt dòng lọc (nút cạnh bộ lọc ngày). Tắt = bỏ mọi giá trị đang lọc trên cột.
    const setColumnLayoutFrozen = useCallback((frozen) => {
        columnLayoutFrozen.current = Boolean(frozen);
        const instance = grid.current && grid.current.instance;
        if (instance) setGridBestFitFrozen(instance, frozen);
    }, []);

    const onToggleFilterRow = useCallback(() => {
        const next = !filterRowVisible.current;
        filterRowVisible.current = next;
        const instance = grid.current && grid.current.instance;
        if (next) setColumnLayoutFrozen(true);
        if (instance) instance.option('filterRow.visible', next);
        if (!next) {
            columnFilterValues.current = {};
            // Mở chốt: ẩn hiện cột trống + độ rộng tính lại theo dữ liệu hiện tại.
            setColumnLayoutFrozen(false);
            resetColumnVisibility();
            if (instance) scheduleGridBestFit(instance, mainColumnsRef.current, gridWidthCache);
        }
        applyColumnFilters();
        return next;
    }, [applyColumnFilters, setColumnLayoutFrozen, resetColumnVisibility, gridWidthCache]);

    const onDateFilterChanged = useCallback(
        (value) => {
            dateFilterRef.current = isValidDateFilter(value) ? value : null;
            saveCachingStates();
            forceReload();
        },
        [saveCachingStates, forceReload]
    );

    const onSearchText = useCallback(
        (text) => {
            searchText.current = text;
            forceReload();
            if (props.onSearchText) props.onSearchText(text);
        },
        [props.onSearchText, forceReload]
    );

    const onDatasourceLoaded = useCallback(
        (dataRows) => {
            loading.current = false;
            loaded.current = true;

            invalidateGridBestFit(grid.current?.instance);
            resetUI();
            saveCachingStates();
            // Mở màn với dòng lọc đang bật (nhớ từ lần trước): để lượt nạp đầu tính bố cục xong rồi mới chốt.
            if (filterRowVisible.current && !columnLayoutFrozen.current && !freezeLayoutPending.current) {
                freezeLayoutPending.current = true;
                setTimeout(() => {
                    freezeLayoutPending.current = false;
                    if (filterRowVisible.current) setColumnLayoutFrozen(true);
                }, 400);
            }

            if (actionBar.current) actionBar.current.runCounting();

            if (props.onLoaded) props.onLoaded(dataRows);

            var sTextValue = dataRows && dataRows.conditions instanceof Array ? dataRows.conditions.find((c) => c.name === 'searchText') : null;
            sTextValue = sTextValue ? sTextValue.value : null;

            var totalCount = dataRows ? dataRows.totalCount : null;
            var rows = dataRows && dataRows.data instanceof Array ? dataRows.data : [];
            var row = rows instanceof Array && rows.length === 1 && totalCount === 1 ? rows[0] : null;

            if (sTextValue === searchText.current && sTextValue && row && props.autoScan && props.autoScan.fields instanceof Array) {
                if (props.autoScan.fields.some((f) => row[f] === sTextValue)) {
                    var keyField = getKeyField();
                    var keyValue = row[keyField];
                    var qtyField = markSelectedField.current;

                    var currentObj = dataSource.current.getEditedItem(keyValue);
                    var qtyValue = currentObj ? parseFloat(currentObj[qtyField]) : parseFloat(row[qtyField]);
                    if (props.autoScan.rule && props.autoScan.rule.type === 'oneByOne') {
                        if (!qtyValue) qtyValue = 1;
                        else qtyValue += 1;
                    }

                    // this.setCellValue(keyValue, qtyField, qtyValue);

                    dataSource.current.updateItem(keyValue, { [qtyField]: qtyValue });
                    if (actionBar.current) {
                        filterBySelected.current = true;
                        actionBar.current.resetItems({
                            filterBySelected: true,
                            searchText: ''
                        });
                        onSearchText('');
                    }
                }
            } else {
                if (actionBar.current) {
                    actionBar.current.resetItems({
                        shouldCount: true
                    });
                }
            }

            // if (rows.length <= 0) {
            //     repaint();
            //     setTimeout(() => {
            //         repaint();
            //     }, 500);
            // }

            //  else if (searchText) {
            //     if (actionBar.current) actionBar.current.setFilterBySelected(false);
            // }
        },
        [resetUI, saveCachingStates, props.onLoaded, props.autoScan, onSearchText, setColumnLayoutFrozen]
    );

    // const categoriesLoaded =
    //     (!props.searchCategories1 || itemsCats1Loaded.current) &&
    //     (!props.searchCategories2 || itemsCats2Loaded.current) &&
    //     (!props.searchCategories3 || itemsCats3Loaded.current) &&
    //     (!props.searchCategories4 || itemsCats4Loaded.current) &&
    //     (!props.searchCategories5 || itemsCats5Loaded.current);

    const initDataSourceConfig = useCallback(() => {
        return {
            key: props.keyExpr,
            API: props.API,
            url: props.url,
            loadFunc: props.loadFunc,
            remotePaging: isRemotePaging,
            updateMode: props.updateMode,
            allowNew: isAllowNew,

            getSearchConditions: dsGetSearchConditions,
            getParentSearchConditions: dsGetParentSearchConditions,
            getFilteredGroupConditions: dsGetFilteredGroupConditions,
            // getQueryFields: () => queryFields,
            getQueryFields: dsGetQueryFields,
            getSearchText: dsGetSearchText,
            getScanBarcode: dsGetScanBarcode,
            getPageSize: dsGetPageSize,
            getPageIndex: dsGetPageIndex,
            setPageIndex: dsSetPageIndex,
            getOrderBy: dsGetOrderBy,
            getOrderings: dsGetOrderings,
            getOrderType: dsGetOrderType,
            isAllowQuery: isAllowQuery,
            isShowEdittedRowsOnly: isShowEdittedRowsOnly,
            onFiltering: onFiltering,
            onGotData: onDatasourceGotData,
            onLoading: onDatasourceLoading,
            onLoaded: onDatasourceLoaded,
            onUpdated: onDataSourceEdited,
            getAppendRows: dsGetAppendRows
        };
    }, [
        dsGetAppendRows,
        props.keyExpr,
        props.API,
        props.url,
        props.loadFunc,
        props.updateMode,
        isRemotePaging,
        isAllowNew,
        dsGetQueryFields,
        dsGetSearchConditions,
        dsGetParentSearchConditions,
        dsGetFilteredGroupConditions,
        queryFields,
        dsGetSearchText,
        dsGetScanBarcode,
        dsGetPageSize,
        dsGetPageIndex,
        dsSetPageIndex,
        dsGetOrderBy,
        dsGetOrderings,
        dsGetOrderType,
        isAllowQuery,
        isShowEdittedRowsOnly,
        onFiltering,
        onDatasourceGotData,
        onDatasourceLoading,
        onDatasourceLoaded,
        onDataSourceEdited
    ]);

    const initSchedulerDataSourceConfig = useCallback(() => {
        return {
            key: props.keyExpr,
            API: props.API,
            url: props.url,
            loadFunc: props.loadFunc,
            // remotePaging: isRemotePaging,
            // updateMode: props.updateMode,
            // allowNew: isAllowNew,

            getSearchConditions: dsGetSearchConditions,
            getParentSearchConditions: dsGetParentSearchConditions,
            getFilteredGroupConditions: dsGetFilteredGroupConditions,
            getQueryFields: () => queryFields,
            getSearchText: dsGetSearchText,
            getScanBarcode: dsGetScanBarcode,
            // getPageSize: dsGetPageSize,
            // getPageIndex: dsGetPageIndex,
            // setPageIndex: dsSetPageIndex,
            getOrderBy: dsGetOrderBy,
            getOrderings: dsGetOrderings,
            getOrderType: dsGetOrderType,
            isAllowQuery: isAllowSchedulerQuery,
            // isShowEdittedRowsOnly: isShowEdittedRowsOnly,
            onFiltering: onFiltering,
            onGotData: async (data, allData) => {
                if (scheduler.current) await scheduler.current.onLoadData(data, allData);
                if (actionBar.current) actionBar.current.runCounting();
            }
            // onLoading: onDatasourceLoading,
            // onLoaded: onDatasourceLoaded,
            // onUpdated: onDataSourceEdited
        };
    }, [
        props.keyExpr,
        props.API,
        props.url,
        props.loadFunc,
        // props.updateMode,
        // isRemotePaging,
        // isAllowNew,
        dsGetSearchConditions,
        dsGetParentSearchConditions,
        dsGetFilteredGroupConditions,
        queryFields,
        dsGetSearchText,
        dsGetScanBarcode,
        // dsGetPageSize,
        // dsGetPageIndex,
        // dsSetPageIndex,
        dsGetOrderBy,
        dsGetOrderings,
        dsGetOrderType,
        isAllowSchedulerQuery,
        // isShowEdittedRowsOnly,
        onFiltering
    ]);

    const onCardViewGotData = useCallback((data, allData) => {
        if (cardview.current) cardview.current.onLoadData(data, allData);
        if (actionBar.current) actionBar.current.runCounting();
    }, []);

    const initCardViewDataSourceConfig = useCallback(() => {
        return {
            key: props.keyExpr,
            API: props.API,
            url: props.url,
            loadFunc: props.loadFunc,
            remotePaging: true,
            isScrolling: true,
            // updateMode: props.updateMode,
            // allowNew: isAllowNew,

            getPageSize: dsGetCardViewPageSize,
            getSearchConditions: dsGetSearchConditions,
            getParentSearchConditions: dsGetParentSearchConditions,
            getFilteredGroupConditions: dsGetFilteredGroupConditions,
            getQueryFields: () => queryFields,
            getSearchText: dsGetSearchText,
            // getScanBarcode: dsGetScanBarcode,
            // getPageIndex: dsGetPageIndex,
            // setPageIndex: dsSetPageIndex,
            getOrderBy: dsGetOrderBy,
            getOrderings: dsGetOrderings,
            getOrderType: dsGetOrderType,
            isAllowQuery: isAllowCardViewQuery,
            // isShowEdittedRowsOnly: isShowEdittedRowsOnly,
            // onFiltering: onFiltering,
            onGotData: onCardViewGotData
        };
    }, [
        props.keyExpr,
        props.API,
        props.url,
        props.loadFunc,
        // props.updateMode,
        // isRemotePaging,
        // isAllowNew,
        dsGetSearchConditions,
        dsGetParentSearchConditions,
        dsGetFilteredGroupConditions,
        queryFields,
        dsGetSearchText,
        // dsGetScanBarcode,
        dsGetCardViewPageSize,
        // dsGetPageIndex,
        // dsSetPageIndex,
        dsGetOrderBy,
        dsGetOrderings,
        dsGetOrderType,
        isAllowCardViewQuery,
        // isShowEdittedRowsOnly,
        // onFiltering,
        onCardViewGotData
    ]);

    useImperativeHandle(ref, () => ({
        forceReload: forceReload,
        // Người dùng mở tab: nạp lại nếu lưới còn nợ lượt nạp từ lúc đầu phiếu đổi.
        reloadIfPending: () => {
            if (!pendingParentReload.current) return false;
            pendingParentReload.current = false;
            forceReload();
            return true;
        },
        markPendingReload: () => { pendingParentReload.current = true; },
        resetSelectedActionGroups: resetSelectedActionGroups,
        refresh: refresh,
        getKeyField: getKeyField,
        getEditedData: getEditedData,
        getSelectedRows: getSelectedRows,
        modifiedRows: modifiedRows,
        forceRender: forceRender,
        getCachedData: getCachedData,
        cleanData: cleanData,
        isDataLoaded: isDataLoaded,
        isDataLoading: isDataLoading,
        getSearchCategories: getSearchCategories,
        getSearchConditions: dsGetSearchConditions,
        getParentSearchConditions: dsGetParentSearchConditions
    }));

    useEffect(() => {
        // if (!showScheduler.current && !showCardView.current) {
        dataSource.current.reInit(initDataSourceConfig());
        // }
    }, [initDataSourceConfig]);

    useEffect(() => {
        if (props.scheduler && showScheduler.current && !showCardView.current) {
            schedulerDataSource.current.reInit(initSchedulerDataSourceConfig());
        }
    }, [initSchedulerDataSourceConfig]);

    useEffect(() => {
        if (props.cardview && !showScheduler.current && showCardView.current) {
            cardViewDataSource.current.reInit(initCardViewDataSourceConfig());
        }
    }, [initCardViewDataSourceConfig]);

    // Đầu phiếu đổi thì lưới nạp lại. Lưới nằm trong tab KHÔNG mở thì chỉ ghi nợ,
    // tới lúc người dùng mở tab đó mới nạp (AntVoucherTabs gọi `reloadIfPending`) —
    // trước đây mỗi lần đầu phiếu đổi là mọi tab cùng gọi một lượt, hơn chục lượt cho
    // một lần bấm nút. Không nằm trong tab (không có `isTabActive`) thì giữ nếp cũ.
    useEffect(() => {
        if (props.isTabActive && props.tabName && !props.isTabActive(props.tabName)) {
            pendingParentReload.current = true;
            return;
        }
        pendingParentReload.current = false;
        forceReload();
    }, [props.parentData]); //, actionBar.current

    // useEffect(() => {
    //     forceReload();
    // }, []);

    useEffect(() => {
        saveCachingStates();
    }, [saveCachingStates, showCardView.current, showScheduler.current, showSearchForm.current, schedulerCurrentView.current, schedulerCurrentDate.current]);

    const scheduleGridHeaderLayout = useCallback(() => {
        clearTimeout(gridHeaderTimer.current);
        gridHeaderTimer.current = setTimeout(() => {
            if (!grid.current || !grid.current.instance) return;
            const instance = grid.current.instance;
            // Cột cố định độ rộng đang sắp xếp: nới cho vừa chữ + icon, bỏ sắp xếp thì trả lại.
            // Cột đang sắp xếp không bị adaptive (màn hẹp) tự ẩn.
            keepSortedColumnsShown(instance, mainColumnsRef.current);
            const widened = gridContainer.current
                ? fitSortedHeaderWidths(instance, mainColumnsRef.current, createGridTextMeasurer(gridContainer.current))
                : 0;
            if (resetGridHeaderHeights(gridContainer.current) || widened) instance.updateDimensions();
        }, 80);
    }, []);

    // ---- Ẩn hiện cột (nút trên thanh công cụ) ----
    // Cột ẩn mặc định: cấu hình cột defaultVisible: false (người dùng bật lại trong bảng ẩn hiện cột).
    const isDefaultHiddenColumn = useCallback(
        (col) => {
            if (!col || !col.dataField) return false;
            let rawCol = props.columns instanceof Array ? props.columns.find((c) => c && c.dataField === col.dataField) : null;
            if (rawCol && rawCol.rawConfig) rawCol = rawCol.rawConfig;
            return Boolean(rawCol && rawCol.defaultVisible === false);
        },
        [props.columns]
    );
    const getColumnChooserItems = useCallback(() => {
        const instance = grid.current && grid.current.instance;
        const defs = mainColumnsRef.current || [];
        const orderCustomized = Boolean(userColumnOrder.current);
        const positionOf = (col) => {
            const index = defs.indexOf(col);
            const visibleIndex = instance ? instance.columnOption(index, 'visibleIndex') : undefined;
            return typeof visibleIndex === 'number' ? visibleIndex : index;
        };
        return defs
            .filter((col) => isUserMovableColumn(col) && col.caption && isColumnVisible(col, { businessOnly: true }))
            .sort((a, b) => positionOf(a) - positionOf(b))
            .map((col) => {
                // Tick = cột được chọn hiện (cột thường: người dùng không tắt; cột ẩn mặc định: người dùng đã bật);
                // cột vẫn có thể đang tự ẩn vì trang hiện tại trống.
                const choice = userColumnVisibility.current[col.dataField];
                const selected = isDefaultHiddenColumn(col) ? choice === true : choice !== false;
                const shown = instance ? instance.columnOption(col.name || col.dataField, 'visible') !== false : col.visible !== false;
                return {
                    field: col.dataField,
                    caption: String(col.caption),
                    visible: selected,
                    autoHidden: selected && !shown,
                    locked: col._antUserHideable === false && selected,
                    customized: orderCustomized || choice !== undefined
                };
            });
    }, [isColumnVisible, isDefaultHiddenColumn]);

    // Áp thứ tự cột lên lưới đang hiển thị: visibleIndex cho MỌI cột theo thứ tự mới (sửa cấu hình cột trước —
    // devextreme-react trả option lệch props về giá trị cũ). Xác định cột theo vị trí trong mảng columns.
    const applyUserColumnOrder = useCallback(() => {
        const instance = grid.current && grid.current.instance;
        const defs = mainColumnsRef.current || [];
        const byDefault = defs.slice().sort((a, b) => (a._antDefaultIndex || 0) - (b._antDefaultIndex || 0));
        const ordered = userColumnOrder.current ? applyColumnOrder(byDefault, userColumnOrder.current, isUserMovableColumn) : byDefault;
        ordered.forEach((col, index) => {
            col.visibleIndex = index;
        });
        if (!instance) return;
        instance.beginUpdate();
        try {
            defs.forEach((col, index) => {
                if (instance.columnOption(index, 'visibleIndex') !== col.visibleIndex) instance.columnOption(index, 'visibleIndex', col.visibleIndex);
            });
        } finally {
            instance.endUpdate();
        }
        scheduleGridBestFit(instance, mainColumnsRef.current, gridWidthCache);
        scheduleGridHeaderLayout();
    }, [gridWidthCache, scheduleGridHeaderLayout]);

    const onColumnOrderChange = useCallback(
        (fields) => {
            if (!(fields instanceof Array) || !fields.length) return;
            userColumnOrder.current = fields.slice();
            updateGridSettings(gridSettingsKey, (entry) => ({ ...entry, columnOrder: fields.slice() }), gridSettingsMeta);
            applyUserColumnOrder();
        },
        [gridSettingsKey, gridSettingsMeta, applyUserColumnOrder]
    );

    // Sửa cấu hình cột TRƯỚC rồi mới columnOption (devextreme-react trả option lệch props về giá trị cũ).
    const applyUserColumnVisibility = useCallback(
        (fields) => {
            const instance = grid.current && grid.current.instance;
            (mainColumnsRef.current || []).forEach((col) => {
                if (!col.dataField || col.isSystemCol || (fields && !fields.includes(col.dataField))) return;
                col.visible = isColumnVisible(col);
                if (instance) {
                    const key = col.name || col.dataField;
                    if (instance.columnOption(key, 'visible') !== col.visible || instance.columnOption(key, 'hidingPriority') !== col.hidingPriority)
                        instance.columnOption(key, { visible: col.visible, hidingPriority: col.hidingPriority });
                }
            });
            // Tắt cột làm lưới mất hết cột chữ/auto → hiện lại 1 cột bị ẩn vì trống.
            keepTextColumnShown(mainColumnsRef.current).forEach((col) => {
                if (instance) instance.columnOption(col.name || col.dataField, 'visible', true);
            });
            if (instance) {
                scheduleGridBestFit(instance, mainColumnsRef.current, gridWidthCache);
                scheduleGridHeaderLayout();
            }
        },
        [isColumnVisible, keepTextColumnShown, gridWidthCache, scheduleGridHeaderLayout]
    );

    const onColumnVisibilityChange = useCallback(
        (field, visible) => {
            if (!field) return;
            // Chỉ lưu lựa chọn khác mặc định: cột thường → lưu "tắt"; cột ẩn mặc định → lưu "bật".
            const def = (mainColumnsRef.current || []).find((c) => c.dataField === field);
            const defaultHidden = isDefaultHiddenColumn(def);
            const choice = defaultHidden ? (visible ? true : undefined) : visible ? undefined : false;
            const next = { ...userColumnVisibility.current };
            if (choice === undefined) delete next[field];
            else next[field] = choice;
            userColumnVisibility.current = next;
            updateGridSettings(
                gridSettingsKey,
                (entry) => ({ ...entry, columns: mergeColumnSettings(entry.columns, { [field]: { visible: choice === undefined ? null : choice } }) }),
                gridSettingsMeta
            );
            applyUserColumnVisibility([field]);
        },
        [gridSettingsKey, gridSettingsMeta, applyUserColumnVisibility, isDefaultHiddenColumn]
    );

    // "Mặc định": bỏ lựa chọn ẩn hiện + thứ tự cột của người dùng (độ rộng đã kéo giữ nguyên).
    const onColumnVisibilityReset = useCallback(() => {
        const fields = Object.keys(userColumnVisibility.current);
        const hadOrder = Boolean(userColumnOrder.current);
        if (!fields.length && !hadOrder) return;
        userColumnVisibility.current = {};
        userColumnOrder.current = null;
        const patch = {};
        fields.forEach((field) => {
            patch[field] = { visible: null };
        });
        updateGridSettings(
            gridSettingsKey,
            (entry) => ({ ...entry, columns: mergeColumnSettings(entry.columns, patch), columnOrder: null }),
            gridSettingsMeta
        );
        if (fields.length) applyUserColumnVisibility(fields);
        if (hadOrder) applyUserColumnOrder();
    }, [gridSettingsKey, gridSettingsMeta, applyUserColumnVisibility, applyUserColumnOrder]);

    // Tự căn độ rộng MỌI cột đang hiện theo nội dung (như Excel — nhấp đúp vạch ngăn cột ở tiêu đề): bỏ độ rộng người
    // dùng đã kéo (cả đã lưu), trả cột về chế độ tự đo / co giãn / độ rộng cấu hình rồi đo lại trang hiện tại.
    const autoFitVisibleColumns = useCallback(() => {
        const instance = grid.current && grid.current.instance;
        if (!instance) return;
        const defs = mainColumnsRef.current || [];
        const savedWidths = readSavedColWidths();
        const cleared = {};
        instance.beginUpdate();
        try {
            defs.forEach((col) => {
                if (!col.dataField || (col.isSystemCol && !isResizableSystemColumn(col))) return;
                const key = col.name || col.dataField;
                if (instance.columnOption(key, 'visible') === false) return;
                if (col.isSystemCol) {
                    // Cột số thứ tự: vừa số lớn nhất của trang (không nhỏ hơn độ rộng cấu hình).
                    const backupWidth = col._antAutoBackup ? col._antAutoBackup.width : col.width;
                    const rows = instance.getVisibleRows().filter((row) => row.rowType === 'data').length;
                    const last = (instance.pageIndex() || 0) * (instance.pageSize() || 0) + rows;
                    const measure = gridContainer.current ? createGridTextMeasurer(gridContainer.current) : null;
                    const fit = measure ? Math.ceil(measure(String(last), 'cell')) : 0;
                    const width = Math.max(typeof backupWidth === 'number' ? backupWidth : 30, fit);
                    col.width = width;
                    instance.columnOption(key, 'width', width);
                    delete col._antAutoBackup;
                    delete col._antUserWidth;
                    if (savedWidths[col.dataField] !== undefined) cleared[col.dataField] = { width: null };
                    return;
                }
                const backup = col._antAutoBackup;
                if (backup) {
                    if (backup.bestFit) col._antBestFit = backup.bestFit;
                    if (backup.flexible) col._antFlexibleWidth = true;
                    // Cột độ rộng cố định theo cấu hình (không tự đo): trả về độ rộng cấu hình.
                    if (!backup.bestFit && !backup.flexible) {
                        col.width = backup.width;
                        instance.columnOption(key, 'width', backup.width);
                    }
                    delete col._antAutoBackup;
                }
                delete col._antUserWidth;
                delete col._antUserMinWidth;
                if (backup || savedWidths[col.dataField] !== undefined) cleared[col.dataField] = { width: null };
            });
        } finally {
            instance.endUpdate();
        }
        if (Object.keys(cleared).length)
            updateGridSettings(gridSettingsKey, (entry) => ({ ...entry, columns: mergeColumnSettings(entry.columns, cleared) }), gridSettingsMeta);
        refitGridBestFit(instance, defs, gridWidthCache);
        scheduleGridHeaderLayout();
    }, [readSavedColWidths, gridSettingsKey, gridSettingsMeta, gridWidthCache, scheduleGridHeaderLayout]);
    autoFitVisibleColumnsRef.current = autoFitVisibleColumns;

    const onGridContentReady = useCallback((e) => {
        scheduleGridBestFit(e?.component || grid.current?.instance, mainColumns, gridWidthCache);
        scheduleGridHeaderLayout();
        decorateInlineCells();
    }, [mainColumns, gridWidthCache, scheduleGridHeaderLayout, decorateInlineCells]);

    useEffect(() => {
        const element = gridContainer.current;
        if (!element || typeof ResizeObserver === 'undefined') return undefined;

        const observer = new ResizeObserver((entries) => {
            const entry = entries && entries[0];
            const width = entry && entry.contentRect ? entry.contentRect.width : 0;
            if (!width) {
                // Reopening at the same width still requires a new measurement.
                lastGridContainerWidth.current = 0;
                clearTimeout(gridResizeTimer.current);
                return;
            }
            if (Math.abs(width - (lastGridContainerWidth.current || 0)) < 1) return;

            lastGridContainerWidth.current = width;
            if (gridResizeTimer.current) clearTimeout(gridResizeTimer.current);
            gridResizeTimer.current = setTimeout(() => {
                if (grid.current && grid.current.instance) {
                    scheduleGridBestFit(grid.current.instance, mainColumns, gridWidthCache);
                    resetGridHeaderHeights(element);
                    grid.current.instance.updateDimensions();
                }
            }, 80);
        });

        observer.observe(element);
        const stopObservingHeaders = observeAdaptiveHiddenHeaders(element);
        return () => {
            observer.disconnect();
            stopObservingHeaders();
            if (gridResizeTimer.current) clearTimeout(gridResizeTimer.current);
            clearTimeout(gridHeaderTimer.current);
            lastGridContainerWidth.current = undefined;
        };
    }, [isRender, mainColumns, gridWidthCache]);

    useEffect(() => {
        return () => {
            if (autoRefreshTimer.current) clearInterval(autoRefreshTimer.current);

            if (afterActionRefreshTimeout.current) clearTimeout(afterActionRefreshTimeout.current);
            if (gridResizeTimer.current) clearTimeout(gridResizeTimer.current);
            clearTimeout(gridHeaderTimer.current);

            delete markSelectedField.current;
            delete grid.current;
            delete gridContainer.current;
            delete actionBar.current;
            delete selectedRowsRef.current;
            delete scheduler.current;
            delete cardview.current;
            delete deletePopup.current;
            delete batchActionPopup.current;
            delete editPopup.current;
            delete addPopup.current;
            delete importPopup.current;
            delete dataSource.current;
            delete schedulerDataSource.current;
            delete cardViewDataSource.current;
            delete showSearchForm.current;
            delete showScheduler.current;
            delete showCardView.current;
            delete schedulerCurrentView.current;
            delete schedulerCurrentDate.current;
            delete sortByColumn.current;
            delete sortType.current;
            delete searchText.current;
            delete searchBarcode.current;
            delete filterBySelected.current;

            markSelectedField.current = null;
            grid.current = null;
            actionBar.current = null;
            selectedRowsRef.current = null;
            cardview.current = null;
            deletePopup.current = null;
            batchActionPopup.current = null;
            editPopup.current = null;
            addPopup.current = null;
            importPopup.current = null;
            dataSource.current = null;
            schedulerDataSource.current = null;
            cardViewDataSource.current = null;
            showSearchForm.current = null;
            showScheduler.current = null;
            showCardView.current = null;
            schedulerCurrentView.current = null;
            schedulerCurrentDate.current = null;
            sortByColumn.current = null;
            sortType.current = null;
            searchText.current = null;
            searchBarcode.current = null;
            filterBySelected.current = null;
        };
    }, []);

    // useEffect(() => {
    //     autoReload();
    // }, [searchText.current, searchBarcode.current, filterBySelected.current]);

    useEffect(() => {
        generateSearchConditions();
    }, [generateSearchConditions]); //, actionBar.current

    // useEffect(() => {
    //     if (grid.current && grid.current.instance) {
    //         grid.current.instance.refresh(true);
    //     }
    // }, [searchConditions.current]); //, actionBar.current

    const isCategoriesShouldVisible = useCallback(
        (cats) => {
            if (!cats) return false;

            let isVisible = AntCondition.isVisible({}, cats);
            if (!isVisible) return false;
            if (cats.visible === true) return true;

            if (searchConditions.current && cats.lookups) {
                if (cats.lookups.some((l) => Object.keys(searchConditions.current).includes(l.field))) return true;
            }

            let ar1 = [
                props.searchCategories1,
                props.searchCategories2,
                props.searchCategories3,
                props.searchCategories4,
                props.searchCategories5,
                props.searchCategories6,
                props.searchCategories7,
                props.searchCategories8,
                props.searchCategories9,
                props.searchCategories10
            ];
            let ar2 = [
                selectedCats1.filter((s) => s.value && s.value.length > 0),
                selectedCats2.filter((s) => s.value && s.value.length > 0),
                selectedCats3.filter((s) => s.value && s.value.length > 0),
                selectedCats4.filter((s) => s.value && s.value.length > 0),
                selectedCats5.filter((s) => s.value && s.value.length > 0),
                selectedCats6.filter((s) => s.value && s.value.length > 0),
                selectedCats7.filter((s) => s.value && s.value.length > 0),
                selectedCats8.filter((s) => s.value && s.value.length > 0),
                selectedCats9.filter((s) => s.value && s.value.length > 0),
                selectedCats10.filter((s) => s.value && s.value.length > 0)
            ];
            let ar3 = [itemsCats1, itemsCats2, itemsCats3, itemsCats4, itemsCats5, itemsCats6, itemsCats7, itemsCats8, itemsCats9, itemsCats10];

            let ar4 = [
                itemsCats1Loaded,
                itemsCats2Loaded,
                itemsCats3Loaded,
                itemsCats4Loaded,
                itemsCats5Loaded,
                itemsCats6Loaded,
                itemsCats7Loaded,
                itemsCats8Loaded,
                itemsCats9Loaded,
                itemsCats10Loaded
            ];

            let currentCatIndex = ar1.findIndex((a) => AntJSON.isDeepEqual(a, cats));
            let currentCatTotals = ar3[currentCatIndex];
            let currentCatSelecteds = ar2[currentCatIndex];
            let currentCatLoaded = ar4[currentCatIndex];

            if (!currentCatLoaded) return true;

            let _selectedCategories = [
                selectedCats1,
                selectedCats2,
                selectedCats3,
                selectedCats4,
                selectedCats5,
                selectedCats6,
                selectedCats7,
                selectedCats8,
                selectedCats9,
                selectedCats10
            ]
                .flat()
                .map((s) => s.value)
                .flat();

            if (cats.visibleDependOthers) {
                let _totalCats =
                    itemsCats1.length +
                    itemsCats2.length +
                    itemsCats3.length +
                    itemsCats4.length +
                    itemsCats5.length +
                    itemsCats6.length +
                    itemsCats7.length +
                    itemsCats8.length +
                    itemsCats9.length +
                    itemsCats10.length;

                if (_totalCats > currentCatTotals.length) {
                    if (cats.visibleDependOthers instanceof Array) {
                        if (cats.visibleDependOthersType !== 'OR')
                            isVisible = cats.visibleDependOthers.every((oName) => {
                                for (let i = 0; i < ar1.length; i++) {
                                    const otherCat = ar1[i];
                                    const otherCatSelecteds = ar2[i];
                                    const otherCatTotals = ar3[i];
                                    if (otherCat && !AntJSON.isDeepEqual(otherCat, cats)) {
                                        if (
                                            otherCat &&
                                            otherCat.lookups &&
                                            otherCat.lookups.some((l) => l.name === oName) &&
                                            (otherCatTotals.length <= 0 || otherCatSelecteds.length > 0)
                                        )
                                            return true;
                                    }
                                }

                                return false;
                            });
                        else {
                            isVisible = cats.visibleDependOthers.some((oName) => {
                                for (let i = 0; i < ar1.length; i++) {
                                    const otherCat = ar1[i];
                                    const otherCatSelecteds = ar2[i];
                                    const otherCatTotals = ar3[i];
                                    if (otherCat && !AntJSON.isDeepEqual(otherCat, cats)) {
                                        if (
                                            otherCat &&
                                            otherCat.lookups &&
                                            otherCat.lookups.some((l) => l.name === oName) &&
                                            otherCatSelecteds.length > 0
                                        )
                                            return true;
                                    }
                                }

                                return false;
                            });

                            if (!isVisible)
                                isVisible = cats.visibleDependOthers.every((oName) => {
                                    for (let i = 0; i < ar1.length; i++) {
                                        const otherCat = ar1[i];
                                        const otherCatSelecteds = ar2[i];
                                        const otherCatTotals = ar3[i];
                                        if (otherCat && !AntJSON.isDeepEqual(otherCat, cats)) {
                                            if (
                                                otherCat &&
                                                otherCat.lookups &&
                                                otherCat.lookups.some((l) => l.name === oName) &&
                                                otherCatTotals.length > 0
                                            )
                                                return false;
                                        }
                                    }

                                    return true;
                                });
                        }
                    } else {
                        isVisible = _selectedCategories.length > 0;
                    }
                }
            } else {
                isVisible = currentCatTotals.length > 1 || currentCatSelecteds.length > 0;
            }

            return isVisible;
        },
        [
            props.searchCategories1,
            props.searchCategories2,
            props.searchCategories3,
            props.searchCategories4,
            props.searchCategories5,
            props.searchCategories6,
            props.searchCategories7,
            props.searchCategories8,
            props.searchCategories9,
            props.searchCategories10,
            defaultStates,
            itemsCats1,
            itemsCats2,
            itemsCats3,
            itemsCats4,
            itemsCats5,
            itemsCats6,
            itemsCats7,
            itemsCats8,
            itemsCats9,
            itemsCats10,
            selectedCats1,
            selectedCats2,
            selectedCats3,
            selectedCats4,
            selectedCats5,
            selectedCats6,
            selectedCats7,
            selectedCats8,
            selectedCats9,
            selectedCats10
        ]
    );

    // const cats1Visible = useMemo(() => isCategoriesShouldVisible(props.searchCategories1), [isCategoriesShouldVisible, searchConditions.current]);
    // const cats2Visible = useMemo(() => isCategoriesShouldVisible(props.searchCategories2), [isCategoriesShouldVisible, searchConditions.current]);
    // const cats3Visible = useMemo(() => isCategoriesShouldVisible(props.searchCategories3), [isCategoriesShouldVisible, searchConditions.current]);
    // const cats4Visible = useMemo(() => isCategoriesShouldVisible(props.searchCategories4), [isCategoriesShouldVisible, searchConditions.current]);
    // const cats5Visible = useMemo(() => isCategoriesShouldVisible(props.searchCategories5), [isCategoriesShouldVisible, searchConditions.current]);
    // const cats6Visible = useMemo(() => isCategoriesShouldVisible(props.searchCategories6), [isCategoriesShouldVisible, searchConditions.current]);
    // const cats7Visible = useMemo(() => isCategoriesShouldVisible(props.searchCategories7), [isCategoriesShouldVisible, searchConditions.current]);
    // const cats8Visible = useMemo(() => isCategoriesShouldVisible(props.searchCategories8), [isCategoriesShouldVisible, searchConditions.current]);
    // const cats9Visible = useMemo(() => isCategoriesShouldVisible(props.searchCategories9), [isCategoriesShouldVisible, searchConditions.current]);
    // const cats10Visible = useMemo(() => isCategoriesShouldVisible(props.searchCategories10), [isCategoriesShouldVisible, searchConditions.current]);

    const cats1Visible = isCategoriesShouldVisible(props.searchCategories1);
    const cats2Visible = isCategoriesShouldVisible(props.searchCategories2);
    const cats3Visible = isCategoriesShouldVisible(props.searchCategories3);
    const cats4Visible = isCategoriesShouldVisible(props.searchCategories4);
    const cats5Visible = isCategoriesShouldVisible(props.searchCategories5);
    const cats6Visible = isCategoriesShouldVisible(props.searchCategories6);
    const cats7Visible = isCategoriesShouldVisible(props.searchCategories7);
    const cats8Visible = isCategoriesShouldVisible(props.searchCategories8);
    const cats9Visible = isCategoriesShouldVisible(props.searchCategories9);
    const cats10Visible = isCategoriesShouldVisible(props.searchCategories10);

    // let catGroupVisible =
    //     cats1Visible ||
    //     cats2Visible ||
    //     cats3Visible ||
    //     cats4Visible ||
    //     cats5Visible ||
    //     cats6Visible ||
    //     cats7Visible ||
    //     cats8Visible ||
    //     cats9Visible ||
    //     cats10Visible;

    // A board can retain category filter conditions for API/cached-state compatibility
    // while intentionally hiding the category controls from its compact card surface.
    const catGroupVisible = useMemo(() => props.showSearchCategories !== false, [props.showSearchCategories]);

    const onFilterClick = useCallback(() => {
        showSearchForm.current = !showSearchForm.current;
        saveCachingStates();
        forceRender();
    }, [saveCachingStates, forceRender]);

    const onShowScheduler = useCallback(() => {
        showScheduler.current = !showScheduler.current;
        saveCachingStates();
        forceRender();
    }, [saveCachingStates, forceRender]);

    const onShowCardView = useCallback(() => {
        showCardView.current = !showCardView.current;
        saveCachingStates();
        forceRender();
    }, [saveCachingStates, forceRender]);

    const onFilteredByGroup = useCallback(
        (gr) => {
            if (props.onFilteredByGroupChanged) props.onFilteredByGroupChanged(gr);
            setFilteredGroup(gr);
            forceReload();
        },
        [forceReload, props.onFilteredByGroupChanged]
    );

    const onLoadedDataCat1 = useCallback((e) => {
        setItemsCats1(e.allItems ? e.allItems : []);
        setItemsCats1Loaded(true);
    }, []);

    const onLoadedDataCat2 = useCallback((e) => {
        setItemsCats2(e.allItems ? e.allItems : []);
        setItemsCats2Loaded(true);
    }, []);

    const onLoadedDataCat3 = useCallback((e) => {
        setItemsCats3(e.allItems ? e.allItems : []);
        setItemsCats3Loaded(true);
    }, []);

    const onLoadedDataCat4 = useCallback((e) => {
        setItemsCats4(e.allItems ? e.allItems : []);
        setItemsCats4Loaded(true);
    }, []);

    const onLoadedDataCat5 = useCallback((e) => {
        setItemsCats5(e.allItems ? e.allItems : []);
        setItemsCats5Loaded(true);
    }, []);

    const onLoadedDataCat6 = useCallback((e) => {
        setItemsCats6(e.allItems ? e.allItems : []);
        setItemsCats6Loaded(true);
    }, []);

    const onLoadedDataCat7 = useCallback((e) => {
        setItemsCats7(e.allItems ? e.allItems : []);
        setItemsCats7Loaded(true);
    }, []);

    const onLoadedDataCat8 = useCallback((e) => {
        setItemsCats8(e.allItems ? e.allItems : []);
        setItemsCats8Loaded(true);
    }, []);

    const onLoadedDataCat9 = useCallback((e) => {
        setItemsCats9(e.allItems ? e.allItems : []);
        setItemsCats9Loaded(true);
    }, []);

    const onLoadedDataCat10 = useCallback((e) => {
        setItemsCats10(e.allItems ? e.allItems : []);
        setItemsCats10Loaded(true);
    }, []);

    const onSelectionChangedCat1 = useCallback(
        (e) => {
            setItemsCats1(e.allItems);
            setSelectedCats1(e.selectedItems);
            latestCatSelections.current[1] = e.selectedItems;
            forceReload({ categorySelections: { 1: e.selectedItems } });
        },
        [forceReload]
    );

    const onSelectionChangedCat2 = useCallback(
        (e) => {
            setItemsCats2(e.allItems);
            setSelectedCats2(e.selectedItems);
            latestCatSelections.current[2] = e.selectedItems;
            forceReload({ categorySelections: { 2: e.selectedItems } });
        },
        [forceReload]
    );

    const onSelectionChangedCat3 = useCallback(
        (e) => {
            setItemsCats3(e.allItems);
            setSelectedCats3(e.selectedItems);
            latestCatSelections.current[3] = e.selectedItems;
            forceReload({ categorySelections: { 3: e.selectedItems } });
        },
        [forceReload]
    );

    const onSelectionChangedCat4 = useCallback(
        (e) => {
            setItemsCats4(e.allItems);
            setSelectedCats4(e.selectedItems);
            latestCatSelections.current[4] = e.selectedItems;
            forceReload({ categorySelections: { 4: e.selectedItems } });
        },
        [forceReload]
    );

    const onSelectionChangedCat5 = useCallback(
        (e) => {
            setItemsCats5(e.allItems);
            setSelectedCats5(e.selectedItems);
            latestCatSelections.current[5] = e.selectedItems;
            forceReload({ categorySelections: { 5: e.selectedItems } });
        },
        [forceReload]
    );

    const onSelectionChangedCat6 = useCallback(
        (e) => {
            setItemsCats6(e.allItems);
            setSelectedCats6(e.selectedItems);
            latestCatSelections.current[6] = e.selectedItems;
            forceReload({ categorySelections: { 6: e.selectedItems } });
        },
        [forceReload]
    );

    const onSelectionChangedCat7 = useCallback(
        (e) => {
            setItemsCats7(e.allItems);
            setSelectedCats7(e.selectedItems);
            latestCatSelections.current[7] = e.selectedItems;
            forceReload({ categorySelections: { 7: e.selectedItems } });
        },
        [forceReload]
    );

    const onSelectionChangedCat8 = useCallback(
        (e) => {
            setItemsCats8(e.allItems);
            setSelectedCats8(e.selectedItems);
            latestCatSelections.current[8] = e.selectedItems;
            forceReload({ categorySelections: { 8: e.selectedItems } });
        },
        [forceReload]
    );

    const onSelectionChangedCat9 = useCallback(
        (e) => {
            setItemsCats9(e.allItems);
            setSelectedCats9(e.selectedItems);
            latestCatSelections.current[9] = e.selectedItems;
            forceReload({ categorySelections: { 9: e.selectedItems } });
        },
        [forceReload]
    );

    const onSelectionChangedCat10 = useCallback(
        (e) => {
            setItemsCats10(e.allItems);
            setSelectedCats10(e.selectedItems);
            latestCatSelections.current[10] = e.selectedItems;
            forceReload({ categorySelections: { 10: e.selectedItems } });
        },
        [forceReload]
    );

    const allowQueryCat1 = useCallback(
        (e) => {
            if (props.categoriesQueryEnabled === false) return false;
            if (props.searchCategories1.visibleDependOthers) return selectedCategories.length > 0;
            return true;
        },
        [selectedCategories, props.categoriesQueryEnabled]
    );

    const allowQueryCat2 = useCallback(
        (e) => {
            if (props.categoriesQueryEnabled === false) return false;
            if (props.searchCategories2.visibleDependOthers) return selectedCategories.length > 0;
            return true;
        },
        [selectedCategories, props.categoriesQueryEnabled]
    );

    const allowQueryCat3 = useCallback(
        (e) => {
            if (props.categoriesQueryEnabled === false) return false;
            if (props.searchCategories3.visibleDependOthers) return selectedCategories.length > 0;
            return true;
        },
        [selectedCategories, props.categoriesQueryEnabled]
    );

    const allowQueryCat4 = useCallback(
        (e) => {
            if (props.categoriesQueryEnabled === false) return false;
            if (props.searchCategories4.visibleDependOthers) return selectedCategories.length > 0;
            return true;
        },
        [selectedCategories, props.categoriesQueryEnabled]
    );

    const allowQueryCat5 = useCallback(
        (e) => {
            if (props.categoriesQueryEnabled === false) return false;
            if (props.searchCategories5.visibleDependOthers) return selectedCategories.length > 0;
            return true;
        },
        [selectedCategories, props.categoriesQueryEnabled]
    );

    const allowQueryCat6 = useCallback(
        (e) => {
            if (props.categoriesQueryEnabled === false) return false;
            if (props.searchCategories6.visibleDependOthers) return selectedCategories.length > 0;
            return true;
        },
        [selectedCategories, props.categoriesQueryEnabled]
    );

    const allowQueryCat7 = useCallback(
        (e) => {
            if (props.categoriesQueryEnabled === false) return false;
            if (props.searchCategories7.visibleDependOthers) return selectedCategories.length > 0;
            return true;
        },
        [selectedCategories, props.categoriesQueryEnabled]
    );

    const allowQueryCat8 = useCallback(
        (e) => {
            if (props.categoriesQueryEnabled === false) return false;
            if (props.searchCategories8.visibleDependOthers) return selectedCategories.length > 0;
            return true;
        },
        [selectedCategories, props.categoriesQueryEnabled]
    );

    const allowQueryCat9 = useCallback(
        (e) => {
            if (props.categoriesQueryEnabled === false) return false;
            if (props.searchCategories9.visibleDependOthers) return selectedCategories.length > 0;
            return true;
        },
        [selectedCategories, props.categoriesQueryEnabled]
    );

    const allowQueryCat10 = useCallback(
        (e) => {
            if (props.categoriesQueryEnabled === false) return false;
            if (props.searchCategories10.visibleDependOthers) return selectedCategories.length > 0;
            return true;
        },
        [selectedCategories, props.categoriesQueryEnabled]
    );

    const onObjectCreated = useCallback(
        (obj) => {
            if (props.add && props.add.onAdded) props.add.onAdded(obj);
            if (props.onAdded) props.onAdded(obj);
            if (props.add?.navigateLink) {
                var value;
                var link;

                if (props.add.navigateLink instanceof Array) {
                    props.add.navigateLink.forEach((l) => {
                        if (l && l.link) {
                            if (l.when && typeof l.when === 'object') {
                                var isValid = AntCondition.isValid(obj, {
                                    when: l.when,
                                    whenType: l.whenType
                                });
                                if (!isValid) return;
                            }
                            value = l.field ? obj[l.field] : obj.code;
                            link = String(l.link);
                        }
                    });
                } else {
                    value = props.add.navigateField ? obj[props.add.navigateField] : obj.code;
                    link = String(props.add.navigateLink);
                }

                if (link && value !== undefined && value !== null) {
                    if (!link.startsWith('/')) link = '/' + link;
                    if (!link.endsWith('/')) link = link + '/';
                    link = link + value;
                    navigate(link);
                }
            }
            reload();
        },
        [reload, props.add, props.onAdded]
    );

    const onObjectEdited = useCallback(
        (e) => {
            if (props.edit && props.edit.onEdited) props.edit.onEdited(e);
            if (props.onEdited) props.onEdited(e);
            reload();
        },
        [reload, props.edit, props.onEdited]
    );

    const onOptionChanged = useCallback(
        (e) => {
            let isShouldReload = false;
            // Column resizing can update header geometry without a full repaint.
            if (e.name === 'columns') scheduleGridHeaderLayout();

            if (!isRemotePaging && e.fullName === 'paging.pageIndex') {
                invalidateGridBestFit(e.component);
            }

            if (e.fullName === 'paging.pageSize') {
                isShouldReload = true;
                if (dsGetPageIndex() != 0) {
                    dsSetPageIndex(0);
                }
            }

            if (e.name === 'columns' && String(e.fullName).endsWith('].sortOrder')) {
                let colIndex = parseInt(String(e.fullName).replace('columns[', '').replace('].sortOrder', ''));
                let fieldName = grid.current && grid.current.instance ? grid.current.instance.columnOption(colIndex).dataField : undefined;

                // if (fieldName && (fieldName != sortByColumn.current || e.value != sortType.current)) {
                if (fieldName) {
                    sortByColumn.current = fieldName;
                    sortType.current = e.value;
                    isShouldReload = true;
                }
            }
            if (isShouldReload) {
                dataSource.current.reInit(initDataSourceConfig());
                forceReload();
            }

            if (props.onOptionChanged) props.onOptionChanged(e);
        },
        [initDataSourceConfig, forceReload, dsGetPageIndex, dsSetPageIndex, props.onOptionChanged, scheduleGridHeaderLayout, isRemotePaging]
    );

    return (
        <React.Fragment>
            {isRender && Boolean(props.search) && (
                <div style={{ display: showSearchForm.current ? 'block' : 'none' }}>
                    <p />
                    <AntSearchForm
                        formData={formSearchConditions}
                        shouldRender={isRender}
                        prepareConditions={props.search ? props.search.prepareConditions : undefined}
                        default={props.search ? props.search.default : undefined}
                        API={props.search && props.search.API ? props.search.API : props.API}
                        table={props.search && props.search.table ? props.search.table : props.table}
                        entityName={props.API.entityName ? props.API.entityName : props.entityName}
                        entityDisplay={props.API.entityDisplay ? props.API.entityDisplay : props.entityDisplay}
                        colCount={props.search && props.search.colCount !== undefined ? props.search.colCount : undefined}
                        colCountDefault={props.search ? props.search.colCountDefault : undefined}
                        // onConditionsChanged={setFormSearchConditions}
                        onFormDataChanged={setFormSearchConditions}
                        fields={props.fields}
                        items={props.search && props.search.items instanceof Array ? props.search.items : []}
                    />
                    <p />
                </div>
            )}

            {isRender && (
                <div ref={attachCategoryLayout} style={{ display: catGroupVisible ? 'flex' : 'none', flexWrap: 'wrap', gap: '5px' }}>
                    {props.searchCategories1 && (
                        <AntGridCategories
                            API={props.API}
                            shouldRender={isRender}
                            searchText={String(searchText.current)}
                            searchConditions={searchConditions.current}
                            searchCategories={props.searchCategories1}
                            layoutCoordinator={categoryLayout.current}
                            gridSettingsKey={gridSettingsKey}
                            gridSettingsMeta={gridSettingsMeta}
                            layoutKey={1}
                            selectedItems={selectedCats1}
                            // autoSelectFirst={
                            //     props.autoSelectFirstCategory &&
                            //     selectedCats1.current.length + selectedCats2.current.length + selectedCats3.current.length + selectedCats4.current.length + selectedCats5.current.length <= 0
                            // }
                            onLoadedData={onLoadedDataCat1}
                            onSelectionChanged={onSelectionChangedCat1}
                            visible={cats1Visible}
                            allowQuery={allowQueryCat1}
                        ></AntGridCategories>
                    )}

                    {props.searchCategories2 && (
                        <AntGridCategories
                            API={props.API}
                            shouldRender={isRender}
                            searchText={String(searchText.current)}
                            searchConditions={searchConditions.current}
                            searchCategories={props.searchCategories2}
                            layoutCoordinator={categoryLayout.current}
                            gridSettingsKey={gridSettingsKey}
                            gridSettingsMeta={gridSettingsMeta}
                            layoutKey={2}
                            refreshVersion={categoryRefreshVersion}
                            selectedItems={selectedCats2}
                            onLoadedData={onLoadedDataCat2}
                            onSelectionChanged={onSelectionChangedCat2}
                            visible={cats2Visible}
                            allowQuery={allowQueryCat2}
                        ></AntGridCategories>
                    )}

                    {props.searchCategories3 && (
                        <AntGridCategories
                            API={props.API}
                            shouldRender={isRender}
                            searchText={String(searchText.current)}
                            searchConditions={searchConditions.current}
                            searchCategories={props.searchCategories3}
                            layoutCoordinator={categoryLayout.current}
                            gridSettingsKey={gridSettingsKey}
                            gridSettingsMeta={gridSettingsMeta}
                            layoutKey={3}
                            selectedItems={selectedCats3}
                            onLoadedData={onLoadedDataCat3}
                            onSelectionChanged={onSelectionChangedCat3}
                            visible={cats3Visible}
                            allowQuery={allowQueryCat3}
                        ></AntGridCategories>
                    )}

                    {props.searchCategories4 && (
                        <AntGridCategories
                            API={props.API}
                            shouldRender={isRender}
                            searchText={String(searchText.current)}
                            searchConditions={searchConditions.current}
                            searchCategories={props.searchCategories4}
                            layoutCoordinator={categoryLayout.current}
                            gridSettingsKey={gridSettingsKey}
                            gridSettingsMeta={gridSettingsMeta}
                            layoutKey={4}
                            selectedItems={selectedCats4}
                            onLoadedData={onLoadedDataCat4}
                            onSelectionChanged={onSelectionChangedCat4}
                            visible={cats4Visible}
                            allowQuery={allowQueryCat4}
                        ></AntGridCategories>
                    )}

                    {props.searchCategories5 && (
                        <AntGridCategories
                            API={props.API}
                            shouldRender={isRender}
                            searchText={String(searchText.current)}
                            searchConditions={searchConditions.current}
                            searchCategories={props.searchCategories5}
                            layoutCoordinator={categoryLayout.current}
                            gridSettingsKey={gridSettingsKey}
                            gridSettingsMeta={gridSettingsMeta}
                            layoutKey={5}
                            selectedItems={selectedCats5}
                            onLoadedData={onLoadedDataCat5}
                            onSelectionChanged={onSelectionChangedCat5}
                            visible={cats5Visible}
                            allowQuery={allowQueryCat5}
                        ></AntGridCategories>
                    )}

                    {props.searchCategories6 && (
                        <AntGridCategories
                            API={props.API}
                            shouldRender={isRender}
                            searchText={String(searchText.current)}
                            searchConditions={searchConditions.current}
                            searchCategories={props.searchCategories6}
                            layoutCoordinator={categoryLayout.current}
                            gridSettingsKey={gridSettingsKey}
                            gridSettingsMeta={gridSettingsMeta}
                            layoutKey={6}
                            selectedItems={selectedCats6}
                            onLoadedData={onLoadedDataCat6}
                            onSelectionChanged={onSelectionChangedCat6}
                            visible={cats6Visible}
                            allowQuery={allowQueryCat6}
                        ></AntGridCategories>
                    )}

                    {props.searchCategories7 && (
                        <AntGridCategories
                            API={props.API}
                            shouldRender={isRender}
                            searchText={String(searchText.current)}
                            searchConditions={searchConditions.current}
                            searchCategories={props.searchCategories7}
                            layoutCoordinator={categoryLayout.current}
                            gridSettingsKey={gridSettingsKey}
                            gridSettingsMeta={gridSettingsMeta}
                            layoutKey={7}
                            selectedItems={selectedCats7}
                            onLoadedData={onLoadedDataCat7}
                            onSelectionChanged={onSelectionChangedCat7}
                            visible={cats7Visible}
                            allowQuery={allowQueryCat7}
                        ></AntGridCategories>
                    )}

                    {props.searchCategories8 && (
                        <AntGridCategories
                            shouldRender={isRender}
                            API={props.API}
                            searchText={String(searchText.current)}
                            searchConditions={searchConditions.current}
                            searchCategories={props.searchCategories8}
                            layoutCoordinator={categoryLayout.current}
                            gridSettingsKey={gridSettingsKey}
                            gridSettingsMeta={gridSettingsMeta}
                            layoutKey={8}
                            selectedItems={selectedCats8}
                            onLoadedData={onLoadedDataCat8}
                            onSelectionChanged={onSelectionChangedCat8}
                            visible={cats8Visible}
                            allowQuery={allowQueryCat8}
                        ></AntGridCategories>
                    )}

                    {props.searchCategories9 && (
                        <AntGridCategories
                            API={props.API}
                            shouldRender={isRender}
                            searchText={String(searchText.current)}
                            searchConditions={searchConditions.current}
                            searchCategories={props.searchCategories9}
                            layoutCoordinator={categoryLayout.current}
                            gridSettingsKey={gridSettingsKey}
                            gridSettingsMeta={gridSettingsMeta}
                            layoutKey={9}
                            selectedItems={selectedCats9}
                            onLoadedData={onLoadedDataCat9}
                            onSelectionChanged={onSelectionChangedCat9}
                            visible={cats9Visible}
                            allowQuery={allowQueryCat9}
                        ></AntGridCategories>
                    )}

                    {props.searchCategories10 && (
                        <AntGridCategories
                            API={props.API}
                            shouldRender={isRender}
                            searchText={String(searchText.current)}
                            searchConditions={searchConditions.current}
                            searchCategories={props.searchCategories10}
                            layoutCoordinator={categoryLayout.current}
                            gridSettingsKey={gridSettingsKey}
                            gridSettingsMeta={gridSettingsMeta}
                            layoutKey={10}
                            selectedItems={selectedCats10}
                            onLoadedData={onLoadedDataCat10}
                            onSelectionChanged={onSelectionChangedCat10}
                            visible={cats10Visible}
                            allowQuery={allowQueryCat10}
                        ></AntGridCategories>
                    )}
                </div>
            )}

            {isRender && props.summaryHeader && (
                <AntGridSummary
                    shouldRender={isRender}
                    API={props.API}
                    dataSource={dataSource.current}
                    searchText={searchText.current}
                    searchConditions={finalSearchConditions}
                    widgets={props.summaryHeader.widgets}
                />
            )}

            {isRender && props.showActionBar != false && (
                <AntGridBar
                    ref={actionBar}
                    shouldRender={isRender}
                    dataSource={dataSource.current}
                    showRefresh={showRefresh}
                    showScheduler={AntCondition.isVisible({}, props.scheduler) && Boolean(props.scheduler)}
                    showCardView={
                        AntCondition.isVisible({}, props.cardview) && Boolean(props.cardview) && props.cardview?.allowViewSwitch !== false
                    }
                    isSchedulerMode={showScheduler.current}
                    isCardviewMode={showCardView.current}
                    parentData={props.parentData}
                    showEdit={showEdit}
                    showFilterBuilder={props.showFilterBuilder}
                    showDelete={showDelete}
                    showAdd={showAdd}
                    showFilterBySelected={(selectable || hasColMarkSelected) && props.showFilterBySelected !== false}
                    showFilterBySelectedOnlyWhenSelected={true}
                    dateFilterField={dateFilterField}
                    dateFilterValue={dateFilterRef.current}
                    onDateFilterChanged={onDateFilterChanged}
                    getColumnChooserItems={getColumnChooserItems}
                    onColumnVisibilityChange={onColumnVisibilityChange}
                    onColumnVisibilityReset={onColumnVisibilityReset}
                    onColumnOrderChange={onColumnOrderChange}
                    showColumnFilter={columnFilterEnabled}
                    columnFilterActive={filterRowVisible.current}
                    onToggleColumnFilter={onToggleFilterRow}
                    filterBySelected={filterBySelected.current}
                    showFilter={Boolean(props.search)}
                    onFilterClick={onFilterClick}
                    onShowScheduler={onShowScheduler}
                    onShowCardView={onShowCardView}
                    showSelectAll={!isRemotePaging && !isAllowNew && (selectable || hasColMarkSelected) && props.showSelectAll !== false}
                    // selectAll={selectedAll}
                    showImport={showImport}
                    showDownload={props.showDownload}
                    showSearchBar={props.showSearchBar}
                    searchBarWidth={props.searchBarWidth}
                    showScanBarcode={props.showScanBarcode}
                    scanBarcodeWidth={props.scanBarcodeWidth}
                    showFieldChooser={props.showFieldChooser}
                    locationRefresh={props.locationRefresh ? props.locationRefresh : 'before'}
                    locationEdit={props.locationEdit ? props.locationEdit : 'before'}
                    locationDelete={props.locationDelete ? props.locationDelete : 'before'}
                    locationAdd={props.locationAdd ? props.locationAdd : 'before'}
                    locationFilterBySelected={props.locationFilterBySelected ? props.locationFilterBySelected : 'after'}
                    locationImport={props.locationImport ? props.locationImport : 'before'}
                    locationDownload={props.locationDownload ? props.locationDownload : 'after'}
                    locationSearchBar={props.locationSearchBar ? props.locationSearchBar : 'after'}
                    locationScanBarcode={props.locationScanBarcode ? props.locationScanBarcode : 'before'}
                    searchText={searchText.current}
                    // autoFocusSearchBar={searchBarFocused ? false : props.autoFocusSearchBar}
                    autoFocusSearchBar={false}
                    autoFocusSearchBarcode={true}
                    onRefreshClick={reload}
                    onShowFieldChooser={showColumnChooser}
                    onSearchText={onSearchText}
                    onStartSearchText={onStartSearchText}
                    // onEndSearchText={onEndSearchText}
                    onScanBarcode={onScanBarcode}
                    onEndScanBarcode={onEndScanBarcode}
                    onAction={onAction}
                    onFilteredByGroup={onFilteredByGroup}
                    onDownloadClick={onActionDownload}
                    onAddClick={onActionAdd}
                    onEditClick={onActionEdit}
                    onDeleteClick={onActionDelete}
                    onBatchAction={onBatchAction}
                    onImportClick={onActionImport}
                    onFilterBySelected={onFilterBySelected}
                    onSelectAll={onSelectAll}
                    items={mainActions}
                    filteredGroup={filteredGroup ? filteredGroup.name : null}
                />
            )}
            {shouldRender && !props.hideHeaderMargin && props.showActionBar === false && <p />}

            {isRender && (
                <div ref={gridContainer} style={{ display: !showScheduler.current && !showCardView.current ? 'block' : 'none' }}>
                    <DataGrid
                        ref={grid}
                        shouldRender={isRender}
                        // noDataText="Không có dữ liệu"
                        noDataText=""
                        className={'dx-card wide-card ant-grid' + (smartGridLayout.financialMode ? ' ant-grid-financial' : '') + (inlineActive ? ' ant-grid-inline' : '')}
                        dataSource={dataSource.current ? dataSource.current.instance() : null}
                        remoteOperations={isRemotePaging}
                        focusedRowEnabled={
                            props.focusedRowEnabled !== undefined
                                ? props.focusedRowEnabled
                                : !inlineActive && props.cellStyles instanceof Array === false && props.rowStyles instanceof Array === false && selectable
                        }
                        onFocusedRowChanged={!selectable && focusable ? onFocusedRowChanged : undefined}
                        onSelectionChanged={selectable ? onSelectionChanged : undefined}
                        onOptionChanged={onOptionChanged}
                        onCellClick={onCellClick}
                        onRowDblClick={onRowDblClick}
                        // defaultFocusedRowIndex={0}
                        height={props.height !== undefined ? props.height : 'auto'}
                        width={props.width !== undefined ? props.width : '100%'}
                        showEditorAlways={true}
                        allowColumnResizing={allowColumnResizing}
                        columnAutoWidth={smartGridLayout.columnAutoWidth}
                        columnResizingMode={inlineActive ? 'widget' : 'nextColumn'}
                        columnHidingEnabled={smartGridLayout.columnHidingEnabled}
                        cellHintEnabled={true}
                        showColumnLines={false}
                        showRowLines={true}
                        showBorders={false}
                        // hoverStateEnabled={props.cellStyles instanceof Array === false && props.rowStyles instanceof Array === false}
                        // hoverStateEnabled={true}
                        hoverStateEnabled={props.hoverStateEnabled !== undefined ? props.hoverStateEnabled : true}
                        rowAlternationEnabled={props.rowAlternationEnabled !== undefined ? props.rowAlternationEnabled : true}
                        repaintChangesOnly={true}
                        // focusStateEnabled={
                        //     props.cellStyles instanceof Array === false &&
                        //     props.rowStyles instanceof Array === false &&
                        //     props.focusStateEnabled !== undefined
                        //         ? props.focusStateEnabled
                        //         : false
                        // }

                        focusStateEnabled={true}
                        keyboardNavigation={
                            props.keyboardNavigation !== undefined
                                ? props.keyboardNavigation
                                : {
                                      enterKeyAction: 'moveFocus',
                                      enterKeyDirection: 'row',
                                      enabled: true,
                                      editOnKeyPress: true
                                  }
                        }
                        // onFocusedCellChanging={(e) => {
                        //     if (e.preRowIndex == 0) {
                        //         e.isHighlighted = false;
                        //     }
                        // }}
                        // onKeyDown={onKeyDown}
                        loadPanel={{ enabled: false }}
                        scrolling={{
                            ...props.scrolling,
                            showScrollbar: smartGridLayout.showScrollbar
                        }}
                        selection={
                            selectable
                                ? {
                                  mode: props.selectionMode ? props.selectionMode : 'multiple',
                                      selectAllMode: gridBatchActions.length > 0 && isRemotePaging ? 'page' : 'allPages',
                                      showCheckBoxesMode: 'always'
                                  }
                                : focusable
                                ? {
                                      mode: 'single'
                                  }
                                : { mode: 'none' }
                        }
                        columnChooser={{
                            emptyPanelText: '',
                            enabled: false,
                            mode: 'select',
                            title: AntLocalization.translateText({
                                vi: 'Ẩn hiện cột',
                                en: 'Column Chooser',
                                fr: 'Colonnes',
                                es: 'Columnas',
                                id: 'Pemilih Kolom',
                                ja: '列セレクタ',
                                zh: '列选择器',
                                ko: '열 선택기',
                                hi: 'कॉलम चुनें',
                                ar: 'محدد الأعمدة'
                            })
                        }}
                        pager={{
                            showInfo: true,
                            infoText: `{2} ${AntLocalization.translateText({
                                vi: 'dòng',
                                en: 'records',
                                fr: 'lignes',
                                es: 'registros',
                                id: 'catatan',
                                ja: 'レコード',
                                zh: '条记录',
                                ko: '개 레코드',
                                hi: 'रिकॉर्ड',
                                ar: 'سجلات'
                            })}`,
                            showNavigationButtons: true,
                            showPageSizeSelector: props.showPageSizeSelector !== undefined ? props.showPageSizeSelector : true,
                            allowedPageSizes: props.allowedPageSizes,
                            visible: props.pagerHideable ? 'auto' : true
                        }}
                        sorting={{
                            mode: props.sortable !== false ? 'single' : 'none',
                            clearText: AntLocalization.translateText({
                                vi: 'Bỏ sắp xếp',
                                en: 'Remove sorting',
                                fr: 'Supprimer le tri',
                                es: 'Eliminar orden',
                                id: 'Hapus pengurutan',
                                ja: '並べ替えを解除',
                                zh: '取消排序',
                                ko: '정렬 해제',
                                hi: 'क्रमबद्धता हटाएं',
                                ar: 'إزالة الترتيب'
                            }),
                            ascendingText: 'A->Z',
                            descendingText: 'Z->A'
                        }}
                        editing={
                            props.allowEdit === true || inlineActive
                                ? {
                                      mode: 'cell',
                                      allowUpdating: true,
                                      selectTextOnEditStart: true
                                  }
                                : {}
                        }
                        onEditingStart={inlineActive ? onInlineEditingStart : undefined}
                        wordWrapEnabled={props.wordWrapEnabled !== undefined ? props.wordWrapEnabled : false}
                        onEditorPreparing={columnFilterEnabled ? onGridEditorPreparing : undefined}
                        // onEditorPreparing={(e) => {
                        //     if (e.parentType == 'dataRow') {
                        //         e.editorOptions.onFocusIn = function (args) {
                        //             let inputEl = args.element.querySelector('.dx-texteditor-input');
                        //             if (inputEl) {
                        //                 inputEl.selectionStart = 0;
                        //                 inputEl.selectionEnd = inputEl.value.length;
                        //             }
                        //         };
                        //         e.editorOptions.valueChangeEvent = 'focusout';
                        //     }
                        // }}
                        columns={mainColumns}
                        onInitialized={onInitialized}
                        onContentReady={onGridContentReady}
                        onCellPrepared={props.cellStyles instanceof Array || inlineActive ? onCellPrepared : undefined}
                        onRowPrepared={props.rowStyles instanceof Array || props.flashConds instanceof Array || inlineActive ? onRowPreparedWithInline : undefined}
                    >
                        <Paging defaultPageSize={defaultPageSize} defaultPageIndex={0} />
                        <Template name={'renderSmartTextCell'} render={renderSmartTextCell} />
                        <Template name={'renderBoldCell'} render={renderBoldCell} />
                        <Template name={'renderCustomTemplate'} render={renderCustomTemplate} />
                        <Template name={'renderCustomFormatCell'} render={renderCustomFormatCell} />
                        <Template name={'renderContentCell'} render={renderContentCell} />
                        <Template name={'renderLinkCell'} render={renderLinkCell} />
                        <Template name={'renderButtonsCell'} render={renderButtonsCell} />
                        <Template name={'renderCheckboxCell'} render={renderCheckboxCell} />
                        <Template name={'renderNoteCell'} render={renderNoteCell} />
                        <Template name={'renderAttachmentCell'} render={renderAttachmentCell} />
                        <Template name={'renderPriorityCell'} render={renderPriorityCell} />
                        <Template name={'renderDetailCell'} render={renderDetailCell} />
                        <Template name={'renderInlineEditCell'} render={renderInlineEditCell} />
                        <Template name={'renderInlineStatusCell'} render={renderInlineStatusCell} />
                        {/* <Template name={'renderCellEditor'} render={renderCellEditor} /> */}
                    </DataGrid>
                </div>
            )}

            {isRender && props.scheduler && (
                <div style={{ display: showScheduler.current && !showCardView.current ? 'block' : 'none', width: '100%', height: '75vh' }}>
                    <AntScheduler
                        ref={scheduler}
                        API={props.API}
                        {...props.scheduler}
                        visible={true}
                        shouldRender={isRender}
                        dataSource={schedulerDataSource.current ? schedulerDataSource.current.instance() : null}
                        defaultCurrentView={schedulerCurrentView.current}
                        defaultCurrentDate={schedulerCurrentDate.current}
                        onAppointmentClick={(data) => {
                            onRowDblClick({ data: data });
                        }}
                        onViewChanged={(view) => {
                            schedulerCurrentView.current = view;
                            saveCachingStates();
                        }}
                        onDateChanged={(view) => {
                            schedulerCurrentDate.current = view;
                            saveCachingStates();
                        }}
                    ></AntScheduler>
                </div>
            )}

            {isRender && props.cardview && props.cardview.type !== 'ListView' && (
                <div style={{ display: !showScheduler.current && showCardView.current ? 'block' : 'none', width: '100%', height: '75vh' }}>
                    <AntCardViewTile
                        ref={cardview}
                        API={props.API}
                        shouldRender={isRender}
                        cardStyles={props.cardview.cardStyles ? props.cardview.cardStyles : props.cellStyles ? props.cellStyles : props.rowStyles}
                        cellActions={props.cellActions ? props.cellActions : gridRowActions}
                        {...props.cardview}
                        dataSource={cardViewDataSource.current.instance()}
                        onItemClick={onItemClick}
                        onAction={onRowAction}
                        showDetail={props.showDetail}
                    ></AntCardViewTile>
                </div>
            )}

            {isRender && props.cardview && props.cardview.type === 'ListView' && (
                <div
                    style={{
                        display: !showScheduler.current && showCardView.current ? 'block' : 'none',
                        width: '100%',
                        height: props.cardview?.usePageScroll ? 'auto' : '75vh'
                    }}
                >
                    <AntPOSCardViewList
                        ref={cardview}
                        API={props.API}
                        shouldRender={isRender}
                        cardStyles={props.cardview.cardStyles ? props.cardview.cardStyles : props.cellStyles ? props.cellStyles : props.rowStyles}
                        cardClasses={
                            props.cardview.cardClasses ? props.cardview.cardClasses : props.cellCalsses ? props.cellCalsses : props.rowCalsses
                        }
                        cellActions={props.cellActions ? props.cellActions : gridRowActions}
                        {...props.cardview}
                        dataSource={cardViewDataSource.current.instance()}
                        rawDataSource={cardViewDataSource.current}
                        searchConditions={{
                            ...props.cardview?.searchConditions
                        }}
                        onItemClick={onItemClick}
                        autoShowActions={props.cardview?.autoShowActions}
                        showActions={props.cardview?.showActions}
                        useQuickAction={props.cardview?.useQuickAction}
                        onAction={onRowAction}
                        showDetail={props.showDetail}
                    ></AntPOSCardViewList>
                </div>
            )}

            {isRender && showDelete && (
                <AntDeletePopup
                    ref={deletePopup}
                    shouldRender={isRender}
                    API={props.API}
                    table={props.delete && props.delete.table ? props.delete.table : props.table}
                    entityName={props.API.entityName ? props.API.entityName : props.entityName}
                    entityDisplay={props.API.entityDisplay ? props.API.entityDisplay : props.entityDisplay}
                    onDeleted={() => {
                        if (props.onDeleted) props.onDeleted();
                        reload();
                    }}
                    fields={props.fields}
                    columns={
                        props.delete && props.delete.columns !== undefined ? props.delete.columns : mainColumns.filter((c) => Boolean(c.visible))
                    }
                />
            )}

            {isRender && gridBatchActions.length > 0 && (
                <AntBatchActionPopup
                    ref={batchActionPopup}
                    API={props.API}
                    keyExpr={props.keyExpr || 'id'}
                    columns={mainColumns}
                    confirmationColumns={props.batchConfirmationColumns}
                    onExecuted={onBatchExecuted}
                />
            )}

            {isRender && showEdit && props.edit && props.edit.items instanceof Array && (
                <AntObjectEditPopup
                    ref={editPopup}
                    shouldRender={isRender}
                    API={props.API}
                    parentTable={props.parentTable}
                    parentData={props.parentData}
                    parentFK={props.parentFK}
                    copyFromParentFields={[
                        ...(props.copyFromHeaderFields ? props.copyFromHeaderFields : []),
                        ...(props.copyFromParentFields ? props.copyFromParentFields : []),
                        ...(props.edit && props.edit.copyFromHeaderFields ? props.edit.copyFromHeaderFields : []),
                        ...(props.edit && props.edit.copyFromParentFields ? props.edit.copyFromParentFields : []),
                        {
                            field: props.parentIDField ? props.parentIDField : 'code',
                            alias: props.FKField
                        }
                    ]}
                    table={props.edit && props.edit.table ? props.edit.table : props.table}
                    title={props.edit ? props.edit.title : undefined}
                    width={props.edit ? props.edit.width : undefined}
                    height={props.edit ? props.edit.height : undefined}
                    minHeight={props.edit ? props.edit.minHeight : undefined}
                    maxHeight={props.edit ? props.edit.maxHeight : undefined}
                    entityName={props.API.entityName ? props.API.entityName : props.entityName}
                    entityDisplay={props.API.entityDisplay ? props.API.entityDisplay : props.entityDisplay}
                    colCount={props.edit ? props.edit.colCount : 1}
                    alignItemLabelsInAllGroups={props.edit ? props.edit.alignItemLabelsInAllGroups : undefined}
                    labelLocation={props.edit ? props.edit.labelLocation : undefined}
                    onFieldDataChanged={props.edit ? props.edit.onFieldDataChanged : undefined}
                    onSaving={props.onEditing ? props.onEditing : props.edit && props.edit.onEditing ? props.edit.onEditing : undefined}
                    onSaved={onObjectEdited}
                    onError={props.edit ? props.edit.onError : undefined}
                    prepareConditions={props.edit && props.edit.prepareConditions ? props.edit.prepareConditions : props.prepareConditions}
                    fields={props.fields}
                    items={props.edit ? props.edit.items : []}
                    postFields={props.edit && props.edit.postFields instanceof Array ? props.edit.postFields : undefined}
                />
            )}

            {isRender && showAdd && props.add && props.add.items instanceof Array && (
                <AntObjectCreationPopup
                    ref={addPopup}
                    shouldRender={isRender}
                    API={props.API}
                    parentTable={props.parentTable}
                    parentData={props.parentData}
                    parentFK={props.parentFK}
                    copyFromParentFields={[
                        ...(props.copyFromHeaderFields ? props.copyFromHeaderFields : []),
                        ...(props.copyFromParentFields ? props.copyFromParentFields : []),
                        ...(props.add && props.add.copyFromHeaderFields ? props.add.copyFromHeaderFields : []),
                        ...(props.add && props.add.copyFromParentFields ? props.add.copyFromParentFields : []),
                        {
                            field: props.parentIDField ? props.parentIDField : 'code',
                            alias: props.FKField
                        }
                    ]}
                    default={props.add && props.add.defaultObj ? props.add.defaultObj : undefined}
                    table={props.add && props.add.table ? props.add.table : props.table}
                    title={props.add ? props.add.title : undefined}
                    width={props.add ? props.add.width : undefined}
                    height={props.add ? props.add.height : undefined}
                    minHeight={props.add ? props.add.minHeight : undefined}
                    maxHeight={props.add ? props.add.maxHeight : undefined}
                    entityName={props.API.entityName ? props.API.entityName : props.entityName}
                    entityDisplay={props.API.entityDisplay ? props.API.entityDisplay : props.entityDisplay}
                    alignItemLabelsInAllGroups={props.add ? props.add.alignItemLabelsInAllGroups : undefined}
                    labelLocation={props.add ? props.add.labelLocation : undefined}
                    colCount={props.add ? props.add.colCount : 1}
                    onFieldDataChanged={props.add ? props.add.onFieldDataChanged : undefined}
                    onSaving={props.onAdding ? props.onAdding : props.add && props.add.onAdding ? props.add.onAdding : undefined}
                    onSaved={onObjectCreated}
                    onError={props.add ? props.add.onError : undefined}
                    prepareConditions={props.add && props.add.prepareConditions ? props.add.prepareConditions : props.prepareConditions}
                    fields={props.fields}
                    items={props.add ? props.add.items : []}
                    postFields={props.add && props.add.postFields instanceof Array ? props.add.postFields : undefined}
                />
            )}

            {isRender && showImport && props.import && props.import.mapping instanceof Array && (
                <AntImport
                    ref={importPopup}
                    shouldRender={isRender}
                    API={props.API}
                    parentTable={props.parentTable}
                    parentData={props.parentData}
                    parentFK={props.parentFK}
                    copyFromParentFields={[
                        ...(props.copyFromHeaderFields ? props.copyFromHeaderFields : []),
                        ...(props.copyFromParentFields ? props.copyFromParentFields : []),
                        ...(props.import && props.import.copyFromHeaderFields ? props.import.copyFromHeaderFields : []),
                        ...(props.import && props.import.copyFromParentFields ? props.import.copyFromParentFields : []),
                        {
                            field: props.parentIDField ? props.parentIDField : 'code',
                            alias: props.FKField
                        }
                    ]}
                    default={props.import && props.import.defaultObj ? props.import.defaultObj : undefined}
                    table={props.import && props.import.table ? props.import.table : props.table}
                    entityName={props.API.entityName ? props.API.entityName : props.entityName}
                    entityDisplay={props.API.entityDisplay ? props.API.entityDisplay : props.entityDisplay}
                    previewWidth={props.import && props.import.previewWidth !== undefined ? props.import.previewWidth : undefined}
                    heights={props.import && props.import.heights !== undefined ? props.import.heights : undefined}
                    createable={
                        props.canImportCreate !== false && (props.import && props.import.createable !== undefined ? props.import.createable : true)
                    }
                    updateable={
                        props.canImportUpdate !== false && (props.import && props.import.updateable !== undefined ? props.import.updateable : true)
                    }
                    fields={props.fields}
                    defaultPageSize={props.import && props.import.defaultPageSize !== undefined ? props.import.defaultPageSize : undefined}
                    mapping={props.import ? props.import.mapping : []}
                    aiEnabled={props.import && props.import.useAI === true}
                    aiJobType={props.import && props.import.aiJobType}
                    aiTargetTable={props.import && props.import.aiTargetTable}
                    aiVariant={props.import && props.import.aiVariant}
                    aiEntity={props.import && props.import.aiEntity}
                    aiExtraInputData={props.import && props.import.aiExtraInputData}
                    onImported={() => {
                        if (props.import && props.import.onImported) props.import.onImported();
                        if (props.onImported) props.onImported();
                        reload();
                    }}
                    onImporting={
                        props.onImporting ? props.onImporting : props.import && props.import.onImporting ? props.import.onImporting : undefined
                    }
                />
            )}
        </React.Fragment>
    );
});
